import AudioReactRecorder, { RecordState } from "audio-react-recorder";
import $ from "jquery";
import _ from "lodash";
import moment from "moment";
import "moment/locale/de";
import "moment/locale/en-gb";
import "moment/locale/fr";
import "moment/locale/it";
import React, {
  memo,
  useCallback,
  useContext,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,

} from "react";
import VoiceMessageWithTranscript from "../../components/VoiceMessageWithTranscript";
import LazyMedia from "../../components/LazyMedia";
import ChatVideoBubble from "../../components/chatMedia/ChatVideoBubble";
import { compressChatVideo, patchTempVideoMessage } from "../../utils/chatVideo";
import { FaVideo } from "react-icons/fa";

import { Form, Modal } from "react-bootstrap";
import { unstable_batchedUpdates, createPortal } from "react-dom";

import { connect, useDispatch, useSelector } from "react-redux";
import { Link, withRouter, useLocation, useHistory } from "react-router-dom";
import { callAPI, callAPI2 } from "../../helper/apiUtils";
import { getBadgeCount, invalidateBadgeCount, applyOptimisticChatRead } from "../../helper/badgeCount";
import {
  getCachedChat,
  isChatCacheFresh,
  isChatFetchInFlight,
  messagesFingerprint,
  fetchChatPage,
  rememberChatSecret,
  appendCachedMessage,
  invalidateCachedChat,
  cacheHasMessage,
  listPreviewMessageId,
} from "../../helper/chatMessageCache";
import {
  API_ROOT,
  BASE_URL,
  KJUUP_COLORS,
  escapeHtml,
  makeid,
  buildImageUrl,
  getFileUrl,
  getSenderColor,
} from "../../helper/constants";
import { $crud } from "../../helper/CrudFactory";
import { $user } from "../../helper/UserFactory";
import MaterialIcon from "../../components/MaterialIcon";
import { ReactComponent as GoogleMap } from "../../Icons/GoogleMap.svg";
import LocationMapPreview from "../../components/LocationMapPreview";
import {
  ALL_BADGE_COUNT,
  DRAFT_MESSAGES,
  FORWARD_GROUP_MESSAGES,
  GROUPS,
  GROUP_CHATS,
  JOIN_ROOM_BUTTON_STATUS_ROOM_WISE,
  OPEN_CHATS,
  OPEN_PROJECTS,
  PROJECTS,
  RIGHT_TOP,
  CLEAR_REACTION_MESSAGES,
  SET_DEEPLINK_DATA,
  SET_DEEPLINK_LOADING,
  SET_CHAT_FULLSCREEN,
  SET_NEW_MESSAGE_DATA,
  SET_OPEN_SIDE_BAR,
  SET_RUNNING_CALLS,
  SET_VIEWER_IINITAL_INDEX,
  SET_VIEWER_IMAGES,
  SET_VIEWER_IS_INTERNAL,
  SHOW_LIST_ONGOING,
  TOGGLE_GROUP_CHAT,
  TOGGLE_LATEST_MSG,
  TOGGLE_CHAT,
  TOGGLE_TODO_VIEW,
  REFRESH_TODO_LIST,
  UPDATE_GROUP_MESSAGE,
  SET_CACHED_MESSAGES,
  UPDATE_CACHED_MESSAGE,
  CLEAR_CACHED_MESSAGES,
  RESET_LATEST_MESSAGES,
  SET_ACTIVITY_MESSAGES,
  SET_ACTIVITY_MESSAGES_REMINDERS,
  SET_ACTIVITY_MESSAGES_LAST_FETCHED,
  store,
} from "../../store";
import FloatingAction from "./Dialogs/FloatingAction";
import ShareContact from "./ShareContact";
import "../../styles/pages.css";
import ReplyPreview from "../../components/ReplyPreview";
import MessageContextMenu from "../../components/MessageContextMenu";
import ChatHeaderPro from "../../components/chat/ChatHeaderPro";
import { teamsBridgeLabel } from "../../utils/teams/combinedChat";
import MessageMenuPro from "../../components/chat/MessageMenuPro";
import BookmarkProjectSheet from "../../components/chat/BookmarkProjectSheet";
import ComposerEmojiPicker from "../../components/chat/ComposerEmojiPicker";
import MessageMeta from "../../components/chat/MessageMeta";
import TranslationLine from "../../components/chat/TranslationLine";
import MessageInfoSheet from "../../components/chat/MessageInfoSheet";
import ChatAvatar from "../../components/chat/ChatAvatar";
import { ComposerContextBar, RecordingBar, replyPreviewLine } from "../../components/chat/ComposerBars";
import { DayChip, UnreadBand, SystemNote, TypingRow, ScrollToLatestButton, SelectCheck } from "../../components/chat/ChatThreadParts";
import "../../components/chat/chat-pro.css";
import { buildChatActionRows } from "../../utils/chatActionRows";
import TeamsChatInfo from "../../components/chat/TeamsChatInfo";
import "../../components/chat/TeamsChat.css";
import { retryTeamsDelivery, createTeamsCallLink, getTeamsAuthUrl } from "../../helper/teamsApi";
import {
  TEAMS_FILE_ERROR_EVENT,
  TEAMS_SETTINGS_PATH,
  applyTeamsDelivery,
  applyTeamsFileUrls,
  buildTeamsActionRows,
  canReactToRow,
  isNonRetryableResponse,
  isSignedFileUrl,
  openInTeams,
  reportTeamsFileError,
  teamsChatFrom,
  teamsDeliveryOf,
  teamsEditedFields,
  teamsFilePagesToTry,
  teamsHeaderName,
  teamsHides,
  teamsMembersLine,
  teamsMentionSuggestions,
  teamsPageOfFile,
  teamsReadOnlyReason,
  teamsReadOnlyText,
  teamsRowCaps,
  teamsSelectionDeletable,
  teamsSenderName,
} from "../../utils/teams/teamsChat";
import { TEAMS_PROJECT_EVENT } from "../../utils/teams/teamsChats";
import { teamsCallOf, teamsCallMessage } from "../../utils/teams/teamsCall";
import { teamsReturnFromMessage, handleTeamsReturn } from "../../utils/teams/teamsConnect";
import TeamsCallMessage from "../../components/chat/TeamsCallMessage";
import { useChatSearchIndex, parseSearchQuery } from "../../components/chat/chatSearchIndex";
import saveMessageMedia from "../../components/chat/saveMessageMedia";
import {
  flattenSections,
  isSystemRow,
  isSelectableRow,
  isRowSelected,
  toggleRowSelection,
  selectionIdsOf,
  selectedMessages,
  allSelectedDeletable,
  deleteIdsOf,
  selectionCopy,
} from "../../utils/chatSelection";
import { createTypingSender, subscribeTyping } from "../../utils/chatTyping";
import { createReceiptTracker, onSocketBack, subscribeReceipts } from "../../utils/chatReceipts";
import { playSendSound, preloadSendSound } from "../../utils/sendSound";
import ForwardedBadge from "../../components/ForwardedBadge";
import ForwardChatPicker from "../../components/ForwardChatPicker";
import TaskNoticeMessage from "../../components/chat/TaskNoticeMessage";
import { openProjectTask } from "../Cockpit/cockpitNavigation";
import EmojiReactionsDisplay from "../../components/EmojiReactionsDisplay";
import UserInfo from "./UserInfo";
import Dropzone from "../../components/Dropzone";
import { sumTotalChatHistory, SOCKET_BASE } from "../../helper/SocketObj";
import { EN } from "../../Languages/EN";
import LanguageContext from "../../helper/LanguageContext";
import { DE } from "../../Languages/DE";
import { isChatBookmarked, canCopyChatMessage, canBookmarkChatMessage, toggleChatBookmarkTodo } from "../../helper/bookmarkTodo";
import { SocketContext } from "../../context/socket";
import { PaneActiveContext } from "../../context/paneActive";
import PlayerFeed from "../../components/PlayerFeed";
import ImagesWithVideos from "../../components/ImagesWithVideos";
import { getUsernameFromText } from "../Project/GroupChat/getUsername";
import { MentionsInput, Mention } from "react-mentions";
import DownloadFileWithIcon from "../../components/DownloadFileWithIcon";
import DocumentGalleryView from "../../components/DocumentGalleryView";
import {
  decryptMessage,
  emojiDecode,
  emojiUnicode,
  encryptMessage,
} from "../../utils/encryptDecryptFunction";
import PreloadedEmojiPicker from "../../components/PreloadedEmojiPicker";
import EmojiReaction from "../Project/EmojiReaction";
import { copyBlobToClipboard } from 'copy-image-clipboard';
import RCJitsiCall from "../../components/JitsiCallComp";
import AcceptCallButton from "../../components/AcceptCallButton";
import { marked } from 'marked';
import ChatMessageMarkdown from "../../components/chat/ChatMessageMarkdown";
import { containsMarkdown, cleanMarkdownWhitespace } from "../../utils/markdownDetect";
import {
  SCROLL_THRESHOLD,
  pinChatToBottom,
  scrollMessageIntoChat,
  isNearBottom,
  isMessageEmojiOnly,
  mergeIncomingMessage,
  buildRenderableSections,
  cleanTranscript,
  stripMarkdown,
  idsMatch,
  isSameChatMessage,
  getLastVisibleMessagePreview,
  applyVisiblePreviewToChat,
} from "../../utils/conversationUtils";
import {
  registerOutgoingMessages,
  injectPendingOutgoing,
  upsertChatHistory,
  applyPendingOutgoingToHistory,
  findChatHistoryIndex,
  hasPendingOutgoing,
} from "../../utils/pendingOutgoingMedia";
import { resolveGalleryImage } from "../../utils/chatImageDisplay";
import { ImageWithLoading, GalleryImage } from "../../components/chat/ChatImageComponents";
import {
  resizeTextarea,
  getLocaleForLanguage,
  syncComposerEmptiness,
  readLiveComposerText,
  pasteAsPlainText,
  collectPastedImageFiles,
  handleComposerDrop,
  getDroppedFiles,
  handleComposerEnterKey,
} from "../../utils/composerUtils";
import { useComposerHistory } from "../../hooks/useComposerHistory";
import { useRichEditor } from "../../hooks/useRichEditor";
import { applyComposerFormat as sharedApplyComposerFormat } from "../../utils/applyComposerFormat";
import {
  persistDraftMessage,
  clearStoredDraft,
  readComposerDraftText,
  applyDraftToComposer,
  flushComposerMessage,
} from "../../utils/draftMessages";
import { openCallTab, markCallActive, unmarkCallActive } from "../../utils/callTab";
import {
  getTranslateText,
  translateMessageContent,
  translateMessagesBatch,
  clearTranslationCache,
  preserveOriginalFormatting,
  isUntranslatableText,
} from "../../utils/translationUtils";
import { shouldAutoTranslateFromSender, detectLanguageClient } from "../../utils/autoTranslationLanguages";
import { buildDocViewerItems, shouldOpenInlineDocViewer } from "../../utils/documentAlbum";
import { lastOnlineText } from "../../utils/lastOnline";

const extractUrls = require("extract-urls");
// How long reply suggestions wait for an incoming image's AI description before fetching anyway.
const IMAGE_DESCRIPTION_WAIT_MS = 8000;

const DocViewer = React.lazy(() => import("./DocViewer"));
const ChatShareMap = React.lazy(() => import("./ChatMap/ChatShareMap"));
const MediaLinksDocs = React.lazy(() => import("../Project/MediaLinksDocs"));
const EmojiPickerDialog = React.lazy(() => import("../Project/Dialogs/EmojiPickerDialog"));
const TranslateDialog = React.lazy(() => import("../../components/TranslateDialog"));
const FullScreenImageViewer = React.lazy(() => import("../../components/FullScreenImageViewer"));

function Conversation(props) {
  /* eslint-disable react-hooks/rules-of-hooks */
  // Every hook here is called unconditionally at the top level. eslint-plugin-react-hooks@4.2.0
  // reports false "called conditionally" errors for a component this size (same as GroupConversation).
  const deeplinkData = useSelector(state => state.deeplinkData);
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  
  // Check if we're in fullscreen mode (opened from profile or deeplink)
  const urlParams = new URLSearchParams(location.search);
  const chatFullscreen = useSelector(state => state.chatFullscreen);
  const isFullscreenMode = urlParams.get('fullscreen') === 'true' || chatFullscreen;
  const user = $user.get();
  const {
    unSeenAllCount,
    projects,
    activityMessages,
    activityMessagesReminders,
    isAutoTranslation,
    autoTranslationLanguages,
    groups,
    translateRoomAndGroupNames,
    bookmarkedChatIds,
  } = useSelector((state) => state);
  const [page, setPage] = useState(deeplinkData?.page_no || 1);
  const [topPage, setTopPage] = useState(deeplinkData?.page_no || 1);
  const [bottomPage, setBottomPage] = useState(deeplinkData?.page_no || 1);
  const [currentPage, setCurrentPage] = useState(deeplinkData?.page_no || 1); // Track the current page we're on
  const [loadedPages, setLoadedPages] = useState(new Set([])); // Track loaded pages
  const [hasMoreTop, setHasMoreTop] = useState(true);
  const [hasMoreBottom, setHasMoreBottom] = useState(deeplinkData?.page_no > 1); // Initially false since page 1 is newest messages
  const [isLoadingBottom, setIsLoadingBottom] = useState(false);
  const [isLoadingTop, setIsLoadingTop] = useState(false);
  // Pagination refs — use refs instead of state so loading pages never causes re-renders
  const paginationRef = useRef({
    isLoadingTop: false,
    isApiCallInProgress: false,
    loadingDirection: null,
  });
  const scrollPreservationRef = useRef({ isPreserving: false, oldScrollTop: 0, oldScrollHeight: 0, chatId: null });
  const scrollRafRef = useRef(null); // for rAF-throttled scroll handler
  // Track when we've scrolled to a specific message - prevents auto-scroll from interfering
  const scrolledToMessageRef = useRef(false);
  // Message ids that got a quick-reaction while away; highlight on open.
  const newReactionMessageIds = useSelector((state) => state.newReactionMessageIds);
  const newReactionIdsRef = useRef(newReactionMessageIds);
  useEffect(() => {
    newReactionIdsRef.current = newReactionMessageIds;
  }, [newReactionMessageIds]);
  const forceReplaceMessagesRef = useRef(false);
  const initialScrollPhaseRef = useRef(false);
  // Track emoji updates to prevent auto-scroll during emoji selection
  const emojiUpdateRef = useRef({ isUpdating: false, scrollTop: 0 });
  let [tempChatHistory, setTempChatHistory] = useState([]);
  const tempChatHistoryRef = useRef([]);
  // Keep ref in sync with state for use in async callbacks/handlers
  useEffect(() => {
    tempChatHistoryRef.current = tempChatHistory;
  }, [tempChatHistory]);


  let [tempChatHistoryTEMP, setTempChatHistoryTEMP] = useState([]);
  const [secretKey, setSecretKey] = useState(null);
  const [isSecretKey, setIsSecretKey] = useState(null);
  const secretKeyRef = useRef(null);
  const autoTransLangsRef = useRef(autoTranslationLanguages);
  autoTransLangsRef.current = autoTranslationLanguages;
  const [NewMess, setNewMess] = useState(false);
  const [viewLoader, setViewLoader] = useState(false);
  const [videoUploadProgress, setVideoUploadProgress] = useState(null);
  const [videoCompressing, setVideoCompressing] = useState(false);
  const [pendingVideoId, setPendingVideoId] = useState(null);
  const [chatDetails, setChatDetails] = useState({});
  const [isChatDetailsLoaded, setIsChatDetailsLoaded] = useState(false);
  const [isEmailAllowed, setIsEmailAllowed] = useState({});
  const [unavailableMembers, setUnavailableMembers] = useState([]);
  const [showUnavailBanner, setShowUnavailBanner] = useState(false);
  // Members who switched the Kjuup chats off - they stay in the chat but can
  // no longer be reached here, so the notice stays visible.
  const [chatsHiddenMembers, setChatsHiddenMembers] = useState([]);
  const unavailBannerTimerRef = useRef(null);
  const [showChatLoadingPopup, setShowChatLoadingPopup] = useState(false);
  // Track the deferred show-timer so we can cancel it when the API responds
  // before the loader was even meant to appear (cache hits, warm backend).
  // shownAt records when the loader actually became visible so we can keep
  // it on screen for at least MIN_VISIBLE_MS to avoid a perceptible flash.
  const chatLoadingPopupShowTimerRef = useRef(null);
  const chatLoadingPopupShownAtRef = useRef(0);
  const [chatDetailsx, setChatDetailsX] = useState({});
  const [mediaDoc, setMediaDoc] = useState(false);
  const [floatingAction, setFloatingAction] = useState(false);
  const [viewInfo, setViewInfo] = useState(false);
  const [message, setMessage] = useState("");
  const messageRef = useRef("");
  useEffect(() => {
    messageRef.current = message;
  }, [message]);
  const [typingUser, setTypingUser] = useState({});
  const [chatHistory, setChatHistory] = useState([]);
  const [viewDoc, setViewDoc] = useState(false);
  const [doc, setDoc] = useState("");
  const [show, setShow] = useState(false);
  const [searchView, setSearchView] = useState(false);
  const [search, setSearch] = useState("");
  // What the in-chat search field shows; `search` (the active query) only takes it on Enter.
  const [searchDraft, setSearchDraft] = useState("");
  const [showContactSection, setShowContactSection] = useState(false);
  const [showTodoCreatingLoader, setShowTodoCreatingLoader] = useState(false);
  const [todoCreatingStep, setTodoCreatingStep] = useState(1);
  const [showMessageInfo, setMessageInfo] = useState(false);
  const [chatMessage, setChatMessage] = useState("");
  const [originalMessages, setOriginalMessages] = useState([]);
  const [totalHighlights, setTotalHighlights] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [highlightIds, setHighlightsIds] = useState([]);
  const [forward, setForward] = useState(false);
  const [showForwardPicker, setShowForwardPicker] = useState(false);
  const [forwardPickerVisible, setForwardPickerVisible] = useState(true);
  // The message waiting for its project before it becomes a task (chat without a project).
  const [taskProjectFor, setTaskProjectFor] = useState(null);
  const [msgIds, setMsgIds] = useState([]);
  const msgIdsRef = useRef([]);
  const forwardAlbumsRef = useRef([]);
  const ignoreChatClicksUntil = useRef(0);
  const [showImage, setShowImage] = useState(false);
  const [image, setImage] = useState("");
  const [delMessage, setDelMessage] = useState(false);
  const [editSaving, setEditSaving] = useState(false);
  const [activeReply, setActiveReply] = useState(false);
  const [showTranslateDialog, setTranslateDialog] = useState(false);
  const [triggerTranslate, setTriggerTranslate] = useState(false);
  const [audioRecording, setAudioRecording] = useState(false);
  const [users, setUsers] = useState(props.users || []);
  // Removed isAdmin, buildingMembers - not needed for one-on-one chats
  const [leaved, setLeaved] = useState(false);
  const [openEmojiPicker, setEmojiPicker] = useState(false);
  const [isInputEmojiOpen, setIsInputEmojiOpen] = useState(false);
  const [isInputEmojiClosing, setIsInputEmojiClosing] = useState(false);
  const [dropfiles, setDropFiles] = useState([]);
  const dropGuardRef = useRef({ at: 0, count: 0 });
  const [allUsers, setAllUsers] = useState([]);
  const [textareaHeight, setTextareaHeight] = useState(false);
  const [expandedMessages, setExpandedMessages] = useState({});
  const [isGettingChats, setIsGettingChats] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isContentReady, setIsContentReady] = useState(false);
  const [showSkeleton, setShowSkeleton] = useState(true);
  const [loadedFromCache, setLoadedFromCache] = useState(false);
  const [isComposerToolbarOpen, setIsComposerToolbarOpen] = useState(true);
  const [activeFormats, setActiveFormats] = useState({});
  const [mentionInput, setMentionInput] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [mentionSuggestions, setMentionSuggestions] = useState([]);
  const [emojiModal, setEmojiModal] = useState({});
  const [emojiMessage, setEmojiMessage] = useState(null);
  const [activeEmojiChatId, setActiveEmojiChatId] = useState(null);
  const [emojiTriggerElement, setEmojiTriggerElement] = useState(null);
  const [isCopied, setIsCopied] = useState(false);
  const [viewEmojiModal, setViewEmojiModal] = useState(false);
  const [IsRcCallOn, setIsRcCallIsOn] = useState(false);
  const [isKeySetted, setIsKeySetted] = useState(false);
  const [emojiReactionUser, setEmojiReactionUser] = useState([]);
  // --- Mobile Pro chat (components/chat/*) ---
  // Message menu (right-click on a bubble / "more" of its hover bar): { chat, anchor }.
  const [messageMenu, setMessageMenu] = useState(null);
  // Edit in the composer with the edit bar on top (mobile), not inside the bubble.
  const [editingChat, setEditingChat] = useState(null);
  const editingChatRef = useRef(null);
  editingChatRef.current = editingChat;
  const preEditDraftRef = useRef(null);
  // In-chat search: position in the hits (0 = newest) and the row that flashes.
  const [searchPos, setSearchPos] = useState(0);
  const [flashMessageId, setFlashMessageId] = useState(null);
  const flashTimerRef = useRef(null);
  // Scroll-to-latest button and the messages that arrived while scrolled away.
  const [showScrollFab, setShowScrollFab] = useState(false);
  const showScrollFabRef = useRef(false);
  const [awayNewCount, setAwayNewCount] = useState(0);
  const countedNewMessRef = useRef(null);
  // Sticky day chip under the header (the day of the topmost visible message).
  const [stickyDay, setStickyDay] = useState(null);
  // "N unread messages" band: the unread count the chat was opened with and the message it sits above.
  const unreadAtOpenRef = useRef(Number(props.chat?.unreadCountAtOpen ?? props.chat?.unseenChatCount) || 0);
  const [unreadAnchorId, setUnreadAnchorId] = useState(null);
  // "… is typing" of the other person ({ name }).
  const [peerTyping, setPeerTyping] = useState(null);
  // Video-call gating: derive `isVideoCallAllowed` from the user profile's
  // dmCallFeatureEnabled flag (already loaded by the app on login). The
  // per-room /videochat/get call previously fired on every chat open; it is
  // no longer required because:
  //   - Active call status comes from the global `runningCalls` selector
  //     (populated by /videochat/getRunningCalls + socket events).
  //   - The DM call feature flag is already on the profile.
  // The backend continues to validate on /videochat/join, so a stray click
  // cannot bypass account/feature gating.
  const [isCallRunning, setIsCallRunning] = useState(false);
  const [isVideoCallAllowed, setIsVideoCallAllowed] = useState(false);
  // Removed addUserAction and addChatUserAction - not needed for one-on-one chats (no members to add)
  // Delivered / read ticks from the socket (utils/chatReceipts), applied when a row renders.
  const receiptsRef = useRef(null);
  if (!receiptsRef.current) receiptsRef.current = createReceiptTracker();
  const [, setReceiptTick] = useState(0);
  const bumpReceipts = useCallback(() => setReceiptTick((n) => n + 1), []);
  const lastSocketRef = useRef(null);
  const [visible, setVisible] = useState(true);
  const [axiosReq, setAxiosReq] = useState(null);
  let [isMe, setIsMe] = useState("Me");
  const [replyMessage, setReplyMessage] = useState(null);
  const [recordState, setRecordState] = useState(RecordState.STOP);
  const [recordingCounter, setRecordingCounter] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  // Track if screen is wide enough to show chat side-by-side (>1380px)
  // From 0-1380px, chat shows as overlay with back arrow visible
  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 1380);

  // Auto-suggestion states for reply recommendations
  const [autoSuggestions, setAutoSuggestions] = useState([]);
  const [autoSuggestionsLoading, setAutoSuggestionsLoading] = useState(false);
  const [autoSuggestionsError, setAutoSuggestionsError] = useState(null);
  const [showSuggestionLoadingPopup, setShowSuggestionLoadingPopup] = useState(false);
  const [pendingSuggestionIndex, setPendingSuggestionIndex] = useState(null);
  const [isReplyInputFocused, setIsReplyInputFocused] = useState(false);
  const autoSuggestionsRef = useRef([]);
  const recordingStartRef = useRef(0);
  const autoSuggestionsLoadingRef = useRef(false);
  const lastSuggestionMsgIdRef = useRef(null);
  // An image without imageDescription waits briefly for it; this holds that wait so it can be
  // cancelled when the chat or last message changes (otherwise the loading flag never clears).
  const imageDescWaitRef = useRef({ msgId: null, timer: null });
  const stopImageDescriptionWait = () => {
    if (!imageDescWaitRef.current.timer) return;
    clearTimeout(imageDescWaitRef.current.timer);
    imageDescWaitRef.current = { msgId: null, timer: null };
    setAutoSuggestionsLoading(false);
    autoSuggestionsLoadingRef.current = false;
  };

  // ========== ALL HOOKS MUST BE AT THE TOP ==========
  // All hooks (useContext, useRef, useCallback, useEffect) must be declared here
  // BEFORE any other code (functions, const objects, etc.)
  
  // Context hooks
  const Socket = useContext(SocketContext);
  const paneActive = useContext(PaneActiveContext);
  const paneActiveRef = useRef(paneActive);
  const { isGerm, strings, language } = React.useContext(LanguageContext);
  
  // Determine current language for moment locale (using useMemo to keep it as a hook)
  const currentLanguage = useMemo(() => language || (isGerm ? 'de' : 'en'), [language, isGerm]);
  // User interface language for auto-translation (app language, not browser language)
  const translationLang = useMemo(
    () => (language || props.language || localStorage.getItem('language') || 'en').split("-")[0].toLowerCase(),
    [language, props.language]
  );
  
  useEffect(() => {
    moment.locale(getLocaleForLanguage(currentLanguage));
  }, [currentLanguage]);
  
  const formatDateWithLocale = useCallback((date) => {
    return moment(date).locale(getLocaleForLanguage(currentLanguage)).format("D MMM, Y");
  }, [currentLanguage]);
  
  // Selector hooks
  const joinNowRoomWise = useSelector(state => state.joinNowRoomWise);
  const runningCalls = useSelector(e => e.runningCalls);
  const isDesktop = useSelector(e => e.isDeskTopResolution);
  const openProjectDetailToggle = useSelector(e => e.openProjectDetailToggle);
  const openGroupChatToggle = useSelector(e => e.openGroupChatToggle);
  const isDesktopResolution = useSelector(state => state.isDesktopResolution);
  const refreshGroupMessages = useSelector(state => state.refreshGroupMessages);
  const profile = useSelector(state => state.profile);
  
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [translatedChatName, setTranslatedChatName] = useState('');
  // Tracks which translated messages are currently showing their original text
  const [showOriginalMap, setShowOriginalMap] = useState({});
  const showOriginalMapRef = useRef(showOriginalMap);
  showOriginalMapRef.current = showOriginalMap;
  const getCopyableOriginalTextRef = useRef(null);
  const toggleShowOriginal = React.useCallback((id) => {
    if (!id) return;
    setShowOriginalMap((prev) => ({ ...prev, [id]: !prev[id] }));
  }, []);
  const getDisplayMessage = React.useCallback((chat) => {
    if (chat && showOriginalMap[chat.id] && chat.originalMessage) return chat.originalMessage;
    return chat?.message;
  }, [showOriginalMap]);
  
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsWideScreen(width > 1380);
      setScreenWidth(width);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isSelfChatConversation = useMemo(() => !!(
    chatDetails?.isSelfChat ||
    props.chat?.isSelfChat ||
    props.chat?.group?.isSelfChat
  ), [chatDetails?.isSelfChat, props.chat?.isSelfChat, props.chat?.group?.isSelfChat]);
  const isInternalAccent = useMemo(
    () => !!(isSelfChatConversation || chatDetails?.isInternal),
    [isSelfChatConversation, chatDetails?.isInternal]
  );

  // Microsoft Teams mirror chat (null for every native chat): this pane, minus what Teams cannot do
  // (unsupportedActions), from the open-chat entry (list row) first, then /group/:id/info, the
  // subscribe and getChat groupInfo (utils/teams/teamsChat.teamsChatFrom). Mobile: the Teams flag
  // of GroupMessageScreen.
  const [teamsInfo, setTeamsInfo] = useState(() => teamsChatFrom(props.chat));
  const teamsInfoRef = useRef(teamsInfo);
  teamsInfoRef.current = teamsInfo;
  const isTeams = !!teamsInfo;
  // The project room the Teams chat is filed under (daily report only; the chat stays room-less).
  // A change made here or from the Messages row menu wins over the payloads until the chat changes.
  const [teamsProjectOverride, setTeamsProjectOverride] = useState(undefined);
  // A push / search opened the chat before the list knew it: Teams group info names it.
  const [teamsHeaderTitle, setTeamsHeaderTitle] = useState(null);
  const applyTeamsGroupInfo = (gi) => {
    const next = teamsChatFrom(gi, props.chat);
    if (!next) return;
    const prev = teamsInfoRef.current;
    if (!(prev && JSON.stringify(prev) === JSON.stringify(next))) {
      teamsInfoRef.current = next;
      setTeamsInfo(next);
    }
    const name = teamsHeaderName(gi, props.chat?.name);
    if (name) setTeamsHeaderTitle(name);
  };
  const applyTeamsGroupInfoRef = useRef(applyTeamsGroupInfo);
  applyTeamsGroupInfoRef.current = applyTeamsGroupInfo;
  useEffect(() => {
    const next = teamsChatFrom(props.chat);
    teamsInfoRef.current = next;
    setTeamsInfo(next);
    setTeamsHeaderTitle(null);
    setTeamsProjectOverride(undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.chat?.id]);

  const teamsProject = teamsProjectOverride !== undefined ? teamsProjectOverride : (teamsInfo && teamsInfo.project) || null;
  useEffect(() => {
    if (!teamsInfo) return undefined;
    const onProject = (e) => {
      const detail = e && e.detail;
      if (!detail || String(detail.groupId) !== String(props.chat?.id)) return;
      setTeamsProjectOverride(detail.project || null);
    };
    window.addEventListener(TEAMS_PROJECT_EVENT, onProject);
    return () => window.removeEventListener(TEAMS_PROJECT_EVENT, onProject);
  }, [teamsInfo, props.chat?.id]);

  // Microsoft Teams files are signed URLs: a photo of this chat that does not load asks the server
  // why (utils/teams/teamsChat.reportTeamsFileError). An expired signature (403 'expired') refetches
  // the history page that holds the message and puts its fresh URLs on the rows on screen (each
  // page at most once a minute); a file only Teams can serve offers "Open in Teams".
  const teamsFileReloadAtRef = useRef(new Map());
  const teamsFileNoticeAtRef = useRef(0);
  useEffect(() => {
    if (!isTeams) return undefined;
    const chatId = props.chat?.id || props.chat?.key;
    if (!chatId) return undefined;
    const onMediaError = (e) => {
      const el = e && e.target;
      if (!el || (el.tagName !== "IMG" && el.tagName !== "VIDEO")) return;
      const src = el.currentSrc || el.src || "";
      if (!isSignedFileUrl(src)) return;
      if (!el.closest || !el.closest(`[id="chat-scroll-view-${chatId}"]`)) return;
      reportTeamsFileError(src);
    };
    const refreshFilePage = async (url) => {
      const entry = (tempChatHistoryRef.current || []).find((x) => x && (x.id === chatId || x.id === props.chat?.key));
      const rows = [];
      (entry?.data || []).forEach((g) => (g?.items || []).forEach((m) => rows.push(m)));
      const hit = teamsPageOfFile(rows, url, 30);
      const pages = hit ? teamsFilePagesToTry(hit.page) : [1];
      const now = Date.now();
      const lastAt = teamsFileReloadAtRef.current.get(pages[0]);
      if (lastAt != null && now - lastAt < 60000) return;
      teamsFileReloadAtRef.current.set(pages[0], now);
      for (const pageNo of pages) {
        const res = await fetchChatPage({ chatId, page: pageNo, limit: 30, userId: user?.id, translationLang, force: true });
        const fresh = res?.data?.status && Array.isArray(res.data.chatHistory) ? res.data.chatHistory : [];
        if (fresh.length) setTempChatHistory((prev) => mapHistoryItems(prev, (items) => applyTeamsFileUrls(items, fresh)));
        if (!hit || fresh.some((r) => r && String(r.id) === String(hit.id))) break;
      }
    };
    const onFileError = (e) => {
      const { action, url } = (e && e.detail) || {};
      if (action === "reload") {
        refreshFilePage(url).catch(() => {});
      } else if (action === "openInTeams") {
        const now = Date.now();
        if (now - teamsFileNoticeAtRef.current < 10000) return;
        teamsFileNoticeAtRef.current = now;
        const webUrl = teamsInfoRef.current && teamsInfoRef.current.webUrl;
        const title = strings.teams_file_unavailable || (isGerm ? "Diese Datei ist nur in Microsoft Teams verfügbar." : "This file is only available in Microsoft Teams.");
        if (!webUrl) {
          $crud.notify({ type: "error", message: title });
          return;
        }
        $crud
          .confirm({
            title,
            textContent: "",
            options: { ok: strings.teams_open_in_teams || (isGerm ? "In Teams öffnen" : "Open in Teams"), cancel: strings.cancel || (isGerm ? "Abbrechen" : "Cancel") },
          })
          .then(() => openInTeams(webUrl))
          .catch(() => {});
      }
    };
    window.addEventListener("error", onMediaError, true);
    window.addEventListener(TEAMS_FILE_ERROR_EVENT, onFileError);
    return () => {
      window.removeEventListener("error", onMediaError, true);
      window.removeEventListener(TEAMS_FILE_ERROR_EVENT, onFileError);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTeams, props.chat?.id, props.chat?.key]);

  useEffect(() => {
    if (
      !translateRoomAndGroupNames ||
      props.chat?.defaultChatGroup ||
      chatDetails?.isOneToOne ||
      props.chat?.isOneToOne ||
      isSelfChatConversation ||
      teamsInfoRef.current
    ) {
      setTranslatedChatName('');
      return;
    }
    const name = typeof props.chat?.name === 'string'
      ? props.chat.name
      : (typeof chatDetails.name === 'string' ? chatDetails.name : '');
    if (!name) return;

    let cancelled = false;
    const lang = translationLang;
    const cleanName = stripMarkdown(name);

    (async () => {
      const translated = await getTranslateText(cleanName, lang);
      if (!cancelled && translated && translated !== cleanName) {
        setTranslatedChatName(translated);
      }
    })();

    return () => { cancelled = true; };
  }, [translateRoomAndGroupNames, props.chat?.name, props.chat?.defaultChatGroup, chatDetails.name, chatDetails?.isOneToOne, isSelfChatConversation, translationLang]);

  // Refs
  const ttop = useRef();
  const textRef = useRef(null);
  const emojiRefs = useRef({});
  const currentLoadingChatRef = useRef(null);
  const isInitialMount = useRef(true);
  const loadingStateRef = useRef({
    chatId: null,
    isLoaded: false,
    requestId: 0
  });
  const paintedFromCacheRef = useRef(false);
  const paintedFingerprintRef = useRef("");
  const recoveredPreviewIdRef = useRef(null);
  const currentFetchingChatIdRef = useRef(null);
  const chatIdTrackingRef = useRef(null);
  const lastChatIdRef = useRef(null);
  const pendingDraftHtmlRef = useRef(null);
  const draftHydratedRef = useRef(false);
  const userIdRef = useRef(user?.id);
  userIdRef.current = user?.id;
  const isComposerToolbarOpenRef = useRef(isComposerToolbarOpen);
  isComposerToolbarOpenRef.current = isComposerToolbarOpen;
  const messagesEndRef = useRef(null);
  const backgroundTranslationIdRef = useRef(0);
  const prevTranslationLangRef = useRef(translationLang);

  const resizeMentionsInput = useCallback(() => {
    resizeTextarea(textRef.current);
  }, []);

  useEffect(() => {
    resizeMentionsInput();
  }, [message, resizeMentionsInput]);

  const {
    applyComposerState,
    saveComposerHistory,
    handleComposerChange,
    handleComposerUndo,
    handleComposerRedo,
  } = useComposerHistory(setMessage, messageRef, textRef);

  const {
    richEditorRef,
    pendingToggleHtmlRef,
    composerMarkdownToHtml,
    htmlToMarkdown,
    updateActiveFormats,
    getRichEditorContent,
  } = useRichEditor(isComposerToolbarOpen, setMessage, setActiveFormats);

  const flushComposerRef = useRef(() => "");
  flushComposerRef.current = () =>
    flushComposerMessage({
      setMessage,
      messageRef,
      richEditorRef,
      getRichEditorContent,
      isComposerToolbarOpen: isComposerToolbarOpenRef.current,
    });

  const mentionCursorRef = useRef(null);

  const applyComposerFormat = useCallback((formatType) => {
    sharedApplyComposerFormat({
      formatType,
      richEditorRef,
      isComposerToolbarOpen,
      textRef,
      messageRef,
      saveComposerHistory,
      applyComposerState,
      enterUrlLabel: strings.enter_url,
    });
  }, [isComposerToolbarOpen, richEditorRef, applyComposerState, saveComposerHistory, strings.enter_url]);

  // Memoize chat sections so typing doesn't re-run heavy grouping/sorting.
  const activeChatSections = useMemo(() => {
    const chatId = props.chat?.id || props.chat?.key;
    const data = tempChatHistory?.find((item) =>
      idsMatch(item?.id, chatId) || idsMatch(item?.id, props.chat?.id) || idsMatch(item?.id, props.chat?.key)
    )?.data || [];
    return buildRenderableSections(data, formatDateWithLocale) || [];
  }, [tempChatHistory, props.chat?.id, props.chat?.key, formatDateWithLocale]);

  // Compute whether suggestions are visible for dynamic padding (only when input focused)
  const hasSuggestionsVisible = useMemo(() => {
    return !audioRecording && !forward && !props.chat?.onlyView && 
      isReplyInputFocused &&
      (autoSuggestions.length > 0 || autoSuggestionsLoading) && !autoSuggestionsError;
  }, [audioRecording, forward, props.chat?.onlyView, isReplyInputFocused, autoSuggestions.length, autoSuggestionsLoading, autoSuggestionsError]);

  // When suggested replies become visible, scroll chat to keep the last message in view
  useEffect(() => {
    if (hasSuggestionsVisible && shouldShowAutoSuggestions()) {
      const chatId = props.chat?.id;
      const chatContainer = document.getElementById(`chat-sc-${chatId}`);
      if (chatContainer && isNearBottom(chatContainer)) {
        // Wait for DOM to apply the has-suggestions padding before scrolling
        setTimeout(() => {
          scrollToBottom(chatId, 'smooth');
        }, 100);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasSuggestionsVisible]);

  // Restore scroll position immediately after DOM updates (before paint).
  // Handles: (a) prepended messages from top-pagination, (b) emoji reaction updates.
  useLayoutEffect(() => {
    // (0) After a thread swap (search jump / back to latest): center the result, or the bottom.
    const pendingScroll = pendingThreadScrollRef.current;
    if (pendingScroll) {
      pendingThreadScrollRef.current = null;
      const box = document.getElementById(`chat-sc-${pendingScroll.chatId}`);
      if (box) {
        if (pendingScroll.target === 'bottom') {
          box.scrollTop = box.scrollHeight;
        } else {
          const rowId = rowIdByMessageIdRef.current.get(pendingScroll.target) || pendingScroll.target;
          const el = document.getElementById(`chat-${rowId}`);
          if (el) scrollMessageIntoChat(el, { behavior: 'auto', container: box });
        }
      }
      scrollPreservationRef.current.isPreserving = false;
      return;
    }

    // (a) Top-pagination: offset scroll by the height of newly-prepended content
    if (scrollPreservationRef.current.isPreserving) {
      const { oldScrollTop, oldScrollHeight, chatId } = scrollPreservationRef.current;
      const chatContainer = document.getElementById(`chat-sc-${chatId}`);
      if (chatContainer) {
        const heightDifference = chatContainer.scrollHeight - oldScrollHeight;
        chatContainer.scrollTop = oldScrollTop + heightDifference;
      }
      scrollPreservationRef.current.isPreserving = false;
      return; // done — skip emoji check
    }

    // (b) Emoji: restore exact scroll position saved before the update
    if (emojiUpdateRef.current.isUpdating) {
      const chatContainer = document.getElementById(`chat-sc-${props.chat?.id}`);
      if (chatContainer) {
        chatContainer.scrollTop = emojiUpdateRef.current.scrollTop;
      }
      emojiUpdateRef.current.isUpdating = false;
    }
  }, [tempChatHistory]);

  // Callbacks
  const closeEmojiPicker = useCallback(() => {
    if (isInputEmojiOpen && !isInputEmojiClosing) {
      setIsInputEmojiClosing(true);
      requestAnimationFrame(() => {
        setTimeout(() => {
          setIsInputEmojiOpen(false);
          setIsInputEmojiClosing(false);
        }, 250);
      });
    }
  }, [isInputEmojiOpen, isInputEmojiClosing]);
  
  const toggleEmojiPicker = useCallback(() => {
    if (isInputEmojiOpen) {
      closeEmojiPicker();
    } else if (!isInputEmojiClosing) {
      setIsInputEmojiOpen(true);
    }
  }, [isInputEmojiOpen, isInputEmojiClosing, closeEmojiPicker]);

  const openEmojiPickerForChat = useCallback((chatId, event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    const button = event?.currentTarget || event?.target;
    
    if (button) {
      const contextMenu = button.closest('.contextMenu');
      if (contextMenu) {
        contextMenu.classList.add('emoji-picker-active');
      }
      
      const actionButton = button.closest('.message-action-btn');
      if (actionButton) {
        actionButton.classList.add('reaction-button-active');
      }
      
      setEmojiTriggerElement(button);
      setActiveEmojiChatId(chatId);
    }
  }, []);

  const closePreloadedEmojiPicker = useCallback(() => {
    document.querySelectorAll('.contextMenu.emoji-picker-active').forEach(menu => {
      menu.classList.remove('emoji-picker-active');
    });
    
    document.querySelectorAll('.message-action-btn.reaction-button-active').forEach(btn => {
      btn.classList.remove('reaction-button-active');
    });
    
    setActiveEmojiChatId(null);
    setEmojiTriggerElement(null);
  }, []);

  const onDrop = useCallback((acceptedFiles, _rejections, event) => {
    const dropped = getDroppedFiles(event?.dataTransfer);
    const files = dropped.length > 0 ? dropped : (acceptedFiles || []);
    if (!files.length) return;
    const now = Date.now();
    if (now - dropGuardRef.current.at < 400 && files.length <= dropGuardRef.current.count) {
      return;
    }
    dropGuardRef.current = { at: now, count: files.length };
    flushComposerRef.current();
    setDropFiles(
      files.map((file) => {
        if (!file.url) file.url = URL.createObjectURL(file);
        return file;
      })
    );
    setFloatingAction(true);
  }, []);

  // All useEffect hooks (functions referenced here are defined later in the component)

  // Badge totals are refreshed after subscribe marks the room as read
  // (`_subsOnly` → getBadgesCount). A mount-time /badge/count would race
  // that forced refresh and show up as a duplicate ~1s request on every open.
  
  useEffect(() => {
    // Get chat ID (support both id and key for direct messages from LatestMessages)
    const currentChatId = props.chat?.id || props.chat?.key;
    
    // Check if chat ID actually changed (not just object reference)
    // Skip reload if: not first render AND same chat ID
    if (chatIdTrackingRef.current !== null && chatIdTrackingRef.current === currentChatId) {
      // Chat ID hasn't changed, just object reference updated (e.g., from reorder)
      // Don't reset state or reload
      return;
    }

    const previousChatId = chatIdTrackingRef.current;
    if (previousChatId && previousChatId !== currentChatId && userIdRef.current) {
      persistDraftMessage(
        userIdRef.current,
        previousChatId,
        readComposerDraftText({
          richEditorRef,
          getRichEditorContent,
          messageRef,
          isComposerToolbarOpen: isComposerToolbarOpenRef.current,
        })
      );
    }
    
    // Update tracking ref
    chatIdTrackingRef.current = currentChatId;
    draftHydratedRef.current = false;
    
    // Clear the fetching ref to cancel any in-flight requests for previous room
    currentFetchingChatIdRef.current = null;
    
    setChatDetails({});
    setIsChatDetailsLoaded(false);
    setChatDetailsX({});
    setIsReplyInputFocused(false);
    
    if (!currentChatId) {
      applyDraftToComposer({
        draftText: "",
        setMessage,
        messageRef,
        richEditorRef,
        isComposerToolbarOpen: isComposerToolbarOpenRef.current,
        composerMarkdownToHtml,
        pendingDraftHtmlRef,
      });
      return;
    }
    
    const drafts = store.getState().draftMessages || [];
    const msg = drafts.find(
      (m) => m.userId === user?.id && m.group === currentChatId
    );
    applyDraftToComposer({
      draftText: msg?.message || "",
      setMessage,
      messageRef,
      richEditorRef,
      isComposerToolbarOpen: isComposerToolbarOpenRef.current,
      composerMarkdownToHtml,
      pendingDraftHtmlRef,
    });
    draftHydratedRef.current = true;
    
    // Fetch details for the new room
    getDetails(currentChatId);
  }, [props.chat?.id, props.chat?.key]);

  useEffect(() => {
    if (unavailableMembers.length > 0) {
      const others = unavailableMembers.filter(u => u.userId !== user?.id);
      if (others.length > 0) {
        setShowUnavailBanner(true);
        if (unavailBannerTimerRef.current) clearTimeout(unavailBannerTimerRef.current);
        unavailBannerTimerRef.current = setTimeout(() => setShowUnavailBanner(false), 5000);
      }
    }
    return () => { if (unavailBannerTimerRef.current) clearTimeout(unavailBannerTimerRef.current); };
  }, [unavailableMembers]);

  // Save draft when unmounting (e.g. when switching chats or navigating back)
  useEffect(() => {
    return () => {
      const groupId = chatIdTrackingRef.current;
      const uid = userIdRef.current;
      if (!groupId || !uid) return;
      const text = readComposerDraftText({
        richEditorRef,
        getRichEditorContent,
        messageRef,
        isComposerToolbarOpen: isComposerToolbarOpenRef.current,
      });
      if (text || draftHydratedRef.current) {
        persistDraftMessage(uid, groupId, text);
      }
    };
  }, []);

  useEffect(() => {
    if (!pendingDraftHtmlRef.current) return;
    if (isComposerToolbarOpen && richEditorRef.current) {
      richEditorRef.current.innerHTML = pendingDraftHtmlRef.current;
      pendingDraftHtmlRef.current = null;
    }
  }, [isComposerToolbarOpen, message, props.chat?.id, props.chat?.key]);

  useEffect(() => {
    if (NewMess) {
      const fromOther = NewMess.senderId != null && String(NewMess.senderId) !== String(user?.id);
      const newKey = NewMess.id || NewMess.messageRequestId;
      if (fromOther && newKey && countedNewMessRef.current !== newKey) {
        countedNewMessRef.current = newKey;
        setPeerTyping(null);
        if (showScrollFabRef.current) setAwayNewCount((n) => n + 1);
      }
      handler(NewMess);
    }
  }, [NewMess, secretKey]);

  // "… is typing" of the other person: POST /group/:id/checkIsTyping makes the backend send an
  // event named after the chat; it clears on the typist's stop, else 6 s after the last one (utils/chatTyping).
  useEffect(() => {
    const chatId = props.chat?.id || props.chat?.key;
    if (!chatId || !Socket || isSelfChatConversation) return undefined;
    setPeerTyping(null);
    return subscribeTyping(Socket, chatId, user?.id, (who) => setPeerTyping(who), () => setPeerTyping(null));
  }, [props.chat?.id, props.chat?.key, Socket, isSelfChatConversation]);

  // My own "typing": from the first keystroke for as long as the field keeps focus and holds
  // text; a send (the field empties) or leaving the chat ends it at once (utils/chatTyping).
  const typingSenderRef = useRef(null);
  if (!typingSenderRef.current) typingSenderRef.current = createTypingSender();
  useEffect(() => () => typingSenderRef.current.stop(), [props.chat?.id, props.chat?.key]);
  useEffect(() => {
    if (!String(message || "").trim()) typingSenderRef.current.stop();
  }, [message]);

  useEffect(() => {
    preloadSendSound();
  }, []);

  // Escape leaves select mode / the in-chat search (the composer handles its own Escape).
  useEffect(() => {
    if (!forward && !searchView) return undefined;
    const onKey = (e) => {
      if (e.key !== "Escape" || e.defaultPrevented) return;
      if (e.target && e.target.closest && e.target.closest('[contenteditable="true"], textarea')) return;
      if (forward) cancelForward();
      else if (searchView) closeChatSearch();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forward, searchView]);

  // "N unread messages": anchored once, above the oldest of the n newest messages.
  useEffect(() => {
    const n = unreadAtOpenRef.current;
    if (unreadAnchorId || n <= 0 || !isContentReady) return;
    const list = flattenSections(activeChatSections);
    if (!list.length) return;
    const target = list[Math.max(0, list.length - Math.min(n, list.length))];
    if (target?.id != null) setUnreadAnchorId(String(target.id));
  }, [activeChatSections, isContentReady, unreadAnchorId]);

  // Re-translate messages when the encryption key changes (e.g. key
  // loaded after initial render).  Does NOT depend on translationLang —
  // language changes are handled by the separate effect below that
  // clears the chat and re-fetches with the new translationLang param.
  // Messages already being translated (translationPending) or already
  // translated (message !== originalMessage) are skipped to avoid
  // duplicate /message/translate calls with backgroundTranslateMessages.
  useEffect(() => {
    if (!secretKey) return;
    const chatId = props.chat?.id || props.chat?.key;
    const currentHistory = tempChatHistoryRef.current;
    const chatEntry = currentHistory?.find(item => item.id === chatId);
    if (!chatEntry?.data) return;

    let cancelled = false;
    const retranslate = async () => {
      const lang = translationLang;
      const langs = autoTransLangsRef.current;

      // Warm the translation cache with one batch call first. The per-message
      // getTranslate below then resolves from cache instead of firing N
      // individual /message/translate requests (which raced the conversation
      // batch and showed up as a flood in the network tab).
      const batchItems = [];
      for (const section of chatEntry.data) {
        for (const msg of (section.items || [])) {
          if (msg.senderId === user?.id) continue;
          if (msg.translationPending) continue;
          if (msg.originalMessage && msg.message !== msg.originalMessage) continue;
          let plain = msg.originalMessage || msg.message;
          if (typeof plain === 'string' && plain.startsWith('U2FsdGVkX1')) {
            try { plain = decryptMessage(plain, secretKey); } catch (e) {}
          }
          let effectiveLang = msg.detectedMessageLanguage;
          if (!effectiveLang && plain) effectiveLang = detectLanguageClient(plain);
          if (!shouldAutoTranslateFromSender(effectiveLang, lang, langs, msg.messageMatchesSenderLanguage)) continue;
          if (plain && isUntranslatableText(plain)) continue;
          const msgId = msg.id || msg.messageRequestId;
          if (plain && msg.originalMessage && msg.message === msg.originalMessage) {
            batchItems.push({ id: `sk-m-${msgId}`, message: plain, isMarkdown: true });
          }
          if (msg.inReplyTo?.message && String(msg.senderId ?? '') !== String(user?.id ?? '')) {
            let replyText = msg.inReplyTo.message;
            if (typeof replyText === 'string' && replyText.startsWith('U2FsdGVkX1')) {
              replyText = secretKey ? decryptMessage(replyText, secretKey) : null;
            }
            if (replyText) batchItems.push({ id: `sk-r-${msgId}`, message: replyText, isMarkdown: true });
          }
          if (msg.transcribedAudio && !msg.originalTranscribedAudio) {
            batchItems.push({ id: `sk-a-${msgId}`, message: msg.transcribedAudio });
          }
          if (msg.docFileSummary && !msg.originalDocFileSummary) {
            batchItems.push({ id: `sk-d-${msgId}`, message: msg.docFileSummary });
          }
        }
      }
      if (batchItems.length > 0 && !cancelled) {
        try {
          await translateMessagesBatch(batchItems, lang);
        } catch (e) {
          console.warn('[autoTranslate] secretKey batch failed', e?.message || e);
        }
      }
      if (cancelled) return;

      const updatedData = await Promise.all(chatEntry.data.map(async (section) => {
        const updatedItems = await Promise.all(section.items.map(async (msg) => {
          if (cancelled || msg.senderId === user?.id) return msg;
          if (msg.translationPending) return msg;
          if (msg.originalMessage && msg.message !== msg.originalMessage) return msg;
          let plain = msg.originalMessage || msg.message;
          if (typeof plain === 'string' && plain.startsWith('U2FsdGVkX1')) {
            try { plain = decryptMessage(plain, secretKey); } catch (e) {}
          }
          let effectiveLang = msg.detectedMessageLanguage;
          if (!effectiveLang && plain) effectiveLang = detectLanguageClient(plain);
          if (!shouldAutoTranslateFromSender(effectiveLang, lang, langs, msg.messageMatchesSenderLanguage)) return msg;
          if (plain && isUntranslatableText(plain)) {
            return msg.translationPending ? { ...msg, translationPending: false } : msg;
          }
          let updatedMsg = { ...msg };
          let changed = false;

          if (msg.originalMessage && msg.message === msg.originalMessage) {
            const translated = await getTranslate({ ...msg, message: msg.originalMessage }, lang);
            if (translated !== msg.originalMessage) {
              updatedMsg.message = translated;
              changed = true;
            }
          }

          if (msg.inReplyTo?.message && msg.inReplyTo.message.startsWith('U2FsdGVkX1')) {
            const translatedReply = await getTranslate(msg.inReplyTo, lang);
            if (translatedReply !== msg.inReplyTo.message) {
              updatedMsg.inReplyTo = { ...msg.inReplyTo, message: translatedReply };
              changed = true;
            }
          }

          if (msg.transcribedAudio && !msg.originalTranscribedAudio) {
            const translatedAudio = preserveOriginalFormatting(
              await getTranslateText(msg.transcribedAudio, lang),
              msg.transcribedAudio
            );
            if (translatedAudio !== msg.transcribedAudio) {
              updatedMsg.originalTranscribedAudio = msg.transcribedAudio;
              updatedMsg.transcribedAudio = translatedAudio;
              changed = true;
            }
          }

          if (msg.docFileSummary && !msg.originalDocFileSummary) {
            const translatedDoc = await getTranslateText(msg.docFileSummary, lang);
            if (translatedDoc !== msg.docFileSummary) {
              updatedMsg.originalDocFileSummary = msg.docFileSummary;
              updatedMsg.docFileSummary = translatedDoc;
              changed = true;
            }
          }

          return changed ? updatedMsg : msg;
        }));
        return { ...section, items: updatedItems };
      }));

      if (!cancelled) {
        setTempChatHistory(prev => prev.map(entry =>
          entry.id === chatId ? { ...entry, data: updatedData } : entry
        ));
      }
    };

    retranslate();
    return () => { cancelled = true; };
  }, [secretKey]);

  useEffect(() => {
    const prev = prevTranslationLangRef.current;
    prevTranslationLangRef.current = translationLang;
    if (String(prev || "").toLowerCase() === String(translationLang || "").toLowerCase()) return;
    if (!isAutoTranslation) return;

    const chatId = props.chat?.id || props.chat?.key;
    if (!chatId) return;

    clearTranslationCache();
    dispatch({ type: CLEAR_CACHED_MESSAGES });
    invalidateCachedChat(chatId);

    setTempChatHistory(h => h.filter(entry => entry.id !== chatId));
    setOriginalMessages([]);
    setLoadedPages(new Set([]));
    _getMessages(1, 'initial');
  }, [translationLang, isAutoTranslation]);

  const prevAutoLangsRef = useRef(autoTranslationLanguages);
  useEffect(() => {
    const prev = prevAutoLangsRef.current;
    prevAutoLangsRef.current = autoTranslationLanguages;
    if (prev === autoTranslationLanguages) return;
    if (!autoTranslationLanguages || autoTranslationLanguages.length === 0) return;
    const chatId = props.chat?.id;
    const currentHistory = tempChatHistoryRef.current;
    const chatEntry = currentHistory?.find(item => item.id === chatId);
    if (!chatEntry?.data) return;
    const lang = translationLang;
    let changed = false;
    const updatedData = chatEntry.data.map(section => ({
      ...section,
      items: section.items.map(msg => {
        if (msg.senderId === user?.id) return msg;
        if (!msg.originalMessage || msg.message === msg.originalMessage) return msg;
        const allowed = shouldAutoTranslateFromSender(msg.detectedMessageLanguage, lang, autoTranslationLanguages);
        if (!allowed) {
          changed = true;
          return { ...msg, message: msg.originalMessage, translationPending: false };
        }
        return msg;
      }),
    }));
    if (changed) {
      setTempChatHistory(h => h.map(entry =>
        entry.id === chatId ? { ...entry, data: updatedData } : entry
      ));
    }
  }, [autoTranslationLanguages]);

  useEffect(() => {
    if (emojiMessage) {
      // Preserve scroll position before updating emoji
      const scrollView = document.getElementById(`chat-sc-${props.chat?.id}`);
      const savedScrollTop = scrollView?.scrollTop || 0;
      
      // Set flag to prevent auto-scroll in useEffect
      emojiUpdateRef.current = { isUpdating: true, scrollTop: savedScrollTop };
      
      if (!emojiMessage.isEmojiSet) {
        let newEmojiList = [];
        const newChat = tempChatHistory?.[0]?.data?.map((chatGroup, index) => {
          return {
            ...chatGroup,
            items: chatGroup?.items?.map((chat) => {
              if (chat?.id === emojiMessage?.chat) {
                newEmojiList = [...chat?.userEmoji];
                const emojiInd = (newEmojiList || [])?.findIndex(
                  (emoji) =>
                    emoji?.sender === emojiMessage?.sender &&
                    emojiMessage?.emoji === emoji?.emoji
                );
                if (emojiInd !== -1) {
                  newEmojiList?.splice(emojiInd, 1);
                }
                return {
                  ...chat,
                  userEmoji: newEmojiList,
                };
              } else {
                return chat;
              }
            }),
          };
        });
        const newTempChat = [{ id: tempChatHistory?.[0]?.id, data: newChat }];
        if (
          newEmojiList?.length &&
          emojiReactionUser?.[0]?.chatId === emojiMessage?.chat
        ) {
          getUserListForEmoji({
            emojiList: newEmojiList,
            chatId: emojiMessage?.chat,
            groupId: props?.chat?.id,
            modalIs: false,
          });
        }
        setTempChatHistory(newTempChat);
        setEmojiMessage(null);
        
        // Restore scroll position after state update
        requestAnimationFrame(() => {
          if (scrollView && savedScrollTop !== undefined) {
            scrollView.scrollTop = savedScrollTop;
          }
        });
      } else {
        // A reaction from a Microsoft Teams person ('teams:<aad>') keeps its name: that person is not
        // a Kjuup user, so the reacters list cannot look it up.
        const emojiInfo = String(emojiMessage?.sender || "").startsWith("teams:")
          ? { sender: emojiMessage.sender, emoji: emojiMessage.emoji, senderName: emojiMessage.senderName || null, isTeamsMember: true }
          : {
              sender: emojiMessage?.sender,
              emoji: emojiMessage?.emoji,
            };
        let newEmojiList = [];
        const newChat = tempChatHistory?.[0]?.data?.map((chatGroup, index) => {
          return {
            ...chatGroup,
            items: chatGroup?.items?.map((chat) => {
              if (chat?.id === emojiMessage?.chat) {
                const emojiInd = (chat?.userEmoji || [])?.findIndex(
                  (emoji) =>
                    emoji?.sender === emojiMessage?.sender &&
                    emojiMessage?.emoji === emoji?.emoji
                );
                if (emojiInd === -1) {
                  newEmojiList = [...(chat?.userEmoji || []), emojiInfo];
                } else {
                  newEmojiList = [...(chat?.userEmoji || [])];
                }
                return {
                  ...chat,
                  userEmoji: newEmojiList,
                };
              } else {
                return chat;
              }
            }),
          };
        });
        const newTempChat = [{ id: tempChatHistory?.[0]?.id, data: newChat }];
        if (
          newEmojiList?.length &&
          emojiReactionUser?.[0]?.chatId === emojiMessage?.chat
        ) {
          getUserListForEmoji({
            emojiList: newEmojiList,
            chatId: emojiMessage?.chat,
            groupId: props?.chat?.id,
            modalIs: false,
          });
        }
        setTempChatHistory(newTempChat);
        setEmojiMessage(null);
        
        // Restore scroll position after state update
        requestAnimationFrame(() => {
          if (scrollView && savedScrollTop !== undefined) {
            scrollView.scrollTop = savedScrollTop;
          }
        });
      }
    }
  }, [emojiMessage]);

  // Note: Removed auto-scroll on modal state changes to preserve user's scroll position
  // The previous logic was scrolling to bottom whenever viewEmojiModal or showMessageInfo changed

  useEffect(() => {
    if (isGerm) {
      setIsMe(DE.me);
    } else {
      setIsMe(EN.me);
    }
  }, [isGerm]);

  // In-chat search (mobile Pro) over the whole history: a background index of every page of
  // the chat (components/chat/chatSearchIndex). Results are ranked (word-start matches first,
  // then newest first); the header counts them "1/y" and ▲ / ▼ walk the ranked list.
  // getChat params besides chatId / page / limit (the index and the search jump's page loads).
  const searchPageParams = { userId: user?.id, translationLang };
  const historySearch = useChatSearchIndex({
    chatId: props.chat?.id || props.chat?.key,
    enabled: searchView,
    params: searchPageParams,
    secretKey,
    pageSize: 30,
  });
  const { mergeLoaded: mergeLoadedIntoSearch, rank: rankSearch } = historySearch;
  // The rendered thread feeds the index too (displayed translations, new and edited messages).
  useEffect(() => {
    if (searchView) mergeLoadedIntoSearch(flattenSections(activeChatSections), secretKey);
  }, [searchView, activeChatSections, secretKey, mergeLoadedIntoSearch]);
  const searchTerms = useMemo(() => (searchView ? parseSearchQuery(search) : []), [searchView, search]);
  const searchRanked = useMemo(
    () => (searchTerms.length ? rankSearch(search) : []),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchTerms, historySearch.version, rankSearch]
  );
  const searchHits = useMemo(() => searchRanked.map((r) => r.id), [searchRanked]);
  const searchTierById = useMemo(() => new Map(searchRanked.map((r) => [r.id, r.tier])), [searchRanked]);
  const searchCurrentIdRef = useRef(null);
  const searchPendingFirstRef = useRef(false);
  const searchJumpTokenRef = useRef(0);
  const [searchJumping, setSearchJumping] = useState(false);
  const topPageRef = useRef(1);
  topPageRef.current = topPage;
  const hasMoreTopRef = useRef(true);
  hasMoreTopRef.current = hasMoreTop;
  const activeChatSectionsRef = useRef(activeChatSections);
  activeChatSectionsRef.current = activeChatSections;
  const searchViewRef = useRef(false);
  searchViewRef.current = searchView;
  // After a jump to a far search result the thread is a window of the search index's rows:
  // { id, newestGI, oldestGI } = index positions of its newest / oldest message. null while the
  // thread is the live one (its bottom is the newest message). See jumpToSearchHit.
  const threadWindowRef = useRef(null);
  const windowSeqRef = useRef(0);
  const loadingNewerRef = useRef(false);
  // Thread swaps (window ↔ live) fade the messages out and in; the newest swap wins.
  const [threadSwapping, setThreadSwapping] = useState(false);
  const swapTokenRef = useRef(0);
  // After a swap: { chatId, target } = the message to center, or "bottom"; applied before paint.
  const pendingThreadScrollRef = useRef(null);
  // Album and document bubbles render several messages under the first one's id:
  // message id → the id its bubble carries.
  const rowIdByMessageId = useMemo(() => {
    const map = new Map();
    const rows = flattenSections(activeChatSections).filter((r) => r && r.id != null);
    rows.forEach((r) => map.set(String(r.id), String(r.id)));
    rows.forEach((r) => {
      const add = (id) => {
        if (id != null && !map.has(String(id))) map.set(String(id), String(r.id));
      };
      (Array.isArray(r.images) ? r.images : []).forEach((im) => add(im && im.id));
      (Array.isArray(r.documents) ? r.documents : []).forEach((d) => add(d && d.id));
    });
    return map;
  }, [activeChatSections]);
  const rowIdByMessageIdRef = useRef(rowIdByMessageId);
  rowIdByMessageIdRef.current = rowIdByMessageId;

  // A new term opens on its best result (as soon as there is one).
  useEffect(() => {
    if (!searchView) return;
    setSearchPos(0);
    searchCurrentIdRef.current = null;
    searchPendingFirstRef.current = true;
    searchJumpTokenRef.current += 1;
    setSearchJumping(false);
    scrolledToMessageRef.current = false;
  }, [search, searchView]);

  // Results grow while the index pages in: keep the selected result, or open the first one.
  useEffect(() => {
    if (!searchView) return;
    if (searchPendingFirstRef.current) {
      if (!searchHits.length) return;
      searchPendingFirstRef.current = false;
      searchCurrentIdRef.current = searchHits[0];
      setSearchPos(0);
      jumpToSearchHit(searchHits[0]);
      return;
    }
    const current = searchCurrentIdRef.current;
    if (current == null) return;
    const at = searchHits.indexOf(current);
    if (at >= 0) setSearchPos(at);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchHits, searchView]);

  useEffect(() => {
    let interval;
    if (audioRecording) {
      interval = setInterval(() => {
        setRecordingCounter(recordingCounter + 1);
      }, 1000);
    }

    if (!audioRecording) {
      setRecordingCounter(0);
      clearInterval(interval);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [audioRecording, recordingCounter]);

  useEffect(() => {
    if (refreshGroupMessages) {
      if (isInitialMount.current) {
        isInitialMount.current = false;
        if (refreshGroupMessages) {
          dispatch({ type: "REFRESH_GROUP_MESSAGES", payload: false });
        }
        return;
      }
      if (refreshGroupMessages) {
        setIsKeySetted(true);
      }
      dispatch({ type: "REFRESH_GROUP_MESSAGES", payload: false });
    }
  }, [refreshGroupMessages]);

  useEffect(() => {
    // Get chat ID (support both id and key for direct messages from LatestMessages)
    const chatId = props.chat?.id || props.chat?.key;
    if (!chatId) return;
    
    // Do not reset loaded state if isOpened flickers — that re-issues
    // /getChat on every parent render that momentarily clears the flag.
    if (props.chat?.isOpened === false) {
      return;
    }
    
    const isAlreadyLoaded = loadingStateRef.current.chatId === chatId && loadingStateRef.current.isLoaded;
    const hasNewScrollTarget = props.scrollToMessageId &&
      props.scrollToMessageId !== loadingStateRef.current.lastScrollTarget;

    if (isAlreadyLoaded && !hasNewScrollTarget) {
      return;
    }

    if (isAlreadyLoaded && hasNewScrollTarget) {
      forceReplaceMessagesRef.current = true;
      chatLoadingPopupShownAtRef.current = Date.now();
      setShowChatLoadingPopup(true);
    }
    
    const requestId = ++loadingStateRef.current.requestId;
    const initialPage = props.scrollToMessagePage || deeplinkData?.page_no || 1;
    
    loadingStateRef.current = { 
      chatId, 
      isLoaded: true, 
      requestId,
      lastScrollTarget: props.scrollToMessageId || null,
    };
    
    // Reset scroll-to-message flag for new chat
    scrolledToMessageRef.current = false;
    
    // Reset pagination state
    setPage(initialPage);
    setTopPage(initialPage);
    setBottomPage(initialPage);
    setCurrentPage(initialPage);
    setLoadedPages(new Set([initialPage]));
    setHasMoreTop(true);
    setHasMoreBottom(initialPage > 1);
    threadWindowRef.current = null;
    pendingThreadScrollRef.current = null;
    swapTokenRef.current += 1;
    setThreadSwapping(false);
    paginationRef.current.isLoadingTop = false;
    setIsLoadingTop(false);
    setIsLoadingBottom(false);
    if (!isChatFetchInFlight(chatId, translationLang)) {
      paginationRef.current.isApiCallInProgress = false;
    }
    
    // Show loading state - but NOT when coming from ToDo (ToDo has its own transition screen)
    // Use props.isFromTodo (passed directly) as primary check, fallback to deeplinkData
    const isFromTodo = props.isFromTodo || deeplinkData?.fromTodo;
    const hasScrollTarget = !!(props.scrollToMessageId || deeplinkData?.messageId);
    const cachedChat = (!hasScrollTarget && initialPage === 1)
      ? getCachedChat(chatId, translationLang)
      : null;
    const canPaintCache = !!(cachedChat?.rawMessages?.length);
    paintedFromCacheRef.current = canPaintCache;
    paintedFingerprintRef.current = canPaintCache
      ? messagesFingerprint(cachedChat.rawMessages)
      : "";
    setLoadedFromCache(canPaintCache);
    const skipLoader = isFromTodo || canPaintCache;
    setIsLoading(!skipLoader);
    setShowSkeleton(!skipLoader);
    setIsGettingChats(false);
    setIsContentReady(isFromTodo || canPaintCache);

    if (canPaintCache) {
      if (cachedChat.secretKey && !secretKeyRef.current) {
        secretKeyRef.current = cachedChat.secretKey;
        setSecretKey(cachedChat.secretKey);
        setIsSecretKey(1);
      }
      const cachedMessages = cachedChat.rawMessages.map((msg) => ({ ...msg, _page: 1 }));
      groupByDate(cachedMessages, chatId, 'initial');
    }
    
    // Show loading popup with slight delay - but NOT when from ToDo. The
    // delay lets fast (cached) responses skip the loader entirely; the
    // useEffect on isContentReady cancels this timer if the API resolves
    // before it fires.
    if (chatLoadingPopupShowTimerRef.current) {
      clearTimeout(chatLoadingPopupShowTimerRef.current);
      chatLoadingPopupShowTimerRef.current = null;
    }
    chatLoadingPopupShownAtRef.current = 0;
    if (!skipLoader && !isChatFetchInFlight(chatId, translationLang)) {
      chatLoadingPopupShowTimerRef.current = setTimeout(() => {
        chatLoadingPopupShowTimerRef.current = null;
        chatLoadingPopupShownAtRef.current = Date.now();
        setShowChatLoadingPopup(true);
      }, 50);
    }
    
    // Subscribe to socket in background (non-blocking). Subscribing marks
    // the chat read on the BE, so a hidden pane waits until it is shown.
    if (Socket?.on && paneActive) {
      _subsOnly();
    }
    
    // Restore in-flight outgoing media immediately so dropped images stay
    // visible if the user left before uploads finished.
    if (!canPaintCache) {
      setTempChatHistory((prev) =>
        applyPendingOutgoingToHistory(prev, chatId, formatDateWithLocale, [props.chat?.id, props.chat?.key])
      );
    }

    // Capture scrollToMessageId BEFORE calling _getMessages to avoid stale closure
    const capturedScrollToMessageId = props.scrollToMessageId;
    
    // Fetch messages immediately - SINGLE API CALL.
    // Success is handled by the isContentReady useEffect below; only the
    // error path needs an explicit popup hide.
    _getMessages(initialPage, 'initial', capturedScrollToMessageId).catch(() => {
      if (chatLoadingPopupShowTimerRef.current) {
        clearTimeout(chatLoadingPopupShowTimerRef.current);
        chatLoadingPopupShowTimerRef.current = null;
      }
      chatLoadingPopupShownAtRef.current = 0;
      setShowChatLoadingPopup(false);
    });
    
    // Safety timeout: hide popup after max 2 seconds even if promises don't resolve
    setTimeout(() => {
      setShowChatLoadingPopup(false);
    }, 2000);
  }, [props.chat?.id, props.chat?.isOpened, props.scrollToMessageId]);

  // List preview can update (latestMsg) while this thread is still showing a
  // stale cached page. If the preview message is not in history, refetch.
  useEffect(() => {
    if (!isContentReady || !props.chat?.id || !paneActive) return;
    const row = (activityMessages || []).find(
      (c) => String(c?.group?.id) === String(props.chat.id)
    );
    const expectId = listPreviewMessageId(row);
    if (!expectId) return;
    if (recoveredPreviewIdRef.current === `${props.chat.id}:${expectId}`) return;
    const entry = (tempChatHistoryRef.current || []).find((h) => idsMatch(h.id, props.chat.id));
    const already = entry?.data?.some((sec) =>
      (sec.items || []).some(
        (m) => idsMatch(m.id, expectId) || idsMatch(m.messageRequestId, expectId)
      )
    );
    if (already) {
      recoveredPreviewIdRef.current = `${props.chat.id}:${expectId}`;
      return;
    }
    recoveredPreviewIdRef.current = `${props.chat.id}:${expectId}`;
    paintedFromCacheRef.current = false;
    _getMessages(1, "initial");
  }, [isContentReady, activityMessages, props.chat?.id, paneActive]);

  // While its page is hidden (kept alive), the BE must not count this user as
  // live in the chat, or every incoming message is marked read. Leave the
  // room when hidden; re-subscribing on return marks read and clears badges.
  useEffect(() => {
    if (paneActiveRef.current === paneActive) return;
    paneActiveRef.current = paneActive;
    if (!(props.chat?.id || props.chat?.key)) return;
    if (paneActive) {
      if (Socket?.on) _subsOnly();
    } else {
      disConnect();
    }
  }, [paneActive]);

  useEffect(() => subscribeReceipts(Socket, receiptsRef.current, bumpReceipts), [Socket, bumpReceipts]);

  // Back from a reconnect or a new socket: join the chat room again (that also marks
  // read, like opening the chat) and take the ticks sent meanwhile from page 1.
  const rejoinRef = useRef(null);
  rejoinRef.current = (isNewSocket) => {
    const chatId = props.chat?.id || props.chat?.key;
    if (!chatId || !paneActiveRef.current || !Socket?.on) return;
    if (isNewSocket) _registerEVents();
    _subsOnly();
    fetchChatPage({ chatId, page: 1, limit: 30, userId: user?.id, translationLang, force: true })
      .then((res) => {
        if (receiptsRef.current.note("rows", res?.data?.chatHistory)) bumpReceipts();
      })
      .catch(() => {});
  };
  useEffect(() => onSocketBack(Socket, lastSocketRef, (isNew) => rejoinRef.current(isNew)), [Socket]);

  // Hide the loading popup as soon as content is ready. If the popup hasn't
  // appeared yet (fast API), cancel the deferred show-timer entirely so it
  // never flashes. If it has appeared, keep it visible for at least
  // MIN_VISIBLE_MS so the user doesn't see a sub-frame flicker.
  useEffect(() => {
    if (!isContentReady) return;
    if (chatLoadingPopupShowTimerRef.current) {
      clearTimeout(chatLoadingPopupShowTimerRef.current);
      chatLoadingPopupShowTimerRef.current = null;
    }
    const shownAt = chatLoadingPopupShownAtRef.current;
    if (!shownAt) {
      setShowChatLoadingPopup(false);
      return;
    }
    const MIN_VISIBLE_MS = 150;
    const elapsed = Date.now() - shownAt;
    const remaining = Math.max(0, MIN_VISIBLE_MS - elapsed);
    const t = setTimeout(() => {
      chatLoadingPopupShownAtRef.current = 0;
      setShowChatLoadingPopup(false);
    }, remaining);
    return () => clearTimeout(t);
  }, [isContentReady]);

  // ----- Scroll-to-bottom on initial load / chat switch -----
  // Fires ONLY when isContentReady flips to true or chatId changes.
  // Does NOT depend on tempChatHistory — pagination, socket messages, and emoji
  // updates are handled by useLayoutEffect (above) and handler.scrollToBottom.
  // A layout effect, so the first painted frame already shows the newest messages.
  useLayoutEffect(() => {
    const chatId = props.chat?.id || props.chat?.key;
    if (!chatId || !isContentReady) return;

    // Skip when there's a specific message to scroll to (deeplink / ToDo)
    if (props.scrollToMessageId || scrolledToMessageRef.current || deeplinkData?.messageId) {
      return;
    }

    const chatContainer = document.getElementById(`chat-sc-${chatId}`);
    if (!chatContainer) return;

    const releasePin = pinChatToBottom(chatContainer, initialScrollPhaseRef);

    // --- Image-load scroll after the pin ends (MutationObserver) ---
    const watchImage = (img) => {
      if (img.complete || img.dataset.scrollWatched) return;
      img.dataset.scrollWatched = '1';
      img.addEventListener('load', () => {
        if (!initialScrollPhaseRef.current && isNearBottom(chatContainer)) {
          chatContainer.scrollTop = chatContainer.scrollHeight;
        }
      }, { once: true });
    };

    chatContainer.querySelectorAll('img').forEach(watchImage);

    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.tagName === 'IMG') { watchImage(node); }
          else { node.querySelectorAll?.('img')?.forEach(watchImage); }
        }
      }
    });
    observer.observe(chatContainer, { childList: true, subtree: true });

    return () => {
      releasePin();
      observer.disconnect();
    };
  }, [props.chat?.id, props.chat?.key, isContentReady]);

  useEffect(() => {
    if (isKeySetted) {
      setIsKeySetted(false);
    }
  }, [isKeySetted, props.chat?.id, props.chat?.key]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isOutsideAllModals = Object.keys(emojiModal).every(chatId => {
        const ref = emojiRefs.current[chatId];
        return !ref || !ref.contains(event.target);
      });

      if (isOutsideAllModals && Object.keys(emojiModal).length > 0) {
        setEmojiModal({});
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [emojiModal]);

  useEffect(() => {
    let index = joinNowRoomWise.findIndex((room) => room.roomId === props.chat?.id)
    if (index !== -1) {
      if (joinNowRoomWise[index].status) {
        setIsCallRunning(true)
      }
    }
  }, [joinNowRoomWise, props.chat?.id]);
  
  // Track which chat we last reset state for, kept for parity with the
  // GroupConversation flow.
  useEffect(() => {
    const currentChatId = props.chat?.id;
    if (!currentChatId) return;
    if (currentChatId !== lastChatIdRef.current) {
      lastChatIdRef.current = currentChatId;
    }
  }, [props.chat?.id]);

  // Drive isVideoCallAllowed from the user profile (already in Redux). No
  // per-room API call is needed.
  useEffect(() => {
    setIsVideoCallAllowed(!!profile?.dmCallFeatureEnabled);
  }, [profile?.dmCallFeatureEnabled]);

  // Drive isCallRunning from the global runningCalls store, which is populated
  // once at app-start by /videochat/getRunningCalls and kept fresh by socket
  // events (videoCallStarted / videoCallEnded). This replaces the per-room
  // /videochat/get call that used to fire on every chat open.
  useEffect(() => {
    const chatId = props.chat?.id;
    if (!chatId) {
      setIsCallRunning(false);
      return;
    }
    const hasRunningCall = runningCalls.some(e => e.groupId === chatId);
    setIsCallRunning(hasRunningCall);
  }, [runningCalls, props.chat?.id]);

  useEffect(() => {
    if (allUsers?.length > 0) {
      setExistingUsers(allUsers);
    }
  }, [allUsers]);

  useEffect(() => {
    return () => {
      disConnect();
    };
  }, []);

  useEffect(() => {
    if (tempChatHistoryTEMP && tempChatHistoryTEMP.length > 0) {
      _mmmerg();
    }
  }, [tempChatHistoryTEMP]);

  // Effect to fetch auto-suggestions when last message changes
  useEffect(() => {
    const chatId = props.chat?.id;
    const chatData = tempChatHistory?.find((item) => item?.id === chatId)?.data || [];
    
    if (chatData.length === 0) {
      stopImageDescriptionWait();
      lastSuggestionMsgIdRef.current = null;
      setAutoSuggestions([]);
      autoSuggestionsRef.current = [];
      return;
    }
    
    const lastSection = chatData[chatData.length - 1];
    if (!lastSection?.items || lastSection.items.length === 0) {
      stopImageDescriptionWait();
      lastSuggestionMsgIdRef.current = null;
      setAutoSuggestions([]);
      autoSuggestionsRef.current = [];
      return;
    }
    
    const lastMessage = lastSection.items[lastSection.items.length - 1];
    const msgId = lastMessage.id || lastMessage.messageRequestId;
    if (imageDescWaitRef.current.msgId !== msgId) stopImageDescriptionWait();

    if (msgId && msgId === lastSuggestionMsgIdRef.current) return;
    
    if ((lastMessage.messageType === 'simple' || 
         lastMessage.messageType === 'image' ||
         (lastMessage.messageType === 'doc' && lastMessage.docFileSummary) ||
         (lastMessage.messageType === 'audio' && lastMessage.transcribedAudio)) && 
        lastMessage.senderId !== user?.id && 
        lastMessage.sender !== user?.id) {
      console.log('[SUGGESTION-FE] lastMessage type:', lastMessage.messageType, 'id:', lastMessage.id, 'imageDescription:', lastMessage.imageDescription ? lastMessage.imageDescription.substring(0, 60) + '...' : 'NONE');
      let messageText = lastMessage.messageType === 'audio' 
        ? lastMessage.transcribedAudio 
        : lastMessage.messageType === 'doc'
          ? lastMessage.docFileSummary
          : (lastMessage.message || '');
      if (secretKey) {
        try {
          const decrypted = decryptMessage(messageText, secretKey);
          if (decrypted) {
            messageText = decrypted;
          }
        } catch (e) {
          // Use original if decryption fails
        }
      }
      if (lastMessage.messageType === 'image') {
        if (lastMessage.imageDescription) {
          messageText = lastMessage.imageDescription;
          console.log('[SUGGESTION-FE] using imageDescription as messageText');
        } else {
          console.log('[SUGGESTION-FE] imageDescription not available yet, waiting...');
          setAutoSuggestionsLoading(true);
          autoSuggestionsLoadingRef.current = true;
          // If the description doesn't arrive in time, fetch anyway: the backend builds the
          // context from the stored chat, so the caption/placeholder is only a fallback.
          if (imageDescWaitRef.current.msgId !== msgId) {
            const caption = (messageText || '').replace(/<[^>]+>/g, '').trim();
            const imageChatId = lastMessage.id;
            imageDescWaitRef.current = {
              msgId,
              timer: setTimeout(() => {
                imageDescWaitRef.current = { msgId: null, timer: null };
                lastSuggestionMsgIdRef.current = msgId;
                fetchAutoSuggestions(caption || '[Shared a photo]', imageChatId);
              }, IMAGE_DESCRIPTION_WAIT_MS),
            };
          }
          return;
        }
      }
      const cleaned = (messageText || '').replace(/<br\s*[/]?>/gi, ' ').replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').trim();
      if (cleaned.length > 0) {
        const withoutEmoji = cleaned.replace(/[\p{Extended_Pictographic}\s]/gu, '');
        if (withoutEmoji.length === 0) {
          lastSuggestionMsgIdRef.current = msgId;
          setAutoSuggestions([]);
          autoSuggestionsRef.current = [];
          return;
        }
      }
      console.log('[SUGGESTION-FE] calling fetchAutoSuggestions with messageText:', messageText?.substring(0, 80), 'chatId:', lastMessage.id);
      lastSuggestionMsgIdRef.current = msgId;
      fetchAutoSuggestions(messageText, lastMessage.id);
    } else {
      lastSuggestionMsgIdRef.current = msgId;
      setAutoSuggestions([]);
      autoSuggestionsRef.current = [];
    }
  }, [tempChatHistory, props.chat?.id, secretKey]);

  // Effect to handle pending suggestion after loading completes. The popup closes even when the
  // request failed or returned fewer suggestions than the clicked chip.
  useEffect(() => {
    if (!autoSuggestionsLoading && pendingSuggestionIndex !== null) {
      const text = autoSuggestions[pendingSuggestionIndex];
      if (text) {
        setMessage(text);
        if (isComposerToolbarOpen && richEditorRef.current) {
          richEditorRef.current.innerHTML = composerMarkdownToHtml(text);
        }
      }
      setShowSuggestionLoadingPopup(false);
      setPendingSuggestionIndex(null);
    }
  }, [autoSuggestionsLoading, autoSuggestions, pendingSuggestionIndex]);

  useEffect(() => () => clearTimeout(imageDescWaitRef.current.timer), []);

  // ========== END OF HOOKS SECTION ==========
  // All hooks must be above this line. Everything below is regular code.
  
  // Function to fetch auto-suggestions from API
  const fetchAutoSuggestions = async (messageText, chatId) => {
    // No AI reply suggestions in Microsoft Teams chats.
    if (teamsInfoRef.current) return;
    if (!messageText || messageText.trim() === '') {
      setAutoSuggestions([]);
      autoSuggestionsRef.current = [];
      return;
    }
    
    setAutoSuggestionsLoading(true);
    autoSuggestionsLoadingRef.current = true;
    setAutoSuggestionsError(null);
    
    try {
      let messageArray = [];
      if (typeof messageText === 'string') {
        messageArray = [messageText.replace(/<br\s*[/]?>/gi, ' ').replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').trim()];
      } else if (Array.isArray(messageText)) {
        messageArray = messageText;
      }
      
      const response = await callAPI(
        '/message/generateSuggestionMessage',
        {},
        'POST',
        { message: messageArray, chat_id: chatId, group_id: props.chat?.group?.id || props.chat?.id }
      );
      
      if (response.data && response.data.suggestion && Array.isArray(response.data.suggestion)) {
        const newSuggestions = response.data.suggestion.slice(0, 3);
        setAutoSuggestions(newSuggestions);
        autoSuggestionsRef.current = newSuggestions;
      } else {
        setAutoSuggestions([]);
        autoSuggestionsRef.current = [];
      }
    } catch (error) {
      setAutoSuggestionsError(strings.suggestions_error || 'Failed to load suggestions');
      setAutoSuggestions([]);
      autoSuggestionsRef.current = [];
    } finally {
      setAutoSuggestionsLoading(false);
      autoSuggestionsLoadingRef.current = false;
    }
  };

  // Handle placeholder chip click - uses refs to avoid stale closure
  const handleSuggestionPlaceholderClick = (index) => {
    const currentSuggestions = autoSuggestionsRef.current;
    const isLoading = autoSuggestionsLoadingRef.current;
    
    if (isLoading) {
      setShowSuggestionLoadingPopup(true);
      setPendingSuggestionIndex(index);
    } else if (currentSuggestions.length > index) {
      const text = currentSuggestions[index];
      setMessage(text);
      if (isComposerToolbarOpen && richEditorRef.current) {
        richEditorRef.current.innerHTML = composerMarkdownToHtml(text);
      }
    }
  };

  // Get the last message from current chat to determine if suggestions should be shown
  const getLastMessageInfo = () => {
    const chatId = props.chat?.id;
    const chatData = tempChatHistory?.find((item) => item?.id === chatId)?.data || [];
    if (chatData.length === 0) return null;
    
    // Get last section and last item
    const lastSection = chatData[chatData.length - 1];
    if (!lastSection?.items || lastSection.items.length === 0) return null;
    
    const lastMessage = lastSection.items[lastSection.items.length - 1];
    return lastMessage;
  };

  // Determine if suggestions should be shown
  const shouldShowAutoSuggestions = () => {
    // No AI reply suggestions in Microsoft Teams chats.
    if (teamsInfoRef.current) return false;
    const lastMessage = getLastMessageInfo();
    if (!lastMessage) return false;

    if (lastMessage.isDeleted) return false;
    if (lastMessage.messageType === 'poll') return false;
    
    if (lastMessage.messageType !== 'simple' && 
        lastMessage.messageType !== 'image' &&
        !(lastMessage.messageType === 'audio' && lastMessage.transcribedAudio) &&
        !(lastMessage.messageType === 'doc' && lastMessage.docFileSummary)) return false;

    // Don't show if last message is only emoji (skip for audio with transcription and images)
    if (lastMessage.messageType !== 'audio' && lastMessage.messageType !== 'image' && isMessageEmojiOnly(lastMessage)) return false;

    // Only show if the last message is NOT from the current user
    if (lastMessage.senderId === user?.id || lastMessage.sender === user?.id) return false;

    // Don't show if in forward/delete/search mode
    if (forward || delMessage || searchView || audioRecording) return false;
    
    // Don't show if chat is view-only
    if (props.chat?.onlyView) return false;
    
    return true;
  };

  // For chats from Latest Messages or fullscreen mode (from profile), always show back arrow
  // For regular project chats, show back arrow below 1380px (use isWideScreen)
  const shouldShowBackArrow = props.isFromLatestMsg || isFullscreenMode ? true : !isWideScreen;
  
  // Regular const objects and functions
  const groupUnsubscribeObj = {
    // Socket routes are matched by pathname on the BE and must NOT carry the
    // dev "/api" prefix. Use SOCKET_BASE ("" in dev, absolute API_ROOT in
    // prod) — NOT API_ROOT — or the request hits a non-existent
    // "/api/group/.../unsubscribe" route. (Same reason the chat-open
    // subscribe below uses SOCKET_BASE; getting this wrong is exactly why
    // unread counters never cleared on web while mobile worked.)
    url: `${SOCKET_BASE}/group/${props.chat?.id}/unsubscribe`,
    method: "get",
    headers: {
      Authorization: `JWT ${$user.getToken()}`,
    },
    data: {
      // Removed building and viewByOwner - not needed for one-on-one chats
      userId: user?.id,
    },
  };


  // Toggle message expansion for ...Mehr feature
  const toggleMessageExpansion = (messageId) => {
    setExpandedMessages(prev => ({
      ...prev,
      [messageId]: !prev[messageId]
    }));
  };

  // Scroll chrome of the mobile Pro chat: the scroll-to-latest button (shows past 250px from the
  // bottom, hides under 35px; its counter resets when it hides) and the sticky day chip (the day
  // of the topmost visible message, hidden while that day's own chip is on screen).
  const updateScrollChrome = (container) => {
    if (!container) return;
    const fromBottom = container.scrollHeight - container.scrollTop - container.clientHeight;
    let nextFab = showScrollFabRef.current;
    if (fromBottom > 250) nextFab = true;
    else if (fromBottom < 35) nextFab = false;
    // A window (search jump) never holds the newest messages: the way back stays offered.
    if (threadWindowRef.current) nextFab = true;
    if (nextFab !== showScrollFabRef.current) {
      showScrollFabRef.current = nextFab;
      setShowScrollFab(nextFab);
      if (!nextFab) setAwayNewCount(0);
    }
    const top = container.getBoundingClientRect().top;
    let label = null;
    const sections = container.querySelectorAll(".chat-date-section");
    for (let i = 0; i < sections.length; i++) {
      const rect = sections[i].getBoundingClientRect();
      if (rect.bottom > top + 1) {
        const chip = sections[i].querySelector(".kjc-day__chip");
        const chipRect = chip ? chip.getBoundingClientRect() : null;
        if (chipRect && chipRect.top < top + 2) label = chip.textContent || null;
        break;
      }
    }
    setStickyDay((prev) => (prev === label ? prev : label));
  };

  // Scroll handler — rAF-throttled so it runs at most once per frame.
  // Uses fixed pixel thresholds (not percentages) for predictable pagination triggers.
  const PAGINATION_TRIGGER_PX = 600;
  const debouncedScrollHandler = (e) => {
    const target = e.target;
    if (scrollRafRef.current) return;
    scrollRafRef.current = requestAnimationFrame(() => {
      scrollRafRef.current = null;
      updateScrollChrome(target);
      if (initialScrollPhaseRef.current) return;
      const { scrollTop, scrollHeight, clientHeight } = target;
      if (scrollHeight <= clientHeight) return;
      const pg = paginationRef.current;
      const distFromTop = scrollTop;
      const distFromBottom = scrollHeight - scrollTop - clientHeight;

      if (distFromTop < PAGINATION_TRIGGER_PX && hasMoreTop && !pg.isLoadingTop && !pg.isApiCallInProgress && !scrolledToMessageRef.current) {
        fetchMoreData(props.chat?.id, 'top');
      } else if (distFromBottom < PAGINATION_TRIGGER_PX && hasMoreBottom && !pg.isLoadingTop && !pg.isApiCallInProgress && (currentPage > 1 || threadWindowRef.current) && !scrolledToMessageRef.current) {
        fetchMoreData(props.chat?.id, 'bottom');
      }
    });
  };

  const onMentionSelect = (mention) => {
    if (isComposerToolbarOpen && mentionCursorRef.current) {
      const editor = richEditorRef.current;
      if (editor) {
        const { node, offset, atIndex } = mentionCursorRef.current;
        if (node && node.parentNode && editor.contains(node)) {
          const before = node.textContent.substring(0, atIndex);
          const after = node.textContent.substring(offset);
          const mentionSpan = document.createElement("span");
          mentionSpan.className = "mention-tag";
          mentionSpan.setAttribute("data-mention-id", mention.id);
          mentionSpan.setAttribute("data-mention-name", mention.name);
          mentionSpan.contentEditable = "false";
          mentionSpan.textContent = `@${mention.name}`;
          const parent = node.parentNode;
          const beforeText = document.createTextNode(before);
          const afterText = document.createTextNode("\u00A0" + after);
          parent.insertBefore(beforeText, node);
          parent.insertBefore(mentionSpan, node);
          parent.insertBefore(afterText, node);
          parent.removeChild(node);
          const sel = window.getSelection();
          const newRange = document.createRange();
          newRange.setStart(afterText, 1);
          newRange.collapse(true);
          sel.removeAllRanges();
          sel.addRange(newRange);
          const md = getRichEditorContent();
          setMessage(md);
        }
      }
      mentionCursorRef.current = null;
    } else {
      const mentionText = `@[${mention.name}](${mention.id})`;
      const updatedContent = message.replace(`@${mentionInput}`, mentionText);
      setMessage(updatedContent);
    }
    setMentionInput("");
    setShowSuggestions(false);
  };

  const showLocationDialog = () => {
    setShow(true);
    setFloatingAction(false);
  };
  const hideLocationDialog = () => setShow(false);

  const setExistingUsers = async (allUsers) => {
    // For one-on-one chats, use chatDetails.users instead of props.members
    let allCopy = [...new Set(chatDetails?.users || [])];
    let already = []; // Removed buildingMembers - not needed for one-on-one chats
    allCopy = allCopy.filter(
      (e) => (e.isActive || !e.hasOwnProperty("isActive")) && !e.isLeaved
    );
    for (let i = 0; i < already.length; i++) {
      let inx = allCopy.findIndex((e) => e.id == already[i]["id"]);
      if (inx !== -1) allCopy.splice(inx, 1);
    }
    allCopy = [...allCopy, ...allUsers];
    const arr = await _.uniqBy(
      allCopy.map((user) => {
        return { name: user.lastName.trim()[0].toUpperCase() };
      }),
      "name"
    );
    const updatedArr = _.sortBy(arr, ["name"]);
    const usersList = updatedArr.map((a) => {
      a.names = allCopy.filter(
        (u) => u.lastName.trim()[0].toUpperCase() === a.name
      );
      return a;
    });
    setUsers(usersList);
  };

  const getDetails = async (chatId) => {
    try {
      const id = chatId;
      if (!id || !user) {
        return;
      }
      
      // Mark this chatId as the one we're currently fetching
      currentFetchingChatIdRef.current = id;
      
      const { data } = await callAPI(`/group/${id}/info`, {}, "GET");
      
      // Verify this is still the current room before updating state
      // This prevents race conditions where a user switches rooms quickly
      if (currentFetchingChatIdRef.current !== id || props.chat?.id !== id) {
        // User switched rooms, ignore this response
        return;
      }
      
        if (data.status) {
        applyTeamsGroupInfoRef.current(data.groupInfo);
        const teamsNow = teamsChatFrom(data.groupInfo, props.chat);
        // Ensure isEmailAllowed is a boolean, not an object
        setIsEmailAllowed(Boolean(data.groupInfo.emailNotification))
        const groupUsers = Array.isArray(data.groupInfo.users) ? data.groupInfo.users : [];
        let mems = [
          ...groupUsers.filter(
            (u) => u.id !== user?.id && !u.isLeave
          ),
        ];
        mems = mems.map((e) => {
          return { ...e, name: e.fullName, display: e.fullName };
        });
        let xcx = [...mems];
        // Microsoft Teams chats mention people as they are; Teams has no "@All".
        if (mems.length > 0 && !teamsNow) {
          xcx.unshift({
            name: strings.All,
            display: strings.All,
            id: "idall12322",
            type: "All",
          });
        }
        setMentionSuggestions(teamsNow ? teamsMentionSuggestions(xcx) : [...xcx]);
        // For one-on-one chats, use chatDetails.users instead of props.members
        let allCopy = [...new Set(chatDetails?.users || [])];
        let already = [...mems];
        allCopy = allCopy.filter(
          (e) => (e.isActive || !e.hasOwnProperty("isActive")) && !e.isLeaved
        );
        for (let i = 0; i < already.length; i++) {
          let inx = allCopy.findIndex((e) => e.id == already[i]["id"]);
          if (inx !== -1) allCopy.splice(inx, 1);
        }
        // Teams people have no last name (lastName ''): their first letter comes from the name.
        const letterOf = (u) => String((u && (u.lastName || u.firstName || u.fullName)) || "?").trim().charAt(0).toUpperCase() || "?";
        const arr = await _.uniqBy(
          allCopy.map((user) => {
            return { name: letterOf(user) };
          }),
          "name"
        );
        const updatedArr = _.sortBy(arr, ["name"]);
        const usersList = updatedArr.map((a) => {
          a.names = allCopy.filter(
            (u) => letterOf(u) === a.name
          );
          return a;
        });
        setUsers(usersList);
        // Removed setBuildingMembers and setIsAdmin - not needed for one-on-one chats
        
        // Build chatDetails with only the properties we actually use in the component
        // This prevents empty objects from being included and causing React render errors
        // Ensure all values are primitives or arrays, never empty objects
        
        // For one-on-one chats, get the other user's details (including isBlock status)
        const otherUser = groupUsers.find(u => u.id !== user?.id);
        const selfChat = Boolean(
          data.groupInfo.isSelfChat ||
          props.chat?.isSelfChat ||
          props.chat?.group?.isSelfChat
        );
        
        const tmmpp = {
          id: data.groupInfo.id || null,
          name: typeof data.groupInfo.name === 'string' ? data.groupInfo.name : '',
          users: Array.isArray(already) ? already : [],
          isInternal: Boolean(data.groupInfo.isInternal) || selfChat,
          isLeave: Boolean(data.groupInfo.isLeave),
          emailNotification: Boolean(data.groupInfo.emailNotification),
          isOneToOne: Boolean(data.groupInfo.isOneToOne) || selfChat,
          isSelfChat: selfChat,
          defaultChatGroup: Boolean(data.groupInfo.defaultChatGroup),
          avatar: typeof data.groupInfo.avatar === 'string' ? data.groupInfo.avatar : null,
          isBlock: otherUser ? Boolean(otherUser.isBlock) : false,
          otherUserId: otherUser ? otherUser.id : null,
          // Header (mobile Pro): the other person's photo, name and presence.
          otherUserAvatar: otherUser && typeof otherUser.avatar === 'string' ? otherUser.avatar : null,
          otherUserName: otherUser && typeof otherUser.fullName === 'string' ? otherUser.fullName : '',
          isOnline: Boolean(otherUser && (otherUser.isOnline === true || otherUser.isOnline === 'true')),
          lastOnlineAt: otherUser && otherUser.lastOnlineAt ? otherUser.lastOnlineAt : null,
        };
        
        // Only include building/room if they exist, are objects, and have keys
        if (data.groupInfo.building && typeof data.groupInfo.building === 'object' && !Array.isArray(data.groupInfo.building) && Object.keys(data.groupInfo.building).length > 0) {
          tmmpp.building = data.groupInfo.building;
        }
        if (data.groupInfo.room && typeof data.groupInfo.room === 'object' && !Array.isArray(data.groupInfo.room) && Object.keys(data.groupInfo.room).length > 0) {
          tmmpp.room = data.groupInfo.room;
        }
        
        // Double-check before setting state
        if (props.chat?.id === id && currentFetchingChatIdRef.current === id) {
          setChatDetails(tmmpp);
          setIsChatDetailsLoaded(true);
          setUnavailableMembers(Array.isArray(data.groupInfo.unavailableMembers) ? data.groupInfo.unavailableMembers : []);
          setChatsHiddenMembers(Array.isArray(data.groupInfo.chatsHiddenMembers) ? data.groupInfo.chatsHiddenMembers : []);
          // For chatDetailsX, include all safe properties from groupInfo
          // Ensure all values are primitives or arrays, never empty objects
          const tmmppx = {
            id: data.groupInfo.id || null,
            name: typeof data.groupInfo.name === 'string' ? data.groupInfo.name : '',
            users: groupUsers,
            isInternal: Boolean(data.groupInfo.isInternal) || selfChat,
            isLeave: Boolean(data.groupInfo.isLeave),
            emailNotification: Boolean(data.groupInfo.emailNotification),
            isOneToOne: Boolean(data.groupInfo.isOneToOne) || selfChat,
            isSelfChat: selfChat,
            defaultChatGroup: Boolean(data.groupInfo.defaultChatGroup),
            avatar: typeof data.groupInfo.avatar === 'string' ? data.groupInfo.avatar : null,
          };
          setChatDetailsX(tmmppx);
          setLeaved(data.groupInfo.isLeave);
        }
      }
    } catch (e) {
      console.error(e);
      // Reset the ref on error
      if (currentFetchingChatIdRef.current === chatId) {
        currentFetchingChatIdRef.current = null;
      }
    }
  };

  const handleTranslateMessage = (chatMessage, id) => {
    let tempChatIndex = tempChatHistory?.findIndex((item) => item.id === id);
    if (tempChatIndex > -1) {
      tempChatHistory[tempChatIndex].data = tempChatHistory[
        tempChatIndex
      ].data.map((chat) => {
        chat.items.map((c) => {
          if (c.id === chatMessage.id) {
            c.originalMessage = chatMessage.originalMessage;
            c.messageLng = chatMessage.messageLng;
            c.message = chatMessage.message;
          }
          return c;
        });
        return chat;
      });
    }
    setTempChatHistory(tempChatHistory);
    setTriggerTranslate(true);
  };
  const handleTranslate = (chat) => {
    setChatMessage(chat);
    setTranslateDialog(true);
  };

  const getTranslate = async (chat, lang) => {
    const sk = secretKeyRef.current || secretKey;
    const langs = autoTransLangsRef.current;
    const raw = chat?.message;
    if (!raw) return raw;
    let message = raw;
    // Only decrypt real ciphertext — never run AES on plaintext.
    if (typeof raw === 'string' && raw.startsWith('U2FsdGVkX1')) {
      if (!sk) return raw;
      message = decryptMessage(raw, sk);
      if (!message) return raw;
    }
    // Determine effective language for gating
    let effectiveLang = chat?.detectedMessageLanguage;
    if (!effectiveLang) {
      effectiveLang = detectLanguageClient(message);
    }
    if (langs?.length > 0 && !shouldAutoTranslateFromSender(effectiveLang, lang, langs)) {
      return raw;
    }
    if (isUntranslatableText(message)) return raw;
    try {
      const translated = await translateMessageContent(message, lang);
      if (!translated || translated === message || translated.trim() === message.trim()) return raw;
      return (sk && raw.startsWith('U2FsdGVkX1')) ? encryptMessage(translated, sk) : translated;
    } catch (e) {
      return raw;
    }
  };

  const backgroundTranslateMessages = async (chatId, lang, sectionsData) => {
    const taskId = ++backgroundTranslationIdRef.current;
    const sk = secretKeyRef.current || secretKey;

    const pendingMessages = [];
    for (const section of sectionsData) {
      for (const msg of section.items) {
        if (msg.translationPending) {
          pendingMessages.push(msg);
        }
      }
    }
    if (pendingMessages.length === 0) return;
    console.log('[autoTranslate] start', { chatId, lang, pending: pendingMessages.length, hasKey: !!sk });

    // Collect all translatable texts and batch-translate in one API call.
    // This pre-warms the in-memory cache so that the per-message processing
    // below hits the cache and makes zero individual /message/translate calls.
    const batchItems = [];
    for (const msg of pendingMessages) {
      const msgId = msg.id || msg.messageRequestId;

      let plainText;
      if (msg.message?.startsWith('U2FsdGVkX1')) {
        plainText = sk ? decryptMessage(msg.message, sk) : null;
      } else {
        plainText = msg.message;
      }
      if (plainText) {
        batchItems.push({ id: `m-${msgId}`, message: plainText, isMarkdown: true });
      }

      if (msg.inReplyTo?.message && msg.senderId !== user?.id) {
        let replyText;
        if (sk) {
          replyText = decryptMessage(msg.inReplyTo.message, sk);
        } else if (!msg.inReplyTo.message.startsWith('U2FsdGVkX1')) {
          replyText = msg.inReplyTo.message;
        }
        if (replyText) {
          batchItems.push({ id: `r-${msgId}`, message: replyText, isMarkdown: true });
        }
      }

      if (msg.transcribedAudio) {
        batchItems.push({ id: `a-${msgId}`, message: msg.transcribedAudio });
      }
      if (msg.docFileSummary) {
        batchItems.push({ id: `d-${msgId}`, message: msg.docFileSummary });
      }
    }

    if (batchItems.length > 0 && taskId === backgroundTranslationIdRef.current) {
      await translateMessagesBatch(batchItems, lang);
    }
    if (taskId !== backgroundTranslationIdRef.current) return;

    // All texts are now cached from the batch call above — these individual
    // calls will resolve from cache without making any API requests.
    // Collect all results first, then apply in a SINGLE state update to
    // avoid N re-renders that cause bumpy scrolling.
    const allResults = await Promise.all(pendingMessages.map(async (msg) => {
      if (taskId !== backgroundTranslationIdRef.current) return null;
      const msgId = msg.id || msg.messageRequestId;
      const result = {};

      result.message = await getTranslate(msg, lang);

      if (msg.inReplyTo?.message && msg.senderId !== user?.id) {
        result.inReplyToMessage = await getTranslate(msg.inReplyTo, lang);
      }

      if (msg.transcribedAudio) {
        const translatedAudio = preserveOriginalFormatting(
          await getTranslateText(msg.transcribedAudio, lang),
          msg.transcribedAudio
        );
        if (translatedAudio && translatedAudio.trim() !== msg.transcribedAudio.trim()) {
          result.originalTranscribedAudio = msg.transcribedAudio;
          result.translatedAudio = translatedAudio;
        }
      }

      if (msg.docFileSummary) {
        const translatedDoc = await getTranslateText(msg.docFileSummary, lang);
        if (translatedDoc && translatedDoc.trim() !== msg.docFileSummary.trim()) {
          result.originalDocFileSummary = msg.docFileSummary;
          result.translatedDocSummary = translatedDoc;
        }
      }

      return { msgId, result };
    }));

    if (taskId !== backgroundTranslationIdRef.current) return;

    const resultMap = new Map();
    for (const entry of allResults) {
      if (entry) resultMap.set(entry.msgId, entry.result);
    }

    // Apply after a tick so groupByDate's setTempChatHistory has committed.
    const applyTranslations = (attempt = 0) => {
      const hasEntry = (tempChatHistoryRef.current || []).some((entry) => entry.id === chatId);
      if (!hasEntry) {
        if (attempt < 20) {
          setTimeout(() => applyTranslations(attempt + 1), 50);
        }
        return;
      }
      setTempChatHistory((prev) => prev.map((entry) => {
        if (entry.id !== chatId) return entry;
        return {
          ...entry,
          data: entry.data.map((section) => ({
            ...section,
            items: section.items.map((item) => {
              const itemId = item.id || item.messageRequestId;
              const result = resultMap.get(itemId);
              if (!result) return item;
              const updated = { ...item, message: result.message, translationPending: false };
              if (result.inReplyToMessage !== undefined) {
                updated.inReplyTo = { ...item.inReplyTo, message: result.inReplyToMessage };
              }
              if (result.translatedAudio !== undefined) {
                updated.originalTranscribedAudio = result.originalTranscribedAudio;
                updated.transcribedAudio = result.translatedAudio;
              }
              if (result.translatedDocSummary !== undefined) {
                updated.originalDocFileSummary = result.originalDocFileSummary;
                updated.docFileSummary = result.translatedDocSummary;
              }
              return updated;
            }),
          })),
        };
      }));
    };
    console.log('[autoTranslate] apply', { chatId, lang, results: resultMap.size });
    setTimeout(() => applyTranslations(0), 0);
  };


  const _mmmerg = async () => {
    const newEntry = tempChatHistoryTEMP[0];
    if (!newEntry?.id) return;

    // All grouping/ordering is handled by buildRenderableSections at render time.
    // This prevents double-processing and ordering conflicts.
    const updatedEntry = { ...newEntry, data: [...newEntry.data] };
    
    // Check if we need to preserve scroll position
    const shouldPreserve = scrollPreservationRef.current.isPreserving && 
                          scrollPreservationRef.current.chatId === newEntry.id;
    
    // MERGE with existing tempChatHistory - preserve local messages that may not be in API response yet
    setTempChatHistory(prev => {
      const existingIndex = prev.findIndex(item => item.id === updatedEntry.id);
      if (existingIndex > -1) {
        const updated = [...prev];
        const existingEntry = updated[existingIndex];
        
        // Merge messages from existing entry that might not be in the updated entry
        // This preserves locally added messages (like images just sent)
        const mergedData = [...updatedEntry.data];
        
        // For each existing date section, check for messages not in the updated entry
        existingEntry.data.forEach(existingSection => {
          const matchingSection = mergedData.find(s => s.createdAt === existingSection.createdAt);
          if (matchingSection) {
            // Add any messages from existing section that aren't in the matching section
            existingSection.items.forEach(existingMsg => {
              const msgExists = matchingSection.items.some(m => isSameChatMessage(existingMsg, m));
              if (!msgExists && (existingMsg.id || existingMsg.messageRequestId)) {
                // Message exists locally but not in API response - preserve it
                // This includes newly sent messages that only have messageRequestId (no id yet)
                matchingSection.items.push(existingMsg);
              }
            });
            // Sort by createdAtTs/orderHint to maintain stable order (multiple images don't jump)
            matchingSection.items.sort((a, b) => {
              const at = a?.createdAtTs ?? (a?.createdAt ? new Date(a.createdAt).getTime() : 0);
              const bt = b?.createdAtTs ?? (b?.createdAt ? new Date(b.createdAt).getTime() : 0);
              if (at !== bt) return at - bt;
              const ah = a?.orderHint ?? 0;
              const bh = b?.orderHint ?? 0;
              if (ah !== bh) return ah - bh;
              const aid = a?.id || a?.messageRequestId || "";
              const bid = b?.id || b?.messageRequestId || "";
              return (aid || "").toString().localeCompare((bid || "").toString());
            });
          } else {
            // Entire date section doesn't exist in updated entry - add it
            mergedData.push(existingSection);
          }
        });
        
        // Sort date sections
        mergedData.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
        const withPending = injectPendingOutgoing(
          updatedEntry.id,
          mergedData,
          formatDateWithLocale,
          [props.chat?.id, props.chat?.key]
        );
        
        updated[existingIndex] = { ...updatedEntry, data: withPending };
        return updated;
      }
      const seeded = injectPendingOutgoing(
        updatedEntry.id,
        updatedEntry.data,
        formatDateWithLocale,
        [props.chat?.id, props.chat?.key]
      );
      return upsertChatHistory(prev, updatedEntry.id, seeded, [props.chat?.id, props.chat?.key]);
    });
    
    // CSS overflow-anchor: auto handles scroll preservation automatically
    // Just reset the preservation flag
    if (shouldPreserve) {
      scrollPreservationRef.current.isPreserving = false;
    }
  };

  const translateMessagesInBackground = async (chatId, lang) => {
    try {
      const sk = secretKeyRef.current || secretKey;
      const langs = autoTransLangsRef.current;
      const chatEntry = tempChatHistoryRef.current?.find(e => e.id === chatId);
      if (!chatEntry?.data) return;

      const pending = [];
      for (const section of chatEntry.data) {
        for (const msg of (section.items || [])) {
          if (msg.translationPending) pending.push(msg);
        }
      }
      console.log('[autoTranslate] background start', { chatId, lang, pending: pending.length, hasKey: !!sk });
      if (pending.length === 0) return;

      const batchItems = [];
      const skippedMsgIds = new Set();
      for (const msg of pending) {
        const msgId = msg.id || msg.messageRequestId;
        let plainText = null;
        try {
          if (typeof msg.message === 'string' && msg.message.startsWith('U2FsdGVkX1')) {
            plainText = sk ? decryptMessage(msg.message, sk) : null;
          } else {
            plainText = msg.message;
          }
        } catch (e) { /* decryption error — skip */ }
        if (plainText) {
          if (isUntranslatableText(plainText)) {
            skippedMsgIds.add(msgId);
            continue;
          }
          if (!msg.detectedMessageLanguage && langs?.length > 0) {
            const detected = detectLanguageClient(plainText);
            if (detected && detected !== lang && !shouldAutoTranslateFromSender(detected, lang, langs)) {
              skippedMsgIds.add(msgId);
              continue;
            }
          }
          batchItems.push({ id: `m-${msgId}`, message: plainText, isMarkdown: true });
        }
        if (msg.inReplyTo?.message && msg.senderId !== user?.id) {
          try {
            let replyText;
            if (typeof msg.inReplyTo.message === 'string' && msg.inReplyTo.message.startsWith('U2FsdGVkX1')) {
              replyText = sk ? decryptMessage(msg.inReplyTo.message, sk) : null;
            } else {
              replyText = msg.inReplyTo.message;
            }
            if (replyText) batchItems.push({ id: `r-${msgId}`, message: replyText, isMarkdown: true });
          } catch (e) { /* skip */ }
        }
      }

      if (batchItems.length > 0) {
        try {
          await translateMessagesBatch(batchItems, lang);
        } catch (e) {
          console.warn('[autoTranslate] batch failed', e?.message || e);
        }
      }

      const translatedMap = new Map();
      await Promise.all(pending.map(async (msg) => {
        const msgId = msg.id || msg.messageRequestId;
        if (skippedMsgIds.has(msgId)) return;
        try {
          const translated = await getTranslate(msg, lang);
          if (translated && translated !== msg.message) {
            const entry = { message: translated };
            if (msg.inReplyTo?.message && msg.senderId !== user?.id) {
              const trReply = await getTranslate(msg.inReplyTo, lang);
              if (trReply && trReply !== msg.inReplyTo.message) {
                entry.inReplyTo = { ...msg.inReplyTo, message: trReply };
              }
            }
            translatedMap.set(msgId, entry);
          }
        } catch (e) {
          console.warn('[autoTranslate] single failed', msgId, e?.message || e);
        }
      }));

      console.log('[autoTranslate] background done', { translated: translatedMap.size, skipped: skippedMsgIds.size, total: pending.length });

      setTempChatHistory(prev => prev.map(entry => {
        if (entry.id !== chatId) return entry;
        return {
          ...entry,
          data: entry.data.map(section => ({
            ...section,
            items: section.items.map(msg => {
              const key = msg.id || msg.messageRequestId;
              const tr = translatedMap.get(key);
              if (!tr) return msg.translationPending ? { ...msg, translationPending: false } : msg;
              return { ...msg, ...tr, translationPending: false };
            }),
          })),
        };
      }));
    } catch (e) {
      console.error('[autoTranslate] background error', e);
    }
  };

  const groupByDate = (chat, chatId, direction = 'initial') => {
    setIsGettingChats(false);
    const lang = translationLang;
    let chatData = (chat || []).map((message) => {
      // Compare as strings — API ids are sometimes number vs string.
      const isIncoming = String(message?.senderId ?? '') !== String(user?.id ?? '');

      const { translatedMessage: _tm, translatedAudio: _ta, ...messageWithoutServerTranslations } = message;
      const sk = secretKeyRef.current || secretKey;

      let serverTranslationDiffers = false;
      let serverTranslatedMsg = _tm;
      if (isIncoming && _tm) {
        const decryptedOriginal = sk ? decryptMessage(message.message, sk) : message.message;
        // Don't let the translation introduce bold/strikethrough that the
        // original message didn't have (keep the font style unchanged).
        const cleanedTm = preserveOriginalFormatting(_tm, decryptedOriginal);
        if (decryptedOriginal) {
          const strip = (s) => s.replace(/<[^>]+>/g, '').replace(/&\w+;/g, '').replace(/[*~_`#\\\-[\](){}|!+]/g, '').replace(/\s+/g, ' ').trim();
          serverTranslationDiffers = strip(cleanedTm) !== strip(decryptedOriginal);
        }
        serverTranslatedMsg = sk ? encryptMessage(cleanedTm, sk) : cleanedTm;
      }

      // Only treat a server translation as authoritative when it actually
      // differs. Identical/stale ChatTranslation rows must not block client retry.
      // translatedAudio alone must not suppress text translation either.
      let effectiveDetectedLang = message.detectedMessageLanguage;
      const langs = autoTransLangsRef.current;
      const plainForDetection = sk && message.message && typeof message.message === 'string' && message.message.startsWith('U2FsdGVkX1')
        ? decryptMessage(message.message, sk)
        : message.message;
      if (!effectiveDetectedLang && isIncoming && plainForDetection) {
        const clientDetected = detectLanguageClient(plainForDetection);
        if (clientDetected) {
          effectiveDetectedLang = clientDetected;
        }
      }
      const langAllowed = shouldAutoTranslateFromSender(effectiveDetectedLang, lang, langs);
      const hasUsableServerTranslation = isIncoming && !!_tm && serverTranslationDiffers && langAllowed;
      const textUntranslatable = !!(plainForDetection && isUntranslatableText(plainForDetection));
      const hasAudioToTranslate = message?.messageType === 'audio' && !!message?.transcribedAudio;
      const needsTranslation =
        isIncoming &&
        ((!!message?.message && !textUntranslatable) || hasAudioToTranslate) &&
        message?.messageType !== "poll" &&
        !hasUsableServerTranslation &&
        langAllowed;

      const processedMessage = {
        ...messageWithoutServerTranslations,
        originalMessage: message.message,
        messageLng: props.language ? props.language : "en",
        inReplyTo: { ...message.inReplyTo },
        message: hasUsableServerTranslation && serverTranslatedMsg ? serverTranslatedMsg : message?.message,
        detectedMessageLanguage: effectiveDetectedLang || message.detectedMessageLanguage,
        translationPending: needsTranslation,
      };

      // Audio transcript translation is independent of the text-message
      // translation: an audio-only message has no `message` text, so
      // `serverTranslationDiffers` (computed from `_tm`) is always false for it.
      // Apply the server-translated transcript whenever it exists and differs.
      if (_ta && processedMessage.transcribedAudio && _ta.trim() !== message.transcribedAudio?.trim()) {
        processedMessage.originalTranscribedAudio = message.transcribedAudio;
        processedMessage.transcribedAudio = preserveOriginalFormatting(_ta, message.transcribedAudio);
      }

      if (processedMessage.messageType === 'audio' && !processedMessage.transcribedAudio) {
        processedMessage.transcriptionPending = true;
      }
      
      if (processedMessage.isForward && processedMessage.images && processedMessage.images.length > 1) {
        processedMessage.isMultiples = true;
        processedMessage.count = processedMessage.images.length;
      }
      
      return processedMessage;
    });

    chatData.forEach(msg => {
      if (msg.messageType === 'audio' && !msg.transcribedAudio && msg.fileUrl) {
        fetchTranscriptForIncoming({ ...msg, groupId: msg.groupId || chatId });
      }
    });

    // Optimize grouping - no need for await on synchronous operations
    const grouping = _.groupBy(chatData, (element) =>
      formatDateWithLocale(element.createdAt)
    );

    // Disable animation for older messages (pages > 1) - they should appear instantly
    // Only animate initial page load (direction === 'initial')
    const shouldSkipAnimation = direction !== 'initial';

    let sections = _.map(grouping, (items, createdAt) => ({
      createdAt: createdAt,
      // Sort items oldest first using createdAtTs and orderHint to preserve gallery→text ordering
      items: [...items].sort((a, b) => {
        const at = a.createdAtTs ?? (a.createdAt ? new Date(a.createdAt).getTime() : 0);
        const bt = b.createdAtTs ?? (b.createdAt ? new Date(b.createdAt).getTime() : 0);
        if (at !== bt) return at - bt;
        const ah = a.orderHint ?? 0;
        const bh = b.orderHint ?? 0;
        if (ah !== bh) return ah - bh;
        const aid = a.id || a.messageRequestId || "";
        const bid = b.id || b.messageRequestId || "";
        return aid.localeCompare(bid);
      }).map(item => ({
        ...item,
        // Mark messages from page 2+ to skip animation
        skipAnimation: shouldSkipAnimation
      })),
      // Skip animation for sections loaded from page 2+
      skipAnimation: shouldSkipAnimation,
    }));
    
    sections = _.orderBy(
      sections,
      [
        function (object) {
          return new Date(object.createdAt);
        },
      ],
      ["asc"]
    );

    const extraChatKeys = [props.chat?.id, props.chat?.key];
    const sortSectionItems = (section) => {
      section.items.sort((a, b) => {
        const at = a?.createdAtTs ?? (a?.createdAt ? new Date(a.createdAt).getTime() : 0);
        const bt = b?.createdAtTs ?? (b?.createdAt ? new Date(b.createdAt).getTime() : 0);
        if (at !== bt) return at - bt;
        const ah = a?.orderHint ?? 0;
        const bh = b?.orderHint ?? 0;
        if (ah !== bh) return ah - bh;
        const aid = a?.id || a?.messageRequestId || "";
        const bid = b?.id || b?.messageRequestId || "";
        return (aid || "").toString().localeCompare((bid || "").toString());
      });
    };
    const commitSections = (dataToStore) => {
      const finalData = injectPendingOutgoing(chatId, dataToStore, formatDateWithLocale, extraChatKeys);
      finalData.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
      finalData.forEach(sortSectionItems);
      if (direction === 'top') {
        const chatContainer = document.getElementById(`chat-sc-${chatId}`);
        if (chatContainer) {
          scrollPreservationRef.current = {
            isPreserving: true,
            oldScrollTop: chatContainer.scrollTop,
            oldScrollHeight: chatContainer.scrollHeight,
            chatId: chatId
          };
        }
      }
      setTempChatHistory((prev) => upsertChatHistory(prev, chatId, finalData, extraChatKeys));
    };

    if (sections?.length > 0 || hasPendingOutgoing(chatId, extraChatKeys)) {
      // The ref, not the render's state: this runs after an await (and the in-chat search loads
      // many pages from one stale closure), so the state copy would drop pages loaded meanwhile.
      const currentHistory = tempChatHistoryRef.current || [];
      let tempChatIndex = findChatHistoryIndex(currentHistory, chatId, extraChatKeys);

      if (tempChatIndex > -1) {
        let existingData = [...currentHistory[tempChatIndex].data];
        let newData;

        if (forceReplaceMessagesRef.current) {
          newData = [...sections];
          forceReplaceMessagesRef.current = false;
        } else if (direction === 'top') {
          newData = [...sections, ...existingData];
        } else if (direction === 'initial') {
          const hasExistingMessages = existingData.length > 0;
          if (hasExistingMessages) {
            // Older messages should appear above (before) the newest message
            newData = [...sections, ...existingData];
          } else {
            // First load - replace entirely
            newData = [...sections];
          }
        } else {
          // Bottom direction - append
          newData = [...existingData, ...sections];
        }

        // Remove duplicates and sort. Match by id OR messageRequestId so that
        // locally added images (messageRequestId) are not duplicated when API returns server id.
        // Use existingData (UI) as base so order is preserved and multiple images don't jump.
        const apiSections = sections;
        const uniqueData = existingData.length > 0
          ? existingData.map((existingSection) => {
              const apiSection = apiSections.find(s => s.createdAt === existingSection.createdAt);
              if (!apiSection) return existingSection;
              const usedApiIds = new Set();
              const mergedItems = [];
              for (const existingItem of existingSection.items) {
                const matchNew = apiSection.items.find(newItem =>
                  isSameChatMessage(existingItem, newItem)
                );
                if (matchNew) {
                  usedApiIds.add(matchNew.id);
                  if (matchNew.messageRequestId) usedApiIds.add(matchNew.messageRequestId);
                  const isLocal = existingItem.local === true;
                  const isVideo = existingItem.messageType === "video" || matchNew.messageType === "video";
                  mergedItems.push({
                    ...existingItem,
                    ...matchNew,
                    id: matchNew.id || existingItem.id,
                    messageRequestId: existingItem.messageRequestId || matchNew.messageRequestId,
                    mediaAlbumId: existingItem.mediaAlbumId || matchNew.mediaAlbumId,
                    fileUrl: isVideo
                      ? (matchNew.fileUrl || existingItem.fileUrl)
                      : (isLocal && existingItem.fileUrl ? existingItem.fileUrl : (matchNew.fileUrl || existingItem.fileUrl)),
                    serverFileUrl: matchNew.fileUrl || existingItem.serverFileUrl,
                    thumbnailUrl: isVideo
                      ? (matchNew.thumbnailUrl || existingItem.thumbnailUrl)
                      : (existingItem.thumbnailUrl || matchNew.thumbnailUrl),
                    images: (existingItem.images && existingItem.images.length > 0 && isLocal)
                      ? existingItem.images.map((img, i) => ({
                          ...img,
                          ...(matchNew.images && matchNew.images[i] ? matchNew.images[i] : {}),
                          fileUrl: img.fileUrl || (matchNew.images && matchNew.images[i] && matchNew.images[i].fileUrl)
                        }))
                      : (matchNew.images || existingItem.images),
                    local: isVideo && matchNew.fileUrl ? false : (isLocal ? true : (matchNew.local !== undefined ? matchNew.local : existingItem.local))
                  });
                } else {
                  mergedItems.push(existingItem);
                }
              }
              for (const newItem of apiSection.items) {
                const alreadyUsed = (newItem.id && usedApiIds.has(newItem.id)) ||
                  (newItem.messageRequestId && usedApiIds.has(newItem.messageRequestId));
                const existsInMerged = mergedItems.some(m => isSameChatMessage(m, newItem) || isSameChatMessage(newItem, m));
                if (!alreadyUsed && !existsInMerged) mergedItems.push(newItem);
              }
              return { ...existingSection, items: mergedItems };
            })
          : [...sections];
        const sectionDates = new Set(uniqueData.map(s => s.createdAt));
        apiSections.forEach(apiSection => {
          if (!sectionDates.has(apiSection.createdAt)) {
            uniqueData.push(apiSection);
            sectionDates.add(apiSection.createdAt);
          }
        });

        commitSections(uniqueData);
      } else {
        commitSections(sections);
      }
    }

    if (direction === 'initial') {
      setOriginalMessages(sections);
    }

    // Fire background translation AFTER state is committed (messages show instantly)
    setTimeout(() => translateMessagesInBackground(chatId, lang), 0);
  };

  const _getText = () => {
    return strings.cancel;
  };
  const patchActivityPreviewAfterDelete = (groupId, sections, deletedIds) => {
    const preview = getLastVisibleMessagePreview(sections, deletedIds);
    const currentState = store.getState();
    const matchesChat = (chat) =>
      chat?.group?.id === groupId || chat?.id === groupId || chat?.mainId === groupId;
    const patch = (c) => (matchesChat(c) ? applyVisiblePreviewToChat(c, preview) : c);
    const am = currentState.activityMessages || [];
    if (am.length > 0) dispatch({ type: SET_ACTIVITY_MESSAGES, messages: am.map(patch) });
    const ar = currentState.activityMessagesReminders || [];
    if (ar.length > 0) dispatch({ type: SET_ACTIVITY_MESSAGES_REMINDERS, messages: ar.map(patch) });
  };

  const deleteMessage = async () => {
    setDelMessage(true);
  };
  const deleteSelectedMessages = async (chatId, messageIds = null) => {
    const groupId = chatId;
    const idsToDelete = messageIds || msgIds;
    let txx = [...tempChatHistory];
    let fillt = txx[0].data.map((u, i) => {
      let itts = u.items.map((e, j) => {
        let isExist = idsToDelete.includes(e.id);
        if (isExist) {
          return { ...e, isDeleted: true };
        } else {
          return { ...e };
        }
      });
      return { ...u, items: itts };
    });
    txx[0] = { ...txx[0], data: [...fillt] };
    setTempChatHistory([...txx]);
    setDelMessage(false);
    setMsgIds([]);
    const { data } = await callAPI(`/message/delete`, {}, "POST", {
      id: idsToDelete,
      group: groupId,
    });

    patchActivityPreviewAfterDelete(groupId, fillt, idsToDelete);
  };

  const handleDeleteSingleMessage = async (chat) => {
    try {
      document.body.setAttribute('data-confirm-color', 'orange');
      await $crud.confirm({
        title: "",
        textContent: strings.delete_message_confirm || (isGerm ? "Möchtest du diese Nachricht wirklich löschen?" : "Do you really want to delete this message?"),
        options: {
          ok: strings.delete_label || (isGerm ? "Löschen" : "Delete"),
          cancel: strings.cancel || (isGerm ? "Abbrechen" : "Cancel"),
        },
      });
      document.body.removeAttribute('data-confirm-color');
      const groupId = props.chat?.group?.id || props.chat?.id;
      const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
      if (chat.messageType === "poll") {
        if (!chat.id || !uuidRegex.test(chat.id)) {
          console.warn("Poll delete skipped: message ID is not a valid UUID yet", chat.id);
          return;
        }
        await callAPI(`/message/${chat.id}/poll`, {}, "DELETE", { group: groupId });
        setTempChatHistory((prev) => {
          return prev.map((entry) => ({
            ...entry,
            data: entry.data?.map((dateGroup) => ({
              ...dateGroup,
              items: dateGroup.items?.map((item) =>
                item.id === chat.id ? { ...item, isDeleted: true } : item
              ),
            })),
          }));
        });

        const pollEntry = (tempChatHistoryRef.current || []).find(
          (e) => e.id === groupId || e.id === props.chat?.id || e.id === props.chat?.key
        );
        patchActivityPreviewAfterDelete(groupId, pollEntry?.data, [chat.id]);
      } else {
        // A merged photo album deletes every one of its images.
        await deleteSelectedMessages(groupId, selectionIdsOf(chat));
      }
    } catch (e) {
      document.body.removeAttribute('data-confirm-color');
      return;
    }
  };

  const getPlainMessageText = (chat) => {
    const source = chat?.originalMessage || chat?.message || "";
    let plain = source;
    if (typeof source === "string" && source.startsWith("U2FsdGVkX1") && secretKey) {
      try { plain = decryptMessage(source, secretKey); } catch (e) { plain = source; }
    }
    return (plain || "").replace(/<br\s*[/]?>/gi, "\n").replace(/&nbsp;/g, " ");
  };

  // Copy always uses the untranslated original, even when the bubble shows a translation.
  const getCopyableOriginalText = (chat) => {
    if (chat?.messageType === 'audio' && (chat?.originalTranscribedAudio || chat?.transcribedAudio)) {
      return (chat.originalTranscribedAudio || chat.transcribedAudio || "")
        .replace(/<br\s*[/]?>/gi, "\n")
        .replace(/&nbsp;/g, " ");
    }
    return getPlainMessageText(chat);
  };
  getCopyableOriginalTextRef.current = getCopyableOriginalText;

  const applyEditedMessageToHistory = (messageId, patch) => {
    setTempChatHistory((prev) => {
      let changed = false;
      const next = prev.map((entry) => ({
        ...entry,
        data: entry.data?.map((dateGroup) => ({
          ...dateGroup,
          items: dateGroup.items?.map((item) => {
            if (item.id === messageId) {
              changed = true;
              return {
                ...item,
                ...patch,
                originalMessage: undefined,
                translationPending: false,
              };
            }
            return item;
          }),
        })),
      }));
      return changed ? next : prev;
    });
  };

  // Edit in the composer (mobile Pro): the text moves into the composer with the edit bar on
  // top and the send button saves it; the draft that was there comes back afterwards.
  const restoreComposerText = (text) => {
    applyDraftToComposer({
      draftText: text || "",
      setMessage,
      messageRef,
      richEditorRef,
      isComposerToolbarOpen: isComposerToolbarOpenRef.current,
      composerMarkdownToHtml,
      pendingDraftHtmlRef,
    });
  };

  const startEditMessage = (chat) => {
    if (!chat || chat.messageType !== "simple" || chat.isDeleted) return;
    if (!editingChatRef.current) {
      preEditDraftRef.current = readComposerDraftText({
        richEditorRef,
        getRichEditorContent,
        messageRef,
        isComposerToolbarOpen: isComposerToolbarOpenRef.current,
      });
    }
    setActiveReply(false);
    setReplyMessage(null);
    editingChatRef.current = chat;
    setEditingChat(chat);
    restoreComposerText(getPlainMessageText(chat));
    focusComposer();
  };

  const cancelEditMessage = () => {
    const draft = preEditDraftRef.current;
    preEditDraftRef.current = null;
    editingChatRef.current = null;
    setEditingChat(null);
    setEditSaving(false);
    restoreComposerText(draft || "");
  };

  // true when saved (or unchanged); false keeps the edit open with the text in the composer.
  const saveEditedMessage = async (chat, nextText) => {
    const trimmed = String(nextText || "").trim();
    if (!chat?.id || !trimmed || editSaving) return false;
    if (trimmed === getPlainMessageText(chat).trim()) {
      cancelEditMessage();
      return true;
    }
    const groupId = props.chat?.group?.id || props.chat?.id;
    if (!groupId) return false;
    setEditSaving(true);
    const payloadMessage = secretKey ? encryptMessage(trimmed, secretKey) : trimmed;
    const { data } = await callAPI(`/message/${chat.id}`, {}, "PUT", {
      group: groupId,
      message: payloadMessage,
    });
    if (!data?.status) {
      setEditSaving(false);
      $crud.notify({
        type: "error",
        message: data?.message || strings.edit_window_expired,
      });
      return false;
    }
    applyEditedMessageToHistory(chat.id, {
      message: data.chat?.message || payloadMessage,
      isEdited: true,
      editedAt: data.chat?.editedAt || new Date(),
      detectedMessageLanguage: data.chat?.detectedMessageLanguage || null,
    });
    cancelEditMessage();
    return true;
  };

  // The open chat's id for socket handlers registered once (Teams delivery events).
  const teamsChatIdRef = useRef(null);
  teamsChatIdRef.current = props.chat?.id || props.chat?.key || null;

  // Runs `fn(items)` over every date group of the history; keeps the same objects when nothing changed.
  const mapHistoryItems = (history, fn) => {
    let changed = false;
    const next = (history || []).map((entry) => {
      if (!entry || !Array.isArray(entry.data)) return entry;
      let entryChanged = false;
      const data = entry.data.map((dateGroup) => {
        if (!dateGroup || !Array.isArray(dateGroup.items)) return dateGroup;
        const items = fn(dateGroup.items);
        if (items === dateGroup.items) return dateGroup;
        entryChanged = true;
        return { ...dateGroup, items };
      });
      if (!entryChanged) return entry;
      changed = true;
      return { ...entry, data };
    });
    return changed ? next : history;
  };

  // Task notice cards (chat.taskNotice): `patch` merged into every card of task `todoId`
  // for `recipientId` — all notices of one task to one person share the confirmation.
  const patchTaskNotices = (todoId, recipientId, patch) => {
    setTempChatHistory((prev) =>
      mapHistoryItems(prev, (items) => {
        let changed = false;
        const next = items.map((item) => {
          const notice = item && item.taskNotice;
          if (!notice || String(notice.todoId) !== String(todoId) || String(notice.recipientId) !== String(recipientId)) return item;
          changed = true;
          return { ...item, taskNotice: { ...notice, ...patch } };
        });
        return changed ? next : items;
      })
    );
  };
  const [taskNoticeBusy, setTaskNoticeBusy] = useState(null);
  // "Bestätigen" on a task notice: PUT /todo/:id/notice/acknowledge (shown at once, undone on error).
  const confirmTaskNotice = async (notice) => {
    if (!notice || !notice.todoId || taskNoticeBusy) return;
    const previous = notice.acknowledgedAt || null;
    setTaskNoticeBusy(String(notice.todoId));
    patchTaskNotices(notice.todoId, notice.recipientId, { acknowledgedAt: new Date().toISOString() });
    try {
      const res = await callAPI(`/todo/${notice.todoId}/notice/acknowledge`, {}, "PUT", {});
      if (res?.data?.status === false) throw new Error(res.data.message || "");
      if (res?.data?.data?.acknowledgedAt) {
        patchTaskNotices(notice.todoId, notice.recipientId, { acknowledgedAt: res.data.data.acknowledgedAt });
      }
    } catch (e) {
      patchTaskNotices(notice.todoId, notice.recipientId, { acknowledgedAt: previous });
      $crud.notify({ type: "error", message: (e && e.message) || strings.something_went_wrong || "Something went wrong" });
    } finally {
      setTaskNoticeBusy(null);
    }
  };
  const openTaskNoticeTask = (notice) => {
    if (!notice || !notice.todoId) return;
    openProjectTask(dispatch, history, { roomId: notice.roomId, roomName: notice.roomName, todoId: notice.todoId });
  };

  // A Microsoft Teams file the server could not deliver: POST /teams/messages/:chatId/retry.
  const retryTeamsMessage = async (chat) => {
    const patchRow = (fields) =>
      setTempChatHistory((prev) => mapHistoryItems(prev, (items) => {
        let hit = false;
        const next = items.map((m) => {
          if (!m || String(m.id) !== String(chat.id)) return m;
          hit = true;
          return { ...m, ...fields };
        });
        return hit ? next : items;
      }));
    patchRow({ teamsDeliveryFailed: false, teams: { ...(chat.teams || {}), sendState: "pending" } });
    const res = await retryTeamsDelivery(chat.id);
    if (res && res.status === true) {
      patchRow({ teamsDeliveryFailed: false, teams: { ...(chat.teams || {}), sendState: res.sendState || "pending" } });
      return;
    }
    patchRow({ teamsDeliveryFailed: true, teams: { ...(chat.teams || {}), sendState: "failed" } });
    $crud.notify({
      type: "error",
      message: (res && res.message) || strings.teams_retry_failed || "The message could not be sent again.",
    });
  };

  // Own text messages stay "sending" until the backend has them and turn "failed" (red retry
  // button in the bubble footer) when the request fails (mobile Pro ProMeta).
  const patchOutgoingMessage = (requestId, patch) => {
    if (!requestId) return;
    setTempChatHistory((prev) => {
      let changed = false;
      const next = prev.map((entry) => ({
        ...entry,
        data: entry.data?.map((dateGroup) => ({
          ...dateGroup,
          items: dateGroup.items?.map((item) => {
            if (item && item.messageRequestId != null && String(item.messageRequestId) === String(requestId)) {
              changed = true;
              return { ...item, ...patch };
            }
            return item;
          }),
        })),
      }));
      return changed ? next : prev;
    });
  };

  const postOutgoing = async (requestId, path, body) => {
    const res = await callAPI(path, {}, "POST", body);
    const data = res && res.data;
    const ok = !!(data && data.status !== false);
    // Microsoft Teams: the server says this send can never succeed as it is (read-only chat,
    // reconnect needed, too long, rejected …): no retry, its reason as a toast.
    const final = !ok && isNonRetryableResponse(data);
    patchOutgoingMessage(
      requestId,
      ok
        ? { sending: false, failedToSend: false, retryRequest: null }
        : final
          ? { sending: false, failedToSend: true, retryRequest: null, nonRetryable: true }
          : { sending: false, failedToSend: true, retryRequest: { path, body } }
    );
    if (final && data.message) $crud.notify({ type: "error", message: data.message });
    return ok ? data : null;
  };

  const retryOutgoingMessage = (chat) => {
    // A Microsoft Teams file that reached the server but not Teams: the Teams retry route.
    if (chat && chat.id && !chat.failedToSend && teamsDeliveryOf(chat) === "failed") {
      retryTeamsMessage(chat);
      return;
    }
    const req = chat && chat.retryRequest;
    if (!req || chat.messageRequestId == null) return;
    patchOutgoingMessage(chat.messageRequestId, { sending: true, failedToSend: false });
    postOutgoing(chat.messageRequestId, req.path, req.body);
  };

  const getPreserveChatHistory = (chatId) => {
    let getChatHistories = localStorage.getItem("chatHistories")
      ? JSON.parse(localStorage.getItem("chatHistories"))
      : [];
    const foundIndex = getChatHistories.findIndex(
      (msg) => msg.userId === user?.id && msg.group === chatId
    );
    if (foundIndex > -1) {
      setChatHistory(getChatHistories[foundIndex].messages);
    }
  };
  const getBadgesCount = async (groupId) => {
    // force: true — subscribe just marked unread as read; a warm/cached or
    // pre-subscribe in-flight /badge/count must not overwrite the cleared
    // SideNav / Latest Messages counters.
    const { data } = await getBadgeCount({ force: true });
    // await props.getChats();
    if (groupId) {
      let tempProject = projects?.map((item) => {
        if (item?.id === groupId) {
          return { ...item };
        } else {
          return {
            ...item,
          };
        }
      });
      await props.updateProjects(tempProject);
    }
    if (data?.status) {
      await props.updateAllBadgeCount(data);
    }
  };

  const handler = async (data) => {
    if (!data) {
      console.warn('Handler received invalid data:', data);
      return;
    }
    const incomingGroupId =
      data.groupId ||
      (data.group && (data.group.id || data.group)) ||
      props.chat?.id;
    if (!incomingGroupId) {
      console.warn('Handler received invalid data:', data);
      return;
    }
    data = { ...data, groupId: incomingGroupId };
    
    // Only dispatch to LatestMessages if message has valid content
    // For images: only dispatch if the message has text OR is marked as the last image
    // This prevents images without text from overwriting the preview text from the last image
    const hasText = typeof data.message === 'string' && data.message.trim() !== '';
    const shouldUpdateLatestMessages = data.messageType !== "image" || 
      (hasText && data.fileUrl && Array.isArray(data.fileUrl) && data.fileUrl.length > 0 && data.fileUrl[0]) ||
      data.isLastImage; // Only update for images that have text or are explicitly marked as last
    
    if (shouldUpdateLatestMessages) {
      // Ensure preview text is always present for latest messages entry
      let previewMessage =
        (typeof data.message === "string" && data.message.trim() !== "")
          ? data.message
          : (data.originalMessage || "");
      
      // Decrypt if needed
      if (secretKey && previewMessage) {
        try {
          previewMessage = decryptMessage(previewMessage, secretKey);
        } catch (e) {
          // If decryption fails, use original text
        }
      }

      dispatch({
        type: SET_NEW_MESSAGE_DATA,
        payload: { 
          ...data, 
          message: previewMessage,
          previewMessage: previewMessage,
          decrypted: true
        }
      });
    }
    // Use ref to get latest state value (avoids stale closure issues)
    let tx = [...tempChatHistoryRef.current];
    let tempNew = [{ ...data }];
    const lang = translationLang;
    const chatData = await Promise.all(
      tempNew.map(async (message) => {
        // Preserve gallery structure for forwarded messages
        const processedMessage = {
          ...message,
          originalMessage: message.message,
          messageLng: props.language ? props.language : "en",
          inReplyTo: message.inReplyTo ? {
            ...message.inReplyTo,
            message:
              String(message?.senderId ?? '') !== String(user?.id ?? '') &&
                message?.inReplyTo?.message
                ? await getTranslate(message?.inReplyTo, lang)
                : message?.inReplyTo?.message,
          } : message.inReplyTo,
          message: await (async () => {
            if (String(message?.senderId ?? '') === String(user?.id ?? '') || !message?.message || message?.messageType === "poll" || message?.taskNotice) {
              return message?.message || message?.originalMessage || '';
            }
            return await getTranslate(message, lang);
          })(),
        };

        if (String(message?.senderId ?? '') !== String(user?.id ?? '') && message?.transcribedAudio) {
          const translatedAudio = preserveOriginalFormatting(
            await getTranslateText(message.transcribedAudio, lang),
            message.transcribedAudio
          );
          if (translatedAudio && translatedAudio.trim() !== message.transcribedAudio.trim()) {
            processedMessage.originalTranscribedAudio = message.transcribedAudio;
            processedMessage.transcribedAudio = translatedAudio;
          }
        }
        
        // Ensure message field is never empty - if it is, log a warning
        if (!processedMessage.message && processedMessage.originalMessage) {
          processedMessage.message = processedMessage.originalMessage;
        }
        
        // If message is forwarded and has images array, preserve gallery structure
        if (processedMessage.isForward && processedMessage.images && processedMessage.images.length > 1) {
          processedMessage.isMultiples = true;
          processedMessage.count = processedMessage.images.length;
        }
        
        // Ensure images array is properly structured for image messages
        if (processedMessage.messageType === "image") {
          // Determine if this is an incoming message (not from current user)
          const isIncomingMessage = processedMessage.senderId !== user?.id;
          const isLocalMessage = isIncomingMessage ? false : (processedMessage.local !== undefined ? processedMessage.local : true);
          
          // If message already has images array, verify and fix it
          if (processedMessage.images && Array.isArray(processedMessage.images)) {
            processedMessage.images = processedMessage.images.map(img => {
              // Ensure each image has fileUrl and local flag
              if (!img.fileUrl && processedMessage.fileUrl) {
                const fileUrls = Array.isArray(processedMessage.fileUrl) ? processedMessage.fileUrl : [processedMessage.fileUrl];
                return {
                  ...img,
                  fileUrl: img.fileUrl || fileUrls[0],
                  attachedFileName: img.attachedFileName || processedMessage.attachedFileName,
                  local: img.local !== undefined ? img.local : isLocalMessage
                };
              }
              // Ensure local flag is set correctly
              return {
                ...img,
                local: img.local !== undefined ? img.local : isLocalMessage
              };
            });
            processedMessage.count = processedMessage.images.length;
            processedMessage.isMultiples = processedMessage.images.length > 1;
          } else if (processedMessage.fileUrl) {
            // Convert fileUrl to images array format
            const fileUrls = Array.isArray(processedMessage.fileUrl) 
              ? processedMessage.fileUrl 
              : [processedMessage.fileUrl];
            
            // Exclude images from spread to avoid circular reference
            const { images: _, ...messageWithoutImages } = processedMessage;
            
            processedMessage.images = fileUrls.map((url, index) => {
              const imageMessage = {
                ...messageWithoutImages,
                fileUrl: url,
                attachedFileName: Array.isArray(processedMessage.attachedFileName) 
                  ? processedMessage.attachedFileName[index] 
                  : processedMessage.attachedFileName,
                local: isLocalMessage,
                imageDimension: processedMessage.imageDimension || {
                  width: processedMessage.width || 0,
                  height: processedMessage.height || 0
                }
              };
              return imageMessage;
            });
            
            processedMessage.count = processedMessage.images.length;
            processedMessage.isMultiples = processedMessage.images.length > 1;
            
          } else {
            console.warn('Image message has no fileUrl or images:', processedMessage);
            processedMessage.images = [{ ...processedMessage, local: isLocalMessage }];
            processedMessage.count = 1;
            processedMessage.isMultiples = false;
          }
          
          // Ensure the parent message also has local flag set correctly
          processedMessage.local = isLocalMessage;
        }
        
        return processedMessage;
      })
    );
    data = chatData[0];
    
    // Ensure data exists
    if (!data) {
      console.warn('Processed message is missing data:', data);
      return;
    }
    
    // For media messages (image, audio, video, doc, poll), message field might be empty
    const mediaTypes = ["image", "audio", "video", "doc", "poll"];
    const isSystemMessage = data.userDeactivated || data.userReactivate || data.userDeleted ||
      data.leftGroup || data.joinedGroup || data.pendingGroup || data.rejectedGroup;
    if (!mediaTypes.includes(data.messageType) && !data.message && !isSystemMessage) {
      console.warn('Non-media message is missing message field:', data);
      return;
    }
    
    // Update lastMessage in group list instantly for preview (for all messages, not just current chat)
    // This ensures preview updates even when chat is not selected
    if (data && data.groupId && props.updateGroupChats) {
      let messageText = "";
      if (data.messageType === "simple") {
        // For simple messages, use the message text
        messageText = data.message || "";
        // If message is encrypted, try to decrypt it
        if (secretKey && messageText) {
          try {
            messageText = decryptMessage(messageText, secretKey);
          } catch (e) {
            // If decryption fails, use original text
            messageText = data.message || "";
          }
        }
      } else if (data.messageType === "image") {
        messageText = "Image";
      } else if (data.messageType === "doc") {
        messageText = "Document";
      } else if (data.messageType === "video") {
        messageText = "Video";
      } else if (data.messageType === "audio") {
        messageText = "Audio";
      } else {
        messageText = data.message || "";
      }
      
      // Only update if we have a valid message text
      if (messageText) {
        // Get current groupChats from Redux or props
        const currentGroupChats = props.groupChats || store.getState().groupChats || [];
        // IMPORTANT: Create a map of current isOpened states to preserve them
        const currentOpenedStates = new Map(
          currentGroupChats.map(g => [g.id, g.isOpened])
        );
        
        const updatedGroupChats = currentGroupChats.map(group => {
          if (group.id === data.groupId) {
            // Preserve isOpened from current state
            const preservedIsOpened = currentOpenedStates.get(group.id) ?? group.isOpened;
            return {
              ...group,
              isOpened: preservedIsOpened,
              lastMessage: messageText,
              lastMessageType: data.messageType || "simple",
              lastMessageDeleted: false,
              message: messageText,
              messageType: data.messageType || "simple",
              lastReactionEmoji: null,
              lastReactionSenderName: null,
            };
          }
          return group;
        });
        
        props.updateGroupChats(updatedGroupChats);
      }
    }
    
    // Check if message belongs to current chat
    // Use loose equality to handle string/number mismatches
    if (data.groupId == props.chat?.id) {
      // Find or create chat entry in tempChatHistory
      let chatIndex = tx.findIndex(item => idsMatch(item.id, data.groupId));
      
      if (chatIndex === -1) {
        // Chat not found in tempChatHistory, create new entry
        const messageDate = formatDateWithLocale(data.createdAt);
        const messageToAdd = {
          ...data,
          local: idsMatch(data.senderId, user.id) ? (data.local !== undefined ? data.local : true) : false,
          transcriptionPending: data.messageType === 'audio' && !data.transcribedAudio ? true : false,
        };
        
        const newChatEntry = {
          id: data.groupId,
          data: [{
            createdAt: messageDate,
            items: [messageToAdd]
          }]
        };
        const updatedTx = [...tx, newChatEntry];
        setTempChatHistory(updatedTx);
        
        if (data.messageType === 'audio' && !data.transcribedAudio && !idsMatch(data.senderId, user.id)) {
          fetchTranscriptForIncoming(data);
        }
        if (data.messageType === 'image' && !data.imageDescription && !idsMatch(data.senderId, user.id)) {
          fetchImageDescriptionForIncoming(data);
        }

        // Scroll to bottom when new message arrives in the current chat
        // Only scroll if the chat is currently opened and user is viewing it
        if (props.chat?.isOpened && data.groupId === props.chat?.id) {
          // Use setTimeout to ensure DOM is updated before scrolling
          setTimeout(() => {
            scrollToBottom(data.groupId, 'smooth'); // Smooth scroll when new message arrives
          }, 100);
        }
        
        setNewMess(null);
        setNewMess(false);
        return;
      }
      
      // Chat exists in tempChatHistory - use ref to get latest state
      const updatedTx = [...tempChatHistoryRef.current];
      chatIndex = updatedTx.findIndex(item => idsMatch(item.id, data.groupId));
      if (chatIndex === -1) {
        setNewMess(null);
        setNewMess(false);
        return;
      }

      let messageFound = false;
      updatedTx[chatIndex].data = updatedTx[chatIndex].data.map((e) => ({
        ...e,
        items: e.items.map((l) => {
          if (isSameChatMessage(l, data)) {
            messageFound = true;
            return mergeIncomingMessage(l, data);
          }
          return { ...l };
        }),
      }));

      const ownMessage = idsMatch(data.senderId, user.id);

      // Own socket echo: only merge into the optimistic row. Never insert a
      // second copy (senderId is often a string from the socket and a number
      // locally, which used to take the incoming-push path).
      // A window (search jump) does not end at the newest message: a new one arrives with page 1.
      if (!messageFound && (!ownMessage || data.pendingGroup) && !threadWindowRef.current) {
        const messageToAdd = {
          ...data,
          local: false,
          transcriptionPending: data.messageType === 'audio' && !data.transcribedAudio ? true : false,
        };
        const lastIndex = updatedTx[chatIndex].data.length - 1;
        if (lastIndex >= 0) {
          updatedTx[chatIndex].data[lastIndex].items.push(messageToAdd);
        } else {
          const messageDate = formatDateWithLocale(data.createdAt);
          updatedTx[chatIndex].data = [{
            createdAt: messageDate,
            items: [messageToAdd]
          }];
        }
      }

      if ((messageFound || !ownMessage) && data.messageType === 'audio' && !data.transcribedAudio && data.fileUrl) {
        fetchTranscriptForIncoming(data);
      }
      if ((messageFound || !ownMessage) && data.messageType === 'image' && !data.imageDescription) {
        fetchImageDescriptionForIncoming(data);
      }

      setTempChatHistory(updatedTx);
      
      // Scroll to bottom when new message arrives in the current chat
      // Only scroll if the chat is currently opened and user is viewing it
      if (props.chat?.isOpened && data.groupId === props.chat?.id && !threadWindowRef.current && !searchViewRef.current) {
        // Use setTimeout to ensure DOM is updated before scrolling
        setTimeout(() => {
          scrollToBottom(data.groupId, 'smooth'); // Smooth scroll when new message arrives
        }, 100);
      }
      
      // Update Redux cache with the new message for instant preview
      if (data && data.id) {
      dispatch({
          type: UPDATE_CACHED_MESSAGE,
          payload: { chatId: data.groupId, message: data }
        });
        appendCachedMessage(data.groupId, data, translationLang);
      }
      
      setNewMess(null);
      setNewMess(false);
    }
  };

  const _registerEVents = async () => {
    if (Socket && Socket.on) {
      try {
        Socket.off("userStatus").on("userStatus", function (data) {
          // The presence of the other person (chatDetails.id is the chat, not a user).
          if (!data || data.user == null) return;
          setChatDetails((prev) => {
            if (!prev || prev.otherUserId == null || String(prev.otherUserId) !== String(data.user)) return prev;
            const isOnline = data.isOnline === true || data.isOnline === "true";
            const lastOnlineAt = data.lastOnlineAt || prev.lastOnlineAt || null;
            return prev.isOnline === isOnline && prev.lastOnlineAt === lastOnlineAt ? prev : { ...prev, isOnline, lastOnlineAt };
          });
        });
        Socket.off("created").on("created", async function (data) {
          setNewMess(data.message);
        });
        Socket.off("emoji").on("emoji", async function (data) {
          setEmojiMessage(data);
        });
        Socket.off("deleted").on("deleted", function (data) {
          if (!data || !data.deletedChatMessage) return;
          const ids = Array.isArray(data.deletedChatMessage) ? data.deletedChatMessage : [data.deletedChatMessage];
          historySearch.removeIds(ids);
          setTempChatHistory((prev) => {
            let changed = false;
            const next = prev.map((entry) => ({
              ...entry,
              data: entry.data?.map((dateGroup) => ({
                ...dateGroup,
                items: dateGroup.items?.map((item) => {
                  if (ids.includes(item.id)) {
                    changed = true;
                    return { ...item, isDeleted: true };
                  }
                  return item;
                }),
              })),
            }));
            return changed ? next : prev;
          });

          const gId = props.chat?.group?.id || props.chat?.id || props.chat?.key;
          if (gId) {
            const entry = (tempChatHistoryRef.current || []).find(
              (e) => e.id === gId || e.id === props.chat?.id || e.id === props.chat?.key
            );
            patchActivityPreviewAfterDelete(gId, entry?.data, ids);
          }
        });
        Socket.off("edited").on("edited", function (data) {
          if (!data || !data.id) return;
          historySearch.applyEdit(data.id, data.message);
          applyEditedMessageToHistory(data.id, {
            message: data.message,
            isEdited: true,
            editedAt: data.editedAt || new Date(),
            detectedMessageLanguage: data.detectedMessageLanguage || null,
            // A Microsoft Teams edit can change a part's file (signed URL), type and album.
            ...teamsEditedFields(data),
          });
        });
        // A task notice was confirmed (here or on another device): its cards show it.
        Socket.off("taskNoticeUpdated").on("taskNoticeUpdated", function (data) {
          if (!data || !data.todoId || !data.recipientId) return;
          patchTaskNotices(data.todoId, data.recipientId, { acknowledgedAt: data.acknowledgedAt || null });
        });
        // Microsoft Teams media delivery (owner sockets): the row's teams.sendState, so the
        // bubble shows pending / failed (with retry) / delivered.
        const onTeamsDelivery = (data, failed) => {
          if (!data || !data.chatId) return;
          const openId = teamsChatIdRef.current;
          if (data.groupId && openId && String(data.groupId) !== String(openId)) return;
          setTempChatHistory((prev) => mapHistoryItems(prev, (items) => applyTeamsDelivery(items, data, failed)));
        };
        Socket.off("teamsDeliveryState").on("teamsDeliveryState", (data) => onTeamsDelivery(data, false));
        Socket.off("teamsDeliveryFailed").on("teamsDeliveryFailed", (data) => onTeamsDelivery(data, true));
      } catch (e) {
        // Socket event registration error
      }
    }
  };

  const _getMessages = async (pageNum = 1, direction = 'initial', targetMsgId = null) => {
    // Get chat ID (support both id and key for direct messages from LatestMessages)
    const chatId = props.chat?.id || props.chat?.key;
    if (!chatId) return;
    
    // Store targetMsgId for use in scroll logic (passed from useEffect to avoid stale closure)
    const scrollTargetId = targetMsgId || props.scrollToMessageId;
    
    // Prevent duplicate loading - ensure content loads only once
    if (paginationRef.current.isApiCallInProgress && direction === 'initial' && !scrollTargetId) {
      // For initial loads without a scroll target, prevent duplicate calls
      return;
    }
    
    // Only skip if page is already loaded AND this is not an initial load
    // For initial loads, always fetch fresh data to ensure latest messages are shown
    if (loadedPages.has(pageNum) && direction !== 'initial') return;

    // Optimize: For LatestMessages, reduce loading state delays
    const isFromLatest = props.isFromLatestMsg && direction === 'initial';

    // Capture the chat ID at the start of the request
    const requestChatId = chatId;
    const currentRequestId = loadingStateRef.current.requestId;

    if (direction === 'top') {
      paginationRef.current.isLoadingTop = true;
      setIsLoadingTop(true);
    } else if (direction === 'bottom') {
      setIsLoadingBottom(true);
    } else {
      // For LatestMessages, minimize loading state to show content faster
      if (!isFromLatest && !paintedFromCacheRef.current) {
        setIsGettingChats(true);
      }
    }

    paginationRef.current.isApiCallInProgress = true;
    let data;
    try {
      const activityRow = (store.getState().activityMessages || []).find(
        (c) => String(c?.group?.id) === String(requestChatId)
      );
      const expectMessageId = listPreviewMessageId(activityRow);
      const missingLatest =
        !!expectMessageId && !cacheHasMessage(requestChatId, expectMessageId, translationLang);

      if (
        direction === 'initial' &&
        pageNum === 1 &&
        paintedFromCacheRef.current &&
        isChatCacheFresh(requestChatId, translationLang) &&
        !scrollTargetId &&
        !missingLatest
      ) {
        paginationRef.current.isApiCallInProgress = false;
        setLoadedPages((prev) => new Set([...prev, pageNum]));
        setIsGettingChats(false);
        setIsLoading(false);
        setShowSkeleton(false);
        setIsContentReady(true);
        _registerEVents();
        return;
      }

      const response = await fetchChatPage({
        chatId: requestChatId,
        page: pageNum,
        limit: 30,
        userId: user?.id,
        translationLang,
        force: !!scrollTargetId || !!missingLatest,
        expectMessageId,
      });
      data = response.data;
      
      // Handle API error - chat not found or access denied
      if (!data?.status) {
        console.warn('[Chat] API Error for chatId:', requestChatId, '- Message:', data?.message || 'Unknown error');
        setIsLoading(false);
        setShowSkeleton(false);
        setIsGettingChats(false);
        // Without this the "loading older" banner stays up and pagination stays blocked.
        paginationRef.current.isApiCallInProgress = false;
        if (direction === 'top') {
          paginationRef.current.isLoadingTop = false;
          setIsLoadingTop(false);
        } else if (direction === 'bottom') {
          setIsLoadingBottom(false);
        }
        return;
      }
      paginationRef.current.isApiCallInProgress = false;
      
      // Check if the chat is still the same after API response
      // If user switched to a different chat, ignore this response for UI updates
      const currentChatId = props.chat?.id || props.chat?.key;
      const isStillActiveChat = currentChatId === requestChatId && 
                                 loadingStateRef.current.requestId === currentRequestId;
      
      if (data.status) {
        dispatch({ type: SET_DEEPLINK_LOADING, loading: false })
        if (data.groupInfo) applyTeamsGroupInfoRef.current(data.groupInfo);

        if (data.groupInfo?.secretKey && !secretKeyRef.current) {
          secretKeyRef.current = data.groupInfo.secretKey;
          setSecretKey(data.groupInfo.secretKey);
          setIsSecretKey(1);
        }
        if (data.groupInfo?.secretKey) {
          rememberChatSecret(requestChatId, data.groupInfo.secretKey, translationLang);
        }
        
        // Always save to Redux cache (even if chat changed)
        if (pageNum === 1 && data.chatHistory?.length > 0) {
          dispatch({
            type: SET_CACHED_MESSAGES,
            payload: {
              chatId: requestChatId,
              rawMessages: data.chatHistory.slice(0, 100)
            }
          });
        }
        
        // Skip UI updates if user switched to a different chat
        if (!isStillActiveChat) {
          return;
        }

        // Mark page as loaded
        setLoadedPages(prev => new Set([...prev, pageNum]));

        // Update pagination state based on direction
        if (direction === 'top') {
          setTopPage(pageNum);
          setCurrentPage(pageNum); // Update current page
          // Older pages never change what lies below the thread (hasMoreBottom).
          // If chatEnd or no data returned, disable further top loading
          if (data.chatEnd || data.chatHistory?.length === 0) {
            setHasMoreTop(false);
          }
        } else if (direction === 'bottom') {
          setBottomPage(pageNum);
          setCurrentPage(pageNum); // Update current page
          if (pageNum <= 1) {
            setHasMoreBottom(false);
          }
        } else {
          setPage(pageNum);
          setCurrentPage(pageNum); // Update current page for initial load
          // Enable top loading for older messages (unless chatEnd is true)
          if (!data.chatEnd) {
            setHasMoreTop(true);
          }
          if (data.chatEnd) {
            setHasMore(false);
          }
        }

        _registerEVents();
        // Process messages immediately for fast loading
        const processMessages = () => {
          const incomingFp = messagesFingerprint(data.chatHistory);
          const cacheAlreadyPainted = paintedFromCacheRef.current && direction === 'initial';
          const sameAsPainted = cacheAlreadyPainted && incomingFp && incomingFp === paintedFingerprintRef.current;
          if (!sameAsPainted) {
            if (cacheAlreadyPainted) {
              forceReplaceMessagesRef.current = true;
            }
            if (data.chatHistory?.length > 0) {
              data.chatHistory.forEach(msg => { msg._page = pageNum; });
              const currentChatId = props.chat?.id || props.chat?.key;
              groupByDate(data.chatHistory, currentChatId, direction);
            } else if (direction === 'initial') {
              const currentChatId = props.chat?.id || props.chat?.key;
              groupByDate([], currentChatId, direction);
            }
            if (direction === 'initial') {
              paintedFingerprintRef.current = incomingFp;
            }
            if (cacheAlreadyPainted && !scrollTargetId) {
              const scrollerId = props.chat?.id || props.chat?.key;
              requestAnimationFrame(() => {
                const el = document.getElementById(`chat-sc-${scrollerId}`);
                if (el) el.scrollTop = el.scrollHeight;
              });
            }
          }
          
          // Handle message scroll and highlight for deeplink
          // Use scrollTargetId (passed as parameter) as primary, fallback to props, then deeplinkData
          const targetMessageId = scrollTargetId || props.scrollToMessageId || deeplinkData?.messageId;
          // IMPORTANT: Set scrolledToMessageRef BEFORE setIsContentReady to prevent
          // auto-scroll-to-bottom effects from firing and overriding the message scroll
          if (targetMessageId && direction === 'initial') {
            scrolledToMessageRef.current = true;
          }
          
          // Don't set isContentReady when loading older messages (direction === 'top')
          // This prevents the useEffect from triggering scroll to bottom
          if (targetMessageId && direction === 'initial') {
            
            // FIRST: Hide transition overlay immediately when message data is loaded
            if (props.onMessageHighlighted) {
              props.onMessageHighlighted();
            }
            
            // THEN: After overlay is hidden, scroll to and highlight the message.
            // Short: every frame spent here is a frame of the transcript sitting
            // at the wrong offset. A missing element is retried by the scroll
            // helper, and its 500ms pass corrects for late layout shifts.
            requestAnimationFrame(() => {
              setTimeout(() => {
                scrollToAndHighlightMessage(targetMessageId);
              }, 120);
            });
          }
          else{
            // Hide transition overlay even if no message to scroll to
            if (props.onMessageHighlighted && props.isFromTodo) {
              props.onMessageHighlighted();
            }
            dispatch({ type: SET_DEEPLINK_DATA, payload: null });
            // No deeplink target: surface any quick-reaction received while away.
            if (direction === 'initial') {
              markNewReactionMessages(data.chatHistory);
            }
          }
          
          if (direction === 'top') {
            // Reset pagination refs immediately — no state updates, no re-renders
            paginationRef.current.isLoadingTop = false;
            paginationRef.current.loadingDirection = null;
            setIsLoadingTop(false);
          } else if (direction === 'bottom') {
            setIsLoadingBottom(false);
          } else {
            // This is the initial load (direction === 'initial')
            // INSTANT: Show content immediately - no delays
            setIsGettingChats(false);
            setIsLoading(false);
            setShowSkeleton(false);
            setIsContentReady(true);
            // Scrolling is handled by the initial-scroll useEffect
            // which triggers when isContentReady flips to true
          }
          // Reset API call in progress flag
          paginationRef.current.isApiCallInProgress = false;
        };
        
        // Execute immediately - no deferred transition
        processMessages();
      } else {
        // Error or no data - show content immediately anyway
        if (direction === 'top') {
          paginationRef.current.isLoadingTop = false;
          setIsLoadingTop(false);
        } else if (direction === 'bottom') {
          setIsLoadingBottom(false);
        } else {
          setIsGettingChats(false);
          setIsLoading(false);
          setShowSkeleton(false);
          setIsContentReady(true);
        }
        paginationRef.current.isApiCallInProgress = false;
      }
    } catch (error) {
      // Reset loading states on error
      if (direction === 'top') {
        paginationRef.current.isLoadingTop = false;
        setIsLoadingTop(false);
      } else if (direction === 'bottom') {
        setIsLoadingBottom(false);
      } else {
        setIsGettingChats(false);
        // Handle loading states on error
        setIsLoading(false);
        setTimeout(() => {
          setShowSkeleton(false);
        }, 300);
        setTimeout(() => {
          setIsContentReady(true);
        }, 400);
      }
      // Reset API call in progress flag
      paginationRef.current.isApiCallInProgress = false;
      return;
    }

  };

  // Scroll to and highlight a specific message (for deeplinks)
  // Note: Transition overlay is hidden BEFORE this is called (when API data loads)
  const scrollToAndHighlightMessage = async (messageId, retryCount = 0, options = {}) => {
    if (!messageId) return; // No message ID to scroll to
    const gentle = options.gentle === true;
    
    const messageElement = document.getElementById(`chat-${messageId}`);
    

    if (messageElement) {
      // Mark that we've scrolled to a specific message - prevents auto-scroll from interfering
      scrolledToMessageRef.current = true;
      
      const chatContainer = document.getElementById(`chat-sc-${props.chat?.id || props.chat?.key}`);
      // Arriving from a deeplink the chat has only just appeared, usually
      // scrolled to the newest message. Animating from there rushes the whole
      // transcript past the user; land on the message directly instead. A
      // gentle scroll (quick reaction) keeps its animation — there the user is
      // already reading the chat and the movement is the point.
      const arrivalBehavior = gentle ? 'smooth' : 'auto';
      if (chatContainer) {
        const allMessages = chatContainer.querySelectorAll('[id^="chat-"]');
        const isFirstMessage = allMessages.length > 0 && allMessages[0]?.id === `chat-${messageId}`;

        if (isFirstMessage) {
          chatContainer.scrollTo({ top: 0, behavior: arrivalBehavior });
        } else {
          const containerRect = chatContainer.getBoundingClientRect();
          const messageRect = messageElement.getBoundingClientRect();
          const messageOffsetInContainer = messageRect.top - containerRect.top + chatContainer.scrollTop;
          const centeredScrollTop = messageOffsetInContainer - (containerRect.height / 2) + (messageRect.height / 2);
          chatContainer.scrollTo({ top: Math.max(0, centeredScrollTop), behavior: arrivalBehavior });

          setTimeout(() => {
            const updatedMessageRect = messageElement.getBoundingClientRect();
            const updatedContainerRect = chatContainer.getBoundingClientRect();
            const updatedOffset = updatedMessageRect.top - updatedContainerRect.top + chatContainer.scrollTop;
            const updatedCenter = updatedOffset - (updatedContainerRect.height / 2) + (updatedMessageRect.height / 2);
            const currentCenter = chatContainer.scrollTop + updatedContainerRect.height / 2;
            const messageCenter = updatedOffset + updatedMessageRect.height / 2;
            if (Math.abs(currentCenter - messageCenter) > 50) {
              chatContainer.scrollTo({ top: Math.max(0, updatedCenter), behavior: 'smooth' });
            }
          }, 500);
        }
      } else {
        scrollMessageIntoChat(messageElement, { behavior: arrivalBehavior });
      }
      
      messageElement.style.zIndex = '10';
      messageElement.style.position = 'relative';
      messageElement.style.overflow = 'visible';

      // Start fully transparent and flush the style, otherwise the browser has
      // no value to animate from and the outline snaps on at full strength.
      messageElement.style.transition = 'none';
      messageElement.style.outline = '2px solid rgba(var(--kjuup-accent-rgb), 0)';
      messageElement.style.outlineOffset = '3px';
      messageElement.style.boxShadow = '0 0 0 0 rgba(var(--kjuup-accent-rgb), 0)';
      void messageElement.offsetWidth;

      messageElement.style.transition = 'outline-color 0.45s ease, box-shadow 0.45s ease';
      messageElement.style.outline = gentle
        ? '2px solid rgba(var(--kjuup-accent-rgb), 0.55)'
        : '2px solid rgba(var(--kjuup-accent-rgb), 0.7)';
      messageElement.style.outlineOffset = '3px';
      messageElement.style.boxShadow = gentle
        ? '0 0 0 3px rgba(var(--kjuup-accent-rgb), 0.08)'
        : '0 0 0 4px rgba(var(--kjuup-accent-rgb), 0.12)';

      setTimeout(() => {
        messageElement.style.transition = 'outline-color 0.7s ease-out, box-shadow 0.7s ease-out';
        messageElement.style.outline = '2px solid rgba(var(--kjuup-accent-rgb), 0)';
        // Fade the spread out rather than dropping to `none`, which is not
        // interpolable and would cut the glow off mid-fade.
        messageElement.style.boxShadow = gentle
          ? '0 0 0 3px rgba(var(--kjuup-accent-rgb), 0)'
          : '0 0 0 4px rgba(var(--kjuup-accent-rgb), 0)';
        
        setTimeout(() => {
          messageElement.style.removeProperty('outline');
          messageElement.style.removeProperty('outline-offset');
          messageElement.style.removeProperty('box-shadow');
          messageElement.style.removeProperty('z-index');
          messageElement.style.removeProperty('position');
          messageElement.style.removeProperty('transition');
          messageElement.style.removeProperty('overflow');
          scrolledToMessageRef.current = false;
        }, 750);
      }, gentle ? 2800 : 3200);
      
      dispatch({ type: SET_DEEPLINK_DATA, payload: null });
    } else {
      // Message not found yet, retry up to 30 times with increasing delays
      if (retryCount < 30) {
        const delay = Math.min(200 * (retryCount + 1), 1000);
        setTimeout(() => {
          scrollToAndHighlightMessage(messageId, retryCount + 1, options);
        }, delay);
      } else {
        dispatch({ type: SET_DEEPLINK_DATA, payload: null });
      }
    }
  };

  // When opening a chat, if any of the just-loaded messages received a quick
  // reaction while we were away, scroll to and gently highlight the most recent
  // one so the user sees which bubble was reacted to, then consume the marker.
  const markNewReactionMessages = (messages) => {
    const ids = newReactionIdsRef.current || [];
    if (!ids.length || !messages?.length) return;
    const matched = messages
      .filter((m) => m?.id != null && ids.includes(m.id))
      .map((m) => m.id);
    if (!matched.length) return;
    const targetId = matched[matched.length - 1];
    // Suppress the auto-scroll-to-bottom so we reliably land on the reacted
    // message instead of the newest one.
    scrolledToMessageRef.current = true;
    requestAnimationFrame(() => {
      setTimeout(() => scrollToAndHighlightMessage(targetId, 0, { gentle: true }), 450);
    });
    dispatch({ type: CLEAR_REACTION_MESSAGES, ids: matched });
  };

  const _subsOnly = () => {
    const chatId = props.chat?.id || props.chat?.key;
    // Drop row + tab badges immediately. Subscribe + getBadgesCount still
    // run to mark read on the BE and reconcile. Skip if the list click
    // already zeroed this row so we don't decrement twice.
    const state = store.getState();
    const am = state.activityMessages || [];
    const row = am.find(
      (c) =>
        String(c?.group?.id) === String(chatId) ||
        String(c?.id) === String(chatId) ||
        String(c?.mainId) === String(chatId)
    );
    const unread = Number(row?.unseenChatCount) || 0;
    // The "N unread messages" band uses the count the chat was opened with.
    if (unread > unreadAtOpenRef.current) unreadAtOpenRef.current = unread;
    if (unread > 0) {
      dispatch({
        type: ALL_BADGE_COUNT,
        unSeenAllCount: applyOptimisticChatRead(state.unSeenAllCount, {
          isOneToOne: true,
          isInternal: false,
          unreadCount: unread,
        }),
      });
      dispatch({
        type: SET_ACTIVITY_MESSAGES,
        messages: am.map((c) => {
          const match =
            String(c?.group?.id) === String(chatId) ||
            String(c?.id) === String(chatId) ||
            String(c?.mainId) === String(chatId);
          return match ? { ...c, unseenChatCount: 0, isOpened: true } : c;
        }),
      });
    }
    let dataSubs = {
      // MUST be SOCKET_BASE, not API_ROOT. Sails routes socket "get"
      // requests by pathname; in dev API_ROOT is "/api", which would send
      // this to "/api/group/:id/subscribe" — a route the BE doesn't have —
      // so `subscribeToGroupChat` never runs and the messages are never
      // marked read (the unread badge then never clears on web, even though
      // mobile, which uses an absolute API_ROOT, works fine).
      url: `${SOCKET_BASE}/group/${chatId}/subscribe`,
      method: "get",
      headers: {
        Authorization: `jwt ${$user.getToken()}`,
      },
      data: {
        userId: user?.id,
      },
    };
    Socket?.emit("get", dataSubs, ({ body }) => {
      if (body?.groupInfo) applyTeamsGroupInfoRef.current(body.groupInfo);
      if (body?.groupInfo?.secretKey) {
        secretKeyRef.current = body.groupInfo.secretKey;
        setSecretKey(body.groupInfo.secretKey);
        setIsSecretKey(1);
        rememberChatSecret(props.chat?.id || props.chat?.key, body.groupInfo.secretKey, translationLang);
      } else {
        setIsSecretKey(0);
      }
      // Subscribe marks unread (+ emoji reactions) as seen on the BE.
      // Refresh global counters immediately so SideNav / filter-tab badges
      // don't wait for leave/re-enter of Latest Messages.
      getBadgesCount(props?.projectDetails?.id);
    });
  };

  const disConnect = () => {
    Socket?.emit("get", groupUnsubscribeObj);
  };
  const clearDraftMessage = async () => {
    clearStoredDraft(props.chat?.id || props.chat?.key);
  };

  const saveDraft = (messageToSave) => {
    const groupId = props.chat?.id || props.chat?.key;
    const uid = user?.id;
    if (!groupId || !uid) return;
    const text = messageToSave != null
      ? String(messageToSave).trim()
      : readComposerDraftText({
          richEditorRef,
          getRichEditorContent,
          messageRef,
          isComposerToolbarOpen: isComposerToolbarOpenRef.current,
        });
    persistDraftMessage(uid, groupId, text);
  };

  const preserveChatHistory = () => {
    const chatHistoryObj = {
      userId: user?.id,
      group: props.chat?.id,
      messages: chatHistory,
    };
    let chatHistories = localStorage.getItem("chatHistories")
      ? JSON.parse(localStorage.getItem("chatHistories"))
      : [];
    const foundIndex = chatHistories.findIndex(
      (msg) => msg.userId === user?.id && msg.group === props.chat?.id
    );
    if (foundIndex > -1) {
      chatHistories[foundIndex] = {
        ...chatHistories[foundIndex],
        messages: chatHistory,
      };
    } else {
      chatHistories = [...chatHistories, chatHistoryObj];
    }
    localStorage.setItem("chatHistories", JSON.stringify(chatHistories));
  };

  const handleCloseChat = (chatId) => {
    if (props.handleClose) {
      return props.handleClose(chatId);
    }
    const filtered = (props.openChats || []).filter(
      (c) => c.id !== chatId && c.key !== chatId
    );
    props.updateOpenChats(filtered);
  };

  const hideProject = async (chatId) => {
    saveDraft();
    preserveChatHistory();
    await handleCloseChat(chatId);
  };

  const sendMessage = async (chatIdParam, messageOverride) => {
    // Use provided chatId or fall back to props
    const chatId = chatIdParam || props.chat?.id || props.chat?.key;
    if (!chatId) return;
    let messagex = readLiveComposerText({
      messageOverride,
      isToolbarOpen: isComposerToolbarOpenRef.current,
      getRichEditorContent,
      messageRef,
      fallback: message,
    });
    // Editing (the edit bar is open): the send button saves the edited text instead.
    if (editingChatRef.current) {
      const editText = String(messagex || "")
        .replace(/<br\s*[/]?>/gi, "\n")
        .replace(/<(?!\/?(?:u|em)>)[^>]+>/g, "")
        .replace(/&nbsp;/g, " ");
      if (!editText.trim()) return;
      closeEmojiPicker();
      await saveEditedMessage(editingChatRef.current, editText);
      return;
    }
    setMessage("");
    messageRef.current = "";
    if (richEditorRef.current) {
      richEditorRef.current.innerHTML = "";
    }
    setTextareaHeight(true);
    // Close emoji picker with fade-out animation
    closeEmojiPicker();
    let converText = messagex
      .replace(/<br\s*[/]?>/gi, "\n")
      .replace(/<(?!\/?(?:u|em)>)[^>]+>/g, "")
      .replace(/&nbsp;/g, " ");
    // converText = messagex?.replace(/\n/g, "<br/>");
    let uniID = makeid(10);
    if (chatDetails.isBlock) {
      await $crud.confirm({
        title: strings.unblock_to_send,
        textContent: "",
        options: {
          ok: strings.unblock,
          cancel: strings.cancel,
        },
      });
      const id = chatId || props.chat?.id;
      const user = chatDetails.otherUserId;
      const { data } = await callAPI(`/group/${id}/block`, {}, "PUT", {
        id: id,
        user: user,
      });
      getDetails(chatId);
    } else {
      if (messagex) {
        if (!activeReply) {
          let msg = {
            createdAt: new Date(),
            id: uniID,
            isSend: false,
            message: secretKey
              ? encryptMessage(messagex.trim(), secretKey)
              : messagex.trim(),
            messageLng: "en",
            messageType: "simple",
            senderId: user.id,
            userEmoji: [],
            isReply: false,
            messageRequestId: uniID,
            isSent: true,
            sending: true,
            isCopied: isCopied,
            // Rid: chatMessageInfo.id,
            // inReplyTo: { ...chatMessageInfo }
          };
          playSendSound();
          // Find the correct chat entry by chatId, not just index 0
          const msgChatIndex = tempChatHistory.findIndex(item => item.id === (chatId || props.chat?.id));
          if (msgChatIndex > -1) {
            let tt = [...tempChatHistory];
            const lastIdx = tt[msgChatIndex].data.length - 1;
            if (lastIdx >= 0) {
              tt[msgChatIndex].data[lastIdx].items.push(msg);
            } else {
              const messageDate = formatDateWithLocale(msg.createdAt);
              tt[msgChatIndex].data = [{ createdAt: messageDate, items: [msg] }];
            }
            setTempChatHistory([...tt]);
          } else {
            // Create new entry for this chat
            const messageDate = formatDateWithLocale(msg.createdAt);
            let tt = [...tempChatHistory, { id: chatId || props.chat?.id, data: [{ createdAt: messageDate, items: [msg] }] }];
            setTempChatHistory([...tt]);
          }
          
          // Update lastMessage in group list instantly when message is sent (optimistic update)
          // Use the original message text (before encryption) for display
          // messagex is the plain text before encryption, so we can use it directly
          if (props.updateGroupChats && (chatId || props.chat?.id)) {
            let messageText = messagex ? messagex.trim() : "";
            
            // Only update if we have a valid non-empty message
            if (messageText && messageText.length > 0) {
              const currentGroupChats = props.groupChats || store.getState().groupChats || [];
              const updatedGroupChats = currentGroupChats.map(group => {
                if (group.id === (chatId || props.chat?.id)) {
                  return {
                    ...group,
                    lastMessage: messageText,
                    lastMessageType: "simple",
                    lastMessageDeleted: false,
                    message: messageText,
                    messageType: "simple",
                    lastReactionEmoji: null,
                    lastReactionSenderName: null,
                  };
                }
                return group;
              });
              props.updateGroupChats(updatedGroupChats);
            }
          }
          
          scrollToBottom(chatDetails.id, 'auto');
          $(`.textInput-${chatDetails.id}`).val("");
          // Blur the input after sending
          if (textRef.current) {
            textRef.current.blur();
          }
          
          // Dispatch immediately to update LatestMessages (move chat to top instantly)
          // Use the plain text message for immediate preview
          dispatch({ 
            type: SET_NEW_MESSAGE_DATA, 
            payload: { 
              id: uniID,
              groupId: chatId || props.chat?.id,
              message: converText,
              previewMessage: converText,
              messageType: "simple",
              senderId: user?.id,
              createdAt: new Date().toISOString(),
              decrypted: true,
              optimistic: true // Flag to indicate this is optimistic data
            } 
          });
          
          const data = await postOutgoing(uniID, "/message", {
            group: chatId || props.chat?.id,
            isGroup: true,
            message: secretKey
              ? encryptMessage(converText, secretKey)
              : converText,
            messageType: "simple",
            sender: user?.id,
            messageRequestId: uniID,
            isCopied: isCopied,
          });
          
          // Update Redux cache with the sent message for instant preview.
          // POST /message answers with a status string in `message`, not the row —
          // spreading that string cached an empty bubble that showed on the next open.
          if (data && data.message && typeof data.message === "object" && (chatId || props.chat?.id)) {
            const messageWithGroupId = {
              ...data.message,
              groupId: chatId || props.chat?.id,
              messageRequestId: uniID
            };
            dispatch({
              type: UPDATE_CACHED_MESSAGE,
              payload: { chatId: chatId || props.chat?.id, message: messageWithGroupId }
            });
            appendCachedMessage(chatId || props.chat?.id, messageWithGroupId, translationLang);
            
            // Server response received - chat already moved to top
            // Message sent successfully
          }
          
          // Update lastMessage in group list after message is successfully sent
          if (data && data.message && (chatId || props.chat?.id) && props.updateGroupChats) {
            let messageText = "";
            if (data.message.messageType === "simple") {
              messageText = data.message.message || "";
              // If message is encrypted, try to decrypt it
              if (secretKey && messageText) {
                try {
                  messageText = decryptMessage(messageText, secretKey);
                } catch (e) {
                  // If decryption fails, use original text
                  messageText = data.message.message || "";
                }
              }
            } else if (data.message.messageType === "image") {
              messageText = "Image";
            } else if (data.message.messageType === "doc") {
              messageText = "Document";
            } else if (data.message.messageType === "video") {
              messageText = "Video";
            } else if (data.message.messageType === "audio") {
              messageText = "Audio";
            } else {
              messageText = data.message.message || "";
            }
            
            // Only update if we have a valid message text
            if (messageText && messageText.trim().length > 0) {
              // Get current groupChats from Redux or props
              const currentGroupChats = props.groupChats || store.getState().groupChats || [];
              const updatedGroupChats = currentGroupChats.map(group => {
                if (group.id === (chatId || props.chat?.id)) {
                  return {
                    ...group,
                    lastMessage: messageText,
                    lastMessageType: data.message.messageType || "simple",
                    lastMessageDeleted: false,
                    message: messageText,
                    messageType: data.message.messageType || "simple",
                    lastReactionEmoji: null,
                    lastReactionSenderName: null,
                  };
                }
                return group;
              });
              
              props.updateGroupChats(updatedGroupChats);
            }
          }
        } else {
          let ttx = replyMessage;
          let msg = {
            createdAt: new Date(),
            id: uniID,
            isSend: false,
            message: secretKey
              ? encryptMessage(messagex.trim(), secretKey)
              : messagex.trim(),
            messageLng: "en",
            messageType: "simple",
            senderId: user.id,
            userEmoji: [],
            isReply: true,
            messageRequestId: uniID,
            isSent: true,
            sending: true,
            isCopied: isCopied,
            Rid: ttx.id,
            inReplyTo: {
              ...ttx,
              message: secretKey
                ? encryptMessage(ttx?.message, secretKey)
                : ttx?.message,
            },
          };
          // Find the correct chat entry by chatId, not just index 0
          const replyChatIndex = tempChatHistory.findIndex(item => item.id === (chatId || props.chat?.id));
          if (replyChatIndex > -1) {
            let tt = [...tempChatHistory];
            const lastIdx = tt[replyChatIndex].data.length - 1;
            if (lastIdx >= 0) {
              tt[replyChatIndex].data[lastIdx].items.push(msg);
            } else {
              const messageDate = formatDateWithLocale(msg.createdAt);
              tt[replyChatIndex].data = [{ createdAt: messageDate, items: [msg] }];
            }
            setTempChatHistory([...tt]);
          } else {
            const messageDate = formatDateWithLocale(msg.createdAt);
            let tt = [...tempChatHistory, { id: chatId || props.chat?.id, data: [{ createdAt: messageDate, items: [msg] }] }];
            setTempChatHistory([...tt]);
          }
          playSendSound();
          scrollToBottom(chatDetails.id, 'auto');
          setActiveReply(false);
          $(`.textInput-${chatDetails.id}`).val("");
          // Blur the input after sending
          if (textRef.current) {
            textRef.current.blur();
          }
          await postOutgoing(
            uniID,
            `/message/${replyMessage.id}/reply`,
            {
              id: replyMessage.id,
              group: chatId || props.chat?.id,
              isGroup: true,
              // message: getInput !==null ? getInput : message,
              message: secretKey
                ? encryptMessage(converText, secretKey)
                : converText,
              messageType: "simple",
              sender: user?.id,
              messageRequestId: uniID,
              isCopied: isCopied,
            }
          );
          setActiveReply(false);
          setReplyMessage(null);
        }
        clearDraftMessage();
        setMessage("");
      }
    }
    setIsCopied(false);
    setTextareaHeight(false);
  };

  const sendImageMessage = async (message, image, imageDimension, chatId) => {
    setMessage("");
    messageRef.current = "";
    if (richEditorRef.current) {
      richEditorRef.current.innerHTML = "";
    }
    if (chatDetails.isBlock) {
      await $crud.confirm({
        title: strings.unblock_to_send,
        textContent: "",
        options: {
          ok: strings.unblock,
          cancel: strings.cancel,
        },
      });
      const id = chatId;
      const user = chatDetails.otherUserId;
      const { data } = await callAPI(`/group/${id}/block`, {}, "PUT", {
        id: id,
        user: user,
      });

      getDetails(chatId);
    } else {
      const mediaAlbumId = makeid(10);
      const caption = (message || "").trim();
      if (!activeReply) {
        // Prepare all image messages first
        const imageMessages = image.map((e, i) => {
          // Assign increasing timestamps so images stay in order
          const createdAtTs = Date.now() + i;
          const uniID = makeid(10);
          // Create blob URL if it doesn't exist (happens when image is from upload dialog vs drag-drop)
          const blobUrl = e.url || URL.createObjectURL(e);
          // For HEIC files, use placeholder. Otherwise use the blob URL.
          const isHeic = !e.type || e.type === 'image/heic' || e.name?.endsWith('.heic');
          const displayUrl = isHeic 
            ? process.env.PUBLIC_URL + `assets/img/${isGerm ? 'no-image-preview-de.png' : 'no-image-preview-en.png'}` 
            : blobUrl;
          
          return {
            img: e,
            blobUrl, // Store for later cleanup if needed
            isLastImage: i === image.length - 1, // Last image always gets the text
            uniID,
            msg: {
              createdAt: new Date(createdAtTs),
              createdAtTs,
              id: uniID,
              isSend: false,
              message: (i === image.length - 1) ? caption : "",
              messageLng: "en",
              messageType: "image",
              senderId: user.id,
              userEmoji: [],
              isReply: false,
              messageRequestId: uniID,
              mediaAlbumId,
              isSent: true,
              fileUrl: [displayUrl],
              attachedFileName: e.name,
              local: true,
              isLastImage: i === image.length - 1,
              hasMultiple: image.length > 1,
              isCopied: isCopied,
              uploading: true,
              // Add image dimensions for proper sizing
              imageDimension: imageDimension[i] || { width: 300, height: 300 },
              width: imageDimension[i]?.width || 300,
              height: imageDimension[i]?.height || 300,
            }
          };
        });
        
        // Build messages for local display - add as individual messages (createdAtTs keeps stable order)
        const localMessages = imageMessages.map(m => ({
          ...m.msg,
          createdAtTs: m.msg.createdAtTs ?? (m.msg.createdAt ? new Date(m.msg.createdAt).getTime() : Date.now()),
          images: [{ ...m.msg }],
          count: 1,
        }));
        
        const targetChatId = chatId || props.chat?.id || props.chat?.key;
        registerOutgoingMessages(
          targetChatId,
          localMessages,
          formatDateWithLocale,
          [props.chat?.id, props.chat?.key]
        );
        
        // Store messageRequestIds to prevent duplicate adds
        const messageRequestIds = new Set(imageMessages.map(m => m.uniID));
        
        setTempChatHistory(prev => {
          const targetChatId = chatId || props.chat?.id;
          const chatIndex = prev.findIndex(item => item.id === targetChatId);
          const messageDate = formatDateWithLocale(moment().toDate());
          
          if (chatIndex > -1) {
            // Check if any of these messages already exist
            let hasExisting = false;
            prev[chatIndex].data.forEach(section => {
              section.items.forEach(item => {
                if (item.messageRequestId && messageRequestIds.has(item.messageRequestId)) {
                  hasExisting = true;
                }
              });
            });
            
            // If messages already exist, don't add again (prevents React re-run duplicates)
            if (hasExisting) {
              return prev;
            }
            
            // Create updated structure immutably
            const lastIdx = prev[chatIndex].data.length - 1;
            if (lastIdx >= 0) {
              return prev.map((chat, idx) => {
                if (idx !== chatIndex) return chat;
                return {
                  ...chat,
                  data: chat.data.map((section, sIdx) => {
                    if (sIdx !== lastIdx) return section;
                    return {
                      ...section,
                      items: [...section.items, ...localMessages]
                    };
                  })
                };
              });
            } else {
              return prev.map((chat, idx) => {
                if (idx !== chatIndex) return chat;
                return {
                  ...chat,
                  data: [{ createdAt: messageDate, items: localMessages }]
                };
              });
            }
          } else {
            // Chat doesn't exist - create new entry
            return [...prev, { 
              id: targetChatId, 
              data: [{ createdAt: messageDate, items: localMessages }] 
            }];
          }
        });
        
        scrollToBottom(chatId, 'smooth');
        
        // Dispatch immediately to update LatestMessages (move chat to top instantly)
        // Use optimistic data from the last image message
        const lastImageMsg = imageMessages[imageMessages.length - 1];
        dispatch({ 
          type: SET_NEW_MESSAGE_DATA, 
          payload: { 
            id: lastImageMsg.uniID,
            groupId: chatId || props.chat?.id,
            message: message,
            previewMessage: message,
            messageType: "image",
            count: image.length,
            hasMultiple: image.length > 1,
            senderId: user?.id,
            createdAt: new Date().toISOString(),
            decrypted: true, // Flag to indicate message is already decrypted
            optimistic: true // Flag to indicate this is optimistic data
          } 
        });
        
        // Upload images sequentially to maintain order with distinct timestamps
        // Send images in order: first all images without text, then the last image with text
        (async () => {
          for (let i = 0; i < imageMessages.length; i++) {
            const { img, isLastImage, uniID } = imageMessages[i];
            const formData = new FormData();
            formData.append("group", `${chatId}`);
            formData.append("isGroup", "true");
            formData.append(
              "message",
              `${isLastImage ? (secretKey && caption ? encryptMessage(caption, secretKey) : caption) : ""}`
            );
            formData.append("messageRequestId", uniID);
            formData.append("mediaAlbumId", mediaAlbumId);
            formData.append("messageType", "image");
            formData.append("attachedFileName", img.name);
            formData.append("sender", `${user?.id}`);
            if (imageDimension[i]?.height)
              formData.append("height", imageDimension[i]?.height);
            if (imageDimension[i]?.width)
              formData.append("width", imageDimension[i]?.width);
            formData.append("file", img, img.name);
            formData.append("isCopied", isCopied);
            try {
              const response = await callAPI2("/message", {}, "POST", formData);
              
              // For the last image, optionally update with server data (already moved to top)
              // This ensures we have the real server data, but the position change already happened
              if (isLastImage && response?.data?.message) {
                // Silent update - chat already moved to top
              }
            } catch (error) {
              console.error("Error sending image:", error);
              $crud.notify({
                type: "error",
                message: "Failed to send image",
              });
            }
            
            // Add a small delay between uploads to ensure distinct server timestamps
            // This maintains the correct order when messages are sorted by timestamp
            if (i < imageMessages.length - 1) {
              await new Promise(resolve => setTimeout(resolve, 100));
            }
          }
        })();
        
        clearDraftMessage();
      } else {
        // Reply with images - prepare all messages first
        const ttx = replyMessage;
        const replyImageMessages = image.map((e, i) => {
          // Assign increasing timestamps so images stay in order
          const createdAtTs = Date.now() + i;
          const uniID = makeid(10);
          const isLastImage = i === image.length - 1; // Last image always gets the text
          // Create blob URL if it doesn't exist
          const blobUrl = e.url || URL.createObjectURL(e);
          const isHeic = !e.type || e.type === 'image/heic' || e.name?.endsWith('.heic');
          const displayUrl = isHeic 
            ? process.env.PUBLIC_URL + `assets/img/${isGerm ? 'no-image-preview-de.png' : 'no-image-preview-en.png'}` 
            : blobUrl;
          
          return {
            img: e,
            blobUrl,
            isLastImage,
            uniID,
            msg: {
              createdAt: new Date(createdAtTs),
              createdAtTs,
              id: uniID,
              isSend: false,
              message: isLastImage ? caption : "",
              messageLng: "en",
              messageType: "image",
              senderId: user.id,
              userEmoji: [],
              isReply: true,
              messageRequestId: uniID,
              mediaAlbumId,
              isSent: true,
              Rid: ttx.id,
              inReplyTo: {
                ...ttx,
                fileUrl: [displayUrl],
                message: secretKey
                  ? encryptMessage(ttx?.message, secretKey)
                  : ttx?.message,
              },
              fileUrl: [displayUrl],
              attachedFileName: e.name,
              local: true,
              isLastImage,
              hasMultiple: image.length > 1,
              isCopied: isCopied,
              uploading: true,
            }
          };
        });
        
        // Build reply messages for local display - add as individual messages (createdAtTs keeps stable order)
        const replyLocalMessages = replyImageMessages.map(m => ({
          ...m.msg,
          createdAtTs: m.msg.createdAtTs ?? (m.msg.createdAt ? new Date(m.msg.createdAt).getTime() : Date.now()),
          images: [{ ...m.msg }],
          count: 1,
        }));
        
        const targetChatId = chatId || props.chat?.id || props.chat?.key;
        registerOutgoingMessages(
          targetChatId,
          replyLocalMessages,
          formatDateWithLocale,
          [props.chat?.id, props.chat?.key]
        );
        
        // Store messageRequestIds to prevent duplicate adds
        const replyMessageRequestIds = new Set(replyImageMessages.map(m => m.uniID));
        
        setTempChatHistory(prev => {
          const targetChatId = chatId || props.chat?.id;
          const chatIndex = prev.findIndex(item => item.id === targetChatId);
          const messageDate = formatDateWithLocale(moment().toDate());
          
          if (chatIndex > -1) {
            // Check if any of these messages already exist
            let hasExisting = false;
            prev[chatIndex].data.forEach(section => {
              section.items.forEach(item => {
                if (item.messageRequestId && replyMessageRequestIds.has(item.messageRequestId)) {
                  hasExisting = true;
                }
              });
            });
            
            // If messages already exist, don't add again
            if (hasExisting) {
              return prev;
            }
            
            // Create updated structure immutably
            const lastIdx = prev[chatIndex].data.length - 1;
            if (lastIdx >= 0) {
              return prev.map((chat, idx) => {
                if (idx !== chatIndex) return chat;
                return {
                  ...chat,
                  data: chat.data.map((section, sIdx) => {
                    if (sIdx !== lastIdx) return section;
                    return {
                      ...section,
                      items: [...section.items, ...replyLocalMessages]
                    };
                  })
                };
              });
            } else {
              return prev.map((chat, idx) => {
                if (idx !== chatIndex) return chat;
                return {
                  ...chat,
                  data: [{ createdAt: messageDate, items: replyLocalMessages }]
                };
              });
            }
          } else {
            // Chat doesn't exist - create new entry
            return [...prev, { 
              id: targetChatId, 
              data: [{ createdAt: messageDate, items: replyLocalMessages }] 
            }];
          }
        });
        
        setActiveReply(false);
        
        // Upload reply images sequentially to maintain order with distinct timestamps
        (async () => {
          for (let i = 0; i < replyImageMessages.length; i++) {
            const { img, isLastImage, uniID } = replyImageMessages[i];
            const formData = new FormData();
            formData.append("id", replyMessage.id);
            formData.append("group", `${chatId}`);
            formData.append("isGroup", "true");
            formData.append(
              "message",
              `${isLastImage ? (secretKey && caption ? encryptMessage(caption, secretKey) : caption) : ""}`
            );
            formData.append("messageRequestId", uniID);
            formData.append("mediaAlbumId", mediaAlbumId);
            formData.append("messageType", "image");
            formData.append("attachedFileName", img.name);
            formData.append("sender", `${user?.id}`);
            if (imageDimension[i]?.height)
              formData.append("height", imageDimension[i]?.height);
            if (imageDimension[i]?.width)
              formData.append("width", imageDimension[i]?.width);
            formData.append("file", img, img.name);
            formData.append("isCopied", isCopied);
            try {
              await callAPI2(
                `/message/${replyMessage.id}/reply`,
                {},
                "POST",
                formData
              );
            } catch (error) {
              console.error("Error sending reply image:", error);
              $crud.notify({
                type: "error",
                message: "Failed to send image",
              });
            }
            
            // Add a small delay between uploads to ensure distinct server timestamps
            if (i < replyImageMessages.length - 1) {
              await new Promise(resolve => setTimeout(resolve, 100));
            }
          }
        })();
        
        setMessage("");
        setReplyMessage(null);
        clearDraftMessage();
      }
    }
    setIsCopied(false);
  };
  const sendDocFile = async (doc, fileName, chatId, base64) => {
    if (chatDetails.isBlock) {
      await $crud.confirm({
        title: strings.unblock_to_send,
        textContent: "",
        options: {
          ok: strings.unblock,
          cancel: strings.cancel,
        },
      });
    const id = chatId;
    const user = chatDetails.otherUserId;
    const { data } = await callAPI(`/group/${id}/block`, {}, "PUT", {
      id: id,
      user: user,
    });
    getDetails(chatId);
    } else {
      let uniID = makeid(10);
      if (doc) {
        if (!activeReply) {
          let msg = {
            createdAt: new Date(),
            id: uniID,
            isSend: false,
            message: message.trim(),
            messageLng: "en",
            messageType: "doc",
            senderId: user.id,
            userEmoji: [],
            isReply: false,
            messageRequestId: uniID,
            mediaAlbumId: uniID,
            isSent: true,
            fileUrl: [base64],
            local: true,
            attachedFileName: fileName,
            isCopied: isCopied,
          };
          if (tempChatHistory.length > 0) {
            let tt = [...tempChatHistory];
            const lastIdx = tt[0].data.length - 1;
            tt[0].data[lastIdx].items.push(msg);
            setTempChatHistory([...tt]);
          } else {
            let data = [{ items: [{ ...msg }] }];
            let tt = [];
            tt.push({ data: data, id: props.chat?.id });
            setTempChatHistory([...tt]);
          }
          scrollToBottom(chatId, 'smooth');
          let formData = new FormData();
          formData.append("group", chatId);
          formData.append("isGroup", "true");
          formData.append("message", "");
          formData.append("messageRequestId", uniID);
          formData.append("mediaAlbumId", uniID);
          formData.append("messageType", "doc");
          formData.append("sender", `${user?.id}`);
          formData.append("attachedFileName", `${fileName}`);
          formData.append("file", doc);
          formData.append("isCopied", isCopied);
          const { data } = await callAPI2("/message", {}, "POST", formData);
          
          // Dispatch to update LatestMessages list immediately
          if (data?.message) {
            const previewText = data.message.message || "";
            dispatch({ 
              type: SET_NEW_MESSAGE_DATA, 
              payload: { 
                ...data.message, 
                groupId: chatId || props.chat?.id,
                previewMessage: previewText
              } 
            });
          }
          clearDraftMessage();
        } else {
          let ttx = replyMessage;
          let msg = {
            createdAt: new Date(),
            id: uniID,
            isSend: false,
            message: message.trim(),
            messageLng: "en",
            messageType: "image",
            senderId: user.id,
            userEmoji: [],
            isReply: true,
            messageRequestId: uniID,
            mediaAlbumId: uniID,
            isSent: true,
            Rid: ttx.id,
            inReplyTo: { ...ttx, fileUrl: [base64] },
            fileUrl: [base64],
            local: true,
            attachedFileName: fileName,
            isCopied: isCopied,
          };
          if (tempChatHistory.length > 0) {
            let tt = [...tempChatHistory];
            const lastIdx = tt[0].data.length - 1;
            tt[0].data[lastIdx].items.push(msg);
            setTempChatHistory([...tt]);
          } else {
            let data = [{ items: [{ ...msg }] }];
            let tt = [];
            tt.push({ data: data, id: props.chat?.id });
            setTempChatHistory([...tt]);
          }
          scrollToBottom(chatId, 'smooth');
          setActiveReply(false);
          let formData = new FormData();
          formData.append("id", replyMessage.id);
          formData.append("group", chatId);
          formData.append("isGroup", "true");
          formData.append("message", "");
          formData.append("messageRequestId", uniID);
          formData.append("mediaAlbumId", uniID);
          formData.append("messageType", "doc");
          formData.append("sender", `${user?.id}`);
          formData.append("attachedFileName", `${fileName}`);
          formData.append("file", doc);
          formData.append("isCopied", isCopied);
          await callAPI2(
            `/message/${replyMessage.id}/reply`,
            {},
            "POST",
            formData
          );
          clearDraftMessage();
          setActiveReply(false);
          setReplyMessage(null);
        }
      }
    }
    setIsCopied(false);
  };

  // Multi-document send. Each file becomes its own `doc` message so the album
  // grouping in buildRenderableSections can collapse them into one bubble; the
  // caption rides on the last file, matching how multi-image sends behave.
  const sendDocFiles = async (message, docs, chatId) => {
    if (!docs || docs.length === 0) return;
    setMessage("");
    messageRef.current = "";
    if (richEditorRef.current) {
      richEditorRef.current.innerHTML = "";
    }

    if (chatDetails.isBlock) {
      await $crud.confirm({
        title: strings.unblock_to_send,
        textContent: "",
        options: {
          ok: strings.unblock,
          cancel: strings.cancel,
        },
      });
      const id = chatId;
      const otherUser = chatDetails.otherUserId;
      await callAPI(`/group/${id}/block`, {}, "PUT", { id: id, user: otherUser });
      getDetails(chatId);
      setIsCopied(false);
      return;
    }

    const caption = (message || "").trim();
    const mediaAlbumId = makeid(10);
    const docMessages = docs.map((file, i) => {
      // Increasing timestamps keep the documents in the picked order.
      const createdAtTs = Date.now() + i;
      const uniID = makeid(10);
      const isLastDoc = i === docs.length - 1;
      const previewUrl = file.url || URL.createObjectURL(file);

      return {
        file,
        isLastDoc,
        uniID,
        msg: {
          createdAt: new Date(createdAtTs),
          createdAtTs,
          id: uniID,
          isSend: false,
          message: isLastDoc ? (secretKey ? encryptMessage(caption, secretKey) : caption) : "",
          messageLng: "en",
          messageType: "doc",
          senderId: user.id,
          userEmoji: [],
          isReply: false,
          messageRequestId: uniID,
          mediaAlbumId,
          isSent: true,
          fileUrl: [previewUrl],
          local: true,
          attachedFileName: file.name,
          fileSize: file.size,
          isCopied: isCopied,
        },
      };
    });

    const localMessages = docMessages.map((m) => ({ ...m.msg, uploading: true }));
    const messageRequestIds = new Set(docMessages.map((m) => m.uniID));
    registerOutgoingMessages(
      chatId || props.chat?.id || props.chat?.key,
      localMessages,
      formatDateWithLocale,
      [props.chat?.id, props.chat?.key]
    );

    setTempChatHistory((prev) => {
      const targetChatId = chatId || props.chat?.id;
      const chatIndex = prev.findIndex((item) => item.id === targetChatId);
      const messageDate = formatDateWithLocale(moment().toDate());

      if (chatIndex > -1) {
        let hasExisting = false;
        prev[chatIndex].data.forEach((section) => {
          section.items.forEach((item) => {
            if (item.messageRequestId && messageRequestIds.has(item.messageRequestId)) {
              hasExisting = true;
            }
          });
        });
        if (hasExisting) return prev;

        const lastIdx = prev[chatIndex].data.length - 1;
        if (lastIdx >= 0) {
          return prev.map((chat, idx) => {
            if (idx !== chatIndex) return chat;
            return {
              ...chat,
              data: chat.data.map((section, sIdx) => {
                if (sIdx !== lastIdx) return section;
                return { ...section, items: [...section.items, ...localMessages] };
              }),
            };
          });
        }
        return prev.map((chat, idx) => {
          if (idx !== chatIndex) return chat;
          return { ...chat, data: [{ createdAt: messageDate, items: localMessages }] };
        });
      }

      return [...prev, { id: targetChatId, data: [{ createdAt: messageDate, items: localMessages }] }];
    });

    scrollToBottom(chatId, 'smooth');

    const lastDocMsg = docMessages[docMessages.length - 1];
    dispatch({
      type: SET_NEW_MESSAGE_DATA,
      payload: {
        id: lastDocMsg.uniID,
        groupId: chatId || props.chat?.id,
        message: caption,
        previewMessage: caption,
        messageType: "doc",
        senderId: user?.id,
        createdAt: new Date().toISOString(),
        decrypted: true,
        optimistic: true,
      },
    });

    (async () => {
      for (let i = 0; i < docMessages.length; i++) {
        const { file, isLastDoc, uniID } = docMessages[i];
        const formData = new FormData();
        formData.append("group", `${chatId}`);
        formData.append("isGroup", "true");
        formData.append(
          "message",
          `${isLastDoc ? (secretKey ? encryptMessage(caption, secretKey) : caption) : ""}`
        );
        formData.append("messageRequestId", uniID);
        formData.append("mediaAlbumId", mediaAlbumId);
        formData.append("messageType", "doc");
        formData.append("attachedFileName", `${file.name}`);
        formData.append("sender", `${user?.id}`);
        formData.append("file", file, file.name);
        formData.append("isCopied", isCopied);
        try {
          await callAPI2("/message", {}, "POST", formData);
        } catch (error) {
          console.error("Error sending document:", error);
          $crud.notify({ type: "error", message: "Failed to send document" });
        }
        // Keep the server timestamps distinct so the order survives a refetch.
        if (i < docMessages.length - 1) {
          await new Promise((resolve) => setTimeout(resolve, 100));
        }
      }
    })();

    clearDraftMessage();
    setIsCopied(false);
  };

  const sendVideoMessage = async (video, message, chatId) => {
    setMessage("");
    messageRef.current = "";
    if (richEditorRef.current) {
      richEditorRef.current.innerHTML = "";
    }
    clearDraftMessage();
    if (chatDetails.isBlock) {
      await $crud.confirm({
        title: strings.unblock_to_send,
        textContent: "",
        options: {
          ok: strings.unblock,
          cancel: strings.cancel,
        },
      });
    const id = chatId;
    const user = chatDetails.otherUserId;
    const { data } = await callAPI(`/group/${id}/block`, {}, "PUT", {
      id: id,
      user: user,
    });
    getDetails(chatId);
    } else {
      if (video) {
        const uniID = makeid(10);
        const blobUrl = video.url || URL.createObjectURL(video);
        const caption = (message || "").trim();
        const payloadMessage = caption
          ? (secretKey ? encryptMessage(caption, secretKey) : caption)
          : "";
        const optimisticMsg = {
          createdAt: new Date(),
          createdAtTs: Date.now(),
          id: uniID,
          isSend: false,
          message: payloadMessage,
          messageLng: "en",
          messageType: "video",
          senderId: user.id,
          userEmoji: [],
          isReply: !!activeReply,
          inReplyTo: activeReply ? replyMessage : null,
          messageRequestId: uniID,
          isSent: true,
          fileUrl: [blobUrl],
          thumbnailUrl: blobUrl,
          local: true,
          uploading: true,
          attachedFileName: video.name,
          isCopied: isCopied,
        };
        const targetChatId = chatId || props.chat?.id;
        setPendingVideoId(uniID);
        setVideoUploadProgress(null);
        setTempChatHistory((prev) => {
          const tt = [...prev];
          const msgChatIndex = tt.findIndex((item) => item.id === targetChatId);
          if (msgChatIndex > -1) {
            const lastIdx = tt[msgChatIndex].data.length - 1;
            if (lastIdx >= 0) {
              tt[msgChatIndex] = {
                ...tt[msgChatIndex],
                data: tt[msgChatIndex].data.map((section, i) =>
                  i === lastIdx ? { ...section, items: [...section.items, optimisticMsg] } : section
                ),
              };
            } else {
              const messageDate = formatDateWithLocale(optimisticMsg.createdAt);
              tt[msgChatIndex] = { ...tt[msgChatIndex], data: [{ createdAt: messageDate, items: [optimisticMsg] }] };
            }
            return tt;
          }
          const messageDate = formatDateWithLocale(optimisticMsg.createdAt);
          return [...tt, { id: targetChatId, data: [{ createdAt: messageDate, items: [optimisticMsg] }] }];
        });
        setTimeout(() => scrollToBottom(targetChatId, "smooth"), 150);
        const uploadOptions = {
          onUploadProgress: (evt) => {
            if (!evt.total) return;
            const pct = Math.round((evt.loaded * 100) / evt.total);
            setVideoUploadProgress(pct >= 100 ? 100 : pct);
          },
        };
        let uploadFailed = false;
        try {
        setVideoCompressing(true);
        setVideoUploadProgress(0);
        const uploadFile = await compressChatVideo(video, {
          onProgress: (pct) => setVideoUploadProgress(pct),
        });
        const compressedUrl = uploadFile.url || URL.createObjectURL(uploadFile);
        uploadFile.url = compressedUrl;
        setTempChatHistory((prev) =>
          patchTempVideoMessage(prev, targetChatId, uniID, {
            fileUrl: [compressedUrl],
            thumbnailUrl: compressedUrl,
            attachedFileName: uploadFile.name,
          })
        );
        setVideoCompressing(false);
        setVideoUploadProgress(0);
        if (!activeReply) {
          let formData = new FormData();
          formData.append("group", chatId);
          formData.append("isGroup", "true");
          formData.append("message", payloadMessage);
          formData.append("attachedFileName", uploadFile.name);
          formData.append("messageType", "video");
          formData.append("sender", `${user?.id}`);
          formData.append("file", uploadFile, uploadFile.name);
          formData.append("isCopied", isCopied);
          formData.append("messageRequestId", uniID);

          const { data } = await callAPI2("/message", {}, "POST", formData, uploadOptions);
          if (data && data.status === false) {
            $crud.notify({ type: "error", message: data.message || strings.video_invalid });
            uploadFailed = true;
          }
          clearDraftMessage();
        } else {
          let formData = new FormData();
          formData.append("id", replyMessage.id);
          formData.append("group", chatId);
          formData.append("isGroup", "true");
          formData.append("message", payloadMessage);
          formData.append("attachedFileName", uploadFile.name);
          formData.append("messageType", "video");
          formData.append("sender", `${user?.id}`);
          formData.append("file", uploadFile, uploadFile.name);
          formData.append("isCopied", isCopied);
          formData.append("messageRequestId", uniID);

          const { data } = await callAPI2(
            `/message/${replyMessage.id}/reply`,
            {},
            "POST",
            formData,
            uploadOptions
          );
          if (data && data.status === false) {
            $crud.notify({ type: "error", message: data.message || strings.video_invalid });
            uploadFailed = true;
          }
          setActiveReply(false);
          setReplyMessage(null);
          clearDraftMessage();
        }
        } catch (err) {
          uploadFailed = true;
        } finally {
          setPendingVideoId(null);
          setVideoUploadProgress(null);
          setVideoCompressing(false);
          setTempChatHistory((prev) => prev.map((entry) => {
            if (entry.id !== targetChatId) return entry;
            return {
              ...entry,
              data: entry.data
                .map((section) => ({
                  ...section,
                  items: uploadFailed
                    ? section.items.filter((item) => item.messageRequestId !== uniID)
                    : section.items.map((item) =>
                        item.messageRequestId === uniID ? { ...item, uploading: false } : item
                      ),
                }))
                .filter((section) => section.items.length > 0),
            };
          }));
          if (!uploadFailed) {
            setTimeout(() => scrollToBottom(targetChatId, "smooth"), 250);
          }
        }
      }
    }
    setIsCopied(false);
  };
  const sendMapMessage = async (message, chatId) => {
    if (chatDetails.isBlock) {
      await $crud.confirm({
        title: strings.unblock_to_send,
        textContent: "",
        options: {
          ok: strings.unblock,
          cancel: strings.cancel,
        },
      });
    const id = chatId;
    const user = chatDetails.otherUserId;
    const { data } = await callAPI(`/group/${id}/block`, {}, "PUT", {
      id: id,
      user: user,
    });
    getDetails(chatId);
    } else {
      let uniID = makeid(10);
      if (message) {
        if (!activeReply) {
          let msg = {
            createdAt: new Date(),
            id: uniID,
            isSend: false,
            message: message.trim(),
            messageLng: "en",
            messageType: "map",
            senderId: user.id,
            userEmoji: [],
            isReply: false,
            messageRequestId: uniID,
            isCopied: isCopied,
            local: true,
          };
          if (tempChatHistory.length > 0) {
            let tt = [...tempChatHistory];
            const lastIdx = tt[0].data.length - 1;
            tt[0].data[lastIdx].items.push(msg);
            setTempChatHistory([...tt]);
          } else {
            let data = [{ items: [{ ...msg }] }];
            let tt = [];
            tt.push({ data: data, id: props.chat?.id });
            setTempChatHistory([...tt]);
          }
          scrollToBottom(chatId, 'smooth'); // Smooth scroll when sending message
          let formData = new FormData();
          formData.append("group", chatId);
          formData.append("isGroup", true);
          formData.append("message", message);
          formData.append("messageRequestId", uniID);
          formData.append("messageType", "map");
          formData.append("sender", user?.id);
          formData.append("isCopied", isCopied);
          const { data } = await callAPI2("/message", {}, "POST", formData);
          clearDraftMessage();
        } else {
          let ttx = replyMessage;
          let msg = {
            createdAt: new Date(),
            id: uniID,
            isSend: false,
            message: message.trim(),
            messageLng: "en",
            messageType: "map",
            senderId: user.id,
            userEmoji: [],
            isReply: true,
            messageRequestId: uniID,
            isSent: true,
            isCopied: isCopied,
            local: true,
            Rid: ttx.id,
            inReplyTo: { ...ttx },
          };
          if (tempChatHistory.length > 0) {
            let tt = [...tempChatHistory];
            const lastIdx = tt[0].data.length - 1;
            tt[0].data[lastIdx].items.push(msg);
            setTempChatHistory([...tt]);
          } else {
            let data = [{ items: [{ ...msg }] }];
            let tt = [];
            tt.push({ data: data, id: props.chat?.id });
            setTempChatHistory([...tt]);
          }
          scrollToBottom(chatId, 'smooth'); // Smooth scroll when sending message
          setActiveReply(false);
          let formData = new FormData();
          formData.append("id", replyMessage.id);
          formData.append("group", chatId);
          formData.append("isGroup", true);
          formData.append("message", message);
          formData.append("messageRequestId", uniID);
          formData.append("messageType", "map");
          formData.append("sender", user?.id);
          formData.append("isCopied", isCopied);
          const { data } = await callAPI2(
            `/message/${replyMessage.id}/reply`,
            {},
            "POST",
            formData
          );
          $crud.notify({
            type: data.status ? "success" : "error",
            message: data.message,
          });
          clearDraftMessage();
          setActiveReply(false);
          setReplyMessage(null);
        }
      }
    }
    setIsCopied(false);
  };

  const scrollToBottom = (chatId, behavior = 'auto') => {
    // In a window (search jump) the bottom is not the newest message: go back to the live chat.
    if (threadWindowRef.current) {
      returnToLatest();
      return;
    }
    // Try multiple times with increasing delays to ensure DOM is ready
    const attemptScroll = (attempt = 1, maxAttempts = 3) => {
      setTimeout(() => {
        const chatContainer = document.getElementById(`chat-sc-${chatId}`);
        if (chatContainer) {
          chatContainer.scrollTo({
            top: chatContainer.scrollHeight,
            behavior: behavior
          });
        }

        // Also try the scroll view
        const scrollView = document.getElementById(`chat-scroll-view-${chatId}`);
        if (scrollView) {
          scrollView.scrollTo({
            top: scrollView.scrollHeight,
            behavior: behavior
          });
        }

        // Try again if we haven't reached max attempts (only for instant scroll)
        if (attempt < maxAttempts && behavior === 'auto') {
          attemptScroll(attempt + 1, maxAttempts);
        }
      }, attempt === 1 ? (behavior === 'auto' ? 100 : 300) : attempt * 200);
    };

    attemptScroll();
  };

  const userTyping = (e, chatId, emoji) => {
    if (e) {
      setMessage(e.currentTarget.value);
    } else {
      if (isComposerToolbarOpen && richEditorRef.current) {
        const editor = richEditorRef.current;
        editor.focus();
        const sel = window.getSelection();
        let range;
        if (sel && sel.rangeCount > 0 && editor.contains(sel.anchorNode)) {
          range = sel.getRangeAt(0);
          range.deleteContents();
        } else {
          range = document.createRange();
          range.selectNodeContents(editor);
          range.collapse(false);
          sel.removeAllRanges();
          sel.addRange(range);
        }
        const textNode = document.createTextNode(emoji);
        range.insertNode(textNode);
        range.setStartAfter(textNode);
        range.setEndAfter(textNode);
        sel.removeAllRanges();
        sel.addRange(range);
        const md = getRichEditorContent();
        setMessage(md);
        return;
      }
      const textAreaElement = document.getElementById(`text-area-${props.chat?.id}`);
      if (!textAreaElement) {
        setMessage((prev) => prev + emoji);
        return;
      }
      setMessage(
        message.substr(0, textAreaElement.selectionStart) +
        emoji +
        message.substr(textAreaElement.selectionEnd)
      );
      resetCursor(textAreaElement.selectionStart, textAreaElement.selectionEnd);
    }
  };

  function resetCursor(x, y) {
    let txtElement = textRef.current;
    if (txtElement.setSelectionRange) {
      txtElement.focus();
      txtElement.setSelectionRange(x, y);
    } else if (txtElement.createTextRange) {
      var range = txtElement.createTextRange();
      range.moveStart("character", 0);
      range.select();
    }
  }

  const handleKeyDown = async (e, chatId) => {
    const keyCode = e.which || e.keyCode;
    if (keyCode === 13 && !e.shiftKey) {
      // Don't generate a new line
      e.preventDefault();
      if (chatDetails.isBlock) {
        await $crud.confirm({
          title: strings.unblock_to_send,
          textContent: "",
          options: {
            ok: strings.unblock,
            cancel: strings.cancel,
          },
        });
    const id = chatId;
    const user = chatDetails.otherUserId;
    const { data } = await callAPI(`/group/${id}/block`, {}, "PUT", {
      id: id,
      user: user,
    });
    getDetails(chatId);
      } else {
        if (e.keyCode === 13) {
          sendMessage();
        }
      }
      // Do something else such as send the message to back-end
      // ...
    }
  };

  // --- In-chat search (the header's search mode, mobile Pro) ---
  const flashMessage = (id) => {
    if (id == null) return;
    clearTimeout(flashTimerRef.current);
    setFlashMessageId(String(id));
    flashTimerRef.current = setTimeout(() => setFlashMessageId(null), 1800);
  };

  // Album and document bubbles show several messages under the first one's id; a result inside
  // one is found (and flashed) through the bubble that shows it.
  const rowIdFor = (id) => (id == null ? null : rowIdByMessageIdRef.current.get(String(id)) || String(id));
  const hitElement = (id) => {
    const rowId = rowIdFor(id);
    return rowId ? document.getElementById(`chat-${rowId}`) : null;
  };

  const jumpToMessage = (id) => {
    if (id == null) return;
    const el = hitElement(id);
    if (el) scrollMessageIntoChat(el);
    flashMessage(rowIdFor(id));
  };

  const waitMs = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const nextFrame = () => new Promise((resolve) => requestAnimationFrame(() => resolve()));

  // --- Search jumps, built from the search index's rows ---
  // The index (chatSearchIndex) keeps every getChat row it paged through, newest = position 0,
  // so a jump needs no network:
  //   result rendered        → smooth scroll to it
  //   just above the top     → its rows are prepended (scroll position kept), then smooth scroll
  //   anywhere else          → the thread fades over to a window of rows around it
  // A window pages from the index rows both ways. Its newest edge rejoins the live chat (page 1)
  // when scrolled down; "scroll to latest" and sending fade back to the live chat.
  const PAGE_SIZE = 30;
  const NEAR_ROWS = 90; // a result at most this far above the top is prepended, not swapped to
  const WINDOW_ROWS = 30; // rows on each side of a result in a window
  const SWAP_FADE_MS = 140; // matches .chat-messages-loaded.is-swapping in chat-pro.css

  const threadChatId = () => props.chat?.id || props.chat?.key;
  const pageOfPosition = (gi) => Math.floor(gi / PAGE_SIZE) + 1;

  // Position (in the index) of the oldest message in the thread, or null when none is indexed.
  const oldestThreadPosition = () => {
    if (threadWindowRef.current) return threadWindowRef.current.oldestGI;
    let oldest = null;
    flattenSections(activeChatSectionsRef.current).forEach((m) => {
      const ids = [m?.id, ...(Array.isArray(m?.images) ? m.images.map((im) => im && im.id) : [])];
      ids.forEach((id) => {
        const at = historySearch.positionOf(id);
        if (at != null && (oldest == null || at > oldest)) oldest = at;
      });
    });
    return oldest;
  };

  const addIndexSlice = (slice, direction) => {
    slice.rows.forEach((m, k) => { m._page = pageOfPosition(slice.from + k); });
    groupByDate(slice.rows, threadChatId(), direction);
  };

  // getChat pagination above index rows continues from the last page they fully cover. New
  // messages only shift positions older, so that page overlaps them (duplicates merge) and
  // never leaves a gap.
  const syncTopPage = (oldestGI, reachedEnd) => {
    const top = Math.max(1, Math.floor((oldestGI + 1) / PAGE_SIZE));
    topPageRef.current = top;
    setTopPage(top);
    const pages = new Set();
    for (let p = 1; p <= top; p += 1) pages.add(p);
    setLoadedPages(pages);
    hasMoreTopRef.current = !reachedEnd;
    setHasMoreTop(!reachedEnd);
  };

  // Older index rows above the thread's top (through position `throughGI`, else one page).
  // False when the index holds none there yet.
  const loadOlderFromIndex = (throughGI = null) => {
    const oldest = oldestThreadPosition();
    if (oldest == null) return false;
    const to = throughGI != null ? throughGI + 1 : oldest + 1 + PAGE_SIZE;
    const slice = historySearch.rowsBetween(oldest + 1, to);
    if (!slice.rows.length) return false;
    addIndexSlice(slice, 'top');
    if (threadWindowRef.current) threadWindowRef.current = { ...threadWindowRef.current, oldestGI: slice.to - 1 };
    syncTopPage(slice.to - 1, slice.end);
    return true;
  };

  // Replaces the thread: this chat's rows in the ref groupByDate merges into are cleared (keeping
  // own messages the server may not have yet when asked), then groupByDate builds it from `rows`.
  const replaceThread = (rows, chatId, keepLocal) => {
    const history = tempChatHistoryRef.current || [];
    const at = findChatHistoryIndex(history, chatId, [props.chat?.id, props.chat?.key]);
    if (at > -1) {
      const kept = keepLocal
        ? (history[at].data || [])
            .map((sec) => ({ ...sec, items: (sec.items || []).filter((m) => m && (m.local === true || m.id == null)) }))
            .filter((sec) => sec.items.length)
        : [];
      tempChatHistoryRef.current = history.map((e, i) => (i === at ? { ...e, data: kept } : e));
    }
    groupByDate(rows, chatId, 'window');
  };

  // Fades the thread out, swaps it, and fades it in once the new rows are laid out.
  const swapThread = async (build) => {
    const swap = ++swapTokenRef.current;
    setThreadSwapping(true);
    const ok = await build(swap);
    if (ok) {
      await nextFrame();
      await nextFrame();
    }
    if (swap === swapTokenRef.current) setThreadSwapping(false);
    return ok;
  };

  const showWindowAround = (id, gi, token) => swapThread(async (swap) => {
    const chatId = threadChatId();
    const requestId = loadingStateRef.current.requestId;
    await waitMs(SWAP_FADE_MS);
    if (token !== searchJumpTokenRef.current || swap !== swapTokenRef.current) return false;
    if (loadingStateRef.current.requestId !== requestId) return false;
    const slice = historySearch.rowsBetween(Math.max(0, gi - WINDOW_ROWS), gi + WINDOW_ROWS + 1);
    if (!slice.rows.length) return false;
    slice.rows.forEach((m, k) => { m._page = pageOfPosition(slice.from + k); });
    windowSeqRef.current += 1;
    threadWindowRef.current = { id: windowSeqRef.current, newestGI: slice.from, oldestGI: slice.to - 1 };
    setHasMoreBottom(true);
    setBottomPage(pageOfPosition(slice.from));
    setCurrentPage(pageOfPosition(slice.from));
    syncTopPage(slice.to - 1, slice.end);
    pendingThreadScrollRef.current = { chatId, target: String(id) };
    replaceThread(slice.rows, chatId, false);
    return true;
  });

  // Back to the live chat from a window (scroll to latest, sending): page 1, scrolled to the bottom.
  const returnToLatest = () => swapThread(async (swap) => {
    const chatId = threadChatId();
    if (!chatId) return false;
    const requestId = loadingStateRef.current.requestId;
    const [response] = await Promise.all([
      fetchChatPage({ chatId, page: 1, limit: PAGE_SIZE, force: true, ...searchPageParams }).catch(() => null),
      waitMs(SWAP_FADE_MS),
    ]);
    if (swap !== swapTokenRef.current || loadingStateRef.current.requestId !== requestId) return false;
    const data = response?.data;
    if (!data?.status) return false;
    const list = Array.isArray(data.chatHistory) ? data.chatHistory : [];
    list.forEach((m) => { m._page = 1; });
    leaveThreadWindow();
    const end = !!data.chatEnd || list.length === 0;
    topPageRef.current = 1;
    setTopPage(1);
    setLoadedPages(new Set([1]));
    hasMoreTopRef.current = !end;
    setHasMoreTop(!end);
    setAwayNewCount(0);
    pendingThreadScrollRef.current = { chatId, target: 'bottom' };
    replaceThread(list, chatId, true);
    return true;
  });

  const leaveThreadWindow = () => {
    threadWindowRef.current = null;
    setHasMoreBottom(false);
    setBottomPage(1);
    setCurrentPage(1);
  };

  // Newer index rows below a window's newest edge; at the index's newest row, page 1 joins the
  // window back to the live chat (or, when too much arrived meanwhile to overlap, fades to it).
  const loadNewerInWindow = async () => {
    const win = threadWindowRef.current;
    if (!win || loadingNewerRef.current) return;
    if (win.newestGI > 0) {
      const slice = historySearch.rowsBetween(Math.max(0, win.newestGI - PAGE_SIZE), win.newestGI);
      if (slice.rows.length) {
        addIndexSlice(slice, 'bottom');
        threadWindowRef.current = { ...win, newestGI: slice.from };
        return;
      }
    }
    loadingNewerRef.current = true;
    setIsLoadingBottom(true);
    try {
      const chatId = threadChatId();
      const response = await fetchChatPage({ chatId, page: 1, limit: PAGE_SIZE, force: true, ...searchPageParams }).catch(() => null);
      if (threadWindowRef.current?.id !== win.id) return;
      const data = response?.data;
      if (!data?.status) return;
      const list = Array.isArray(data.chatHistory) ? data.chatHistory : [];
      const newest = historySearch.rowsBetween(0, 1).rows[0];
      if (newest && list.some((m) => String(m?.id) === String(newest.id))) {
        list.forEach((m) => { m._page = 1; });
        groupByDate(list, chatId, 'bottom');
        leaveThreadWindow();
      } else {
        returnToLatest();
      }
    } finally {
      loadingNewerRef.current = false;
      setIsLoadingBottom(false);
    }
  };

  // Rows prepended from the index for a result just above the top, then a smooth scroll to it.
  const revealAbove = async (id, gi, token) => {
    const oldest = oldestThreadPosition();
    if (oldest == null || gi <= oldest || gi - oldest > NEAR_ROWS) return false;
    // A few rows of context above the result.
    if (!loadOlderFromIndex(gi + 6)) return false;
    await nextFrame();
    await nextFrame();
    if (token !== searchJumpTokenRef.current) return true;
    if (!hitElement(id)) return false;
    jumpToMessage(id);
    return true;
  };

  const waitForPagination = async () => {
    for (let w = 0; w < 300 && (paginationRef.current.isApiCallInProgress || paginationRef.current.isLoadingTop); w += 1) {
      await waitMs(80);
    }
  };

  // ▲ / ▼ / a new query: go to a result. A newer jump takes over from a running one.
  const jumpToSearchHit = async (id) => {
    if (id == null) return;
    const key = String(id);
    searchJumpTokenRef.current += 1;
    const token = searchJumpTokenRef.current;
    if (hitElement(key)) {
      jumpToMessage(key);
      return;
    }
    // Never fight the initial scroll pin of a freshly opened chat.
    for (let i = 0; i < 20 && initialScrollPhaseRef.current; i += 1) await waitMs(100);
    if (token !== searchJumpTokenRef.current) return;
    // Keeps the scroll handler from paginating on its own and the bottom pin away meanwhile.
    scrolledToMessageRef.current = true;
    try {
      // A getChat page still in flight would merge into the swapped thread.
      await waitForPagination();
      if (token !== searchJumpTokenRef.current) return;
      if (hitElement(key)) {
        jumpToMessage(key);
        return;
      }
      const gi = historySearch.positionOf(key);
      if (gi != null) {
        if (await revealAbove(key, gi, token)) return;
        if (token !== searchJumpTokenRef.current) return;
        if (await showWindowAround(key, gi, token)) {
          // Late image heights can move the result a little: settle it smoothly.
          await waitMs(220);
          if (token === searchJumpTokenRef.current) jumpToMessage(key);
          return;
        }
      }
      // Not among the index rows (should not happen): page getChat up to it as a last resort.
      setSearchJumping(true);
      for (let hop = 0; hop < 12; hop += 1) {
        if (token !== searchJumpTokenRef.current) return;
        if (hitElement(key)) break;
        if (!hasMoreTopRef.current) break;
        await waitForPagination();
        if (token !== searchJumpTokenRef.current) return;
        const next = (topPageRef.current || 1) + 1;
        topPageRef.current = next;
        await _getMessages(next, "top");
        await waitMs(140);
      }
      if (token === searchJumpTokenRef.current && hitElement(key)) jumpToMessage(key);
    } finally {
      if (token === searchJumpTokenRef.current) {
        setSearchJumping(false);
        setTimeout(() => {
          if (token === searchJumpTokenRef.current) scrolledToMessageRef.current = false;
        }, 600);
      }
    }
  };

  const openChatSearch = () => {
    setMessageMenu(null);
    setSearch("");
    setSearchDraft("");
    setSearchPos(0);
    setSearchView(true);
  };

  const closeChatSearch = () => {
    searchJumpTokenRef.current += 1;
    searchCurrentIdRef.current = null;
    searchPendingFirstRef.current = false;
    setSearchJumping(false);
    scrolledToMessageRef.current = false;
    setSearchView(false);
    setSearch("");
    setSearchDraft("");
    setSearchPos(0);
  };

  // delta +1 = the next result of the ranked list (▲), -1 = the previous one (▼).
  const stepSearch = (delta) => {
    if (!searchHits.length) return;
    const next = Math.min(Math.max(searchPos + delta, 0), searchHits.length - 1);
    if (next === searchPos) return;
    setSearchPos(next);
    searchCurrentIdRef.current = searchHits[next];
    jumpToSearchHit(searchHits[next]);
  };

  // Highlight of a bubble: its matched parts (word starts only for a tier-1 result).
  const searchHighlightFor = (messageId) => {
    if (!searchView || !searchTerms.length || messageId == null) return "";
    const tier = searchTierById.get(String(messageId));
    return tier ? { terms: searchTerms, wordStartOnly: tier === 1 } : "";
  };

  const handleMessageInfo = async (msg) => {
    if (secretKey && (msg?.messageType === "simple" || msg?.messageType === "image")) {
      const updateChat = {
        ...msg,
        inReplyTo: msg.isForward ? false : (msg.inReplyTo ? { ...msg.inReplyTo, message: msg.inReplyTo.message ? secretKey ? getUsernameFromText((decryptMessage(msg.inReplyTo.message, secretKey))) : msg.inReplyTo.message : msg.inReplyTo.message } : false),
        message: secretKey ? getUsernameFromText((decryptMessage(msg.message, secretKey))) : msg.message,
      };
      await setChatMessage(updateChat);
      setMessageInfo(true);
    }
    else {
      const updateChat = {
        ...msg,
        inReplyTo: msg.isForward ? false : msg.inReplyTo
      };
      await setChatMessage(updateChat);
      setMessageInfo(true);
    }
  };

  const applyUnreadCountToLists = (groupId, unreadCount) => {
    const currentState = store.getState();
    const patch = (list) =>
      (list || []).map((c) => {
        const matches =
          c?.group?.id === groupId ||
          c?.id === groupId ||
          c?.mainId === groupId;
        if (!matches) return c;
        return { ...c, unseenChatCount: unreadCount, isOpened: false };
      });
    const am = currentState.activityMessages || [];
    const ar = currentState.activityMessagesReminders || [];
    if (am.length > 0) {
      dispatch({ type: SET_ACTIVITY_MESSAGES, messages: patch(am) });
    }
    if (ar.length > 0) {
      dispatch({ type: SET_ACTIVITY_MESSAGES_REMINDERS, messages: patch(ar) });
    }
    if (groups && groups.length > 0) {
      props.updateGroups(
        groups.map((g) =>
          g.id === groupId ? { ...g, unseenChatCount: unreadCount } : g
        )
      );
    }
  };

  const handleMarkUnread = async (chat) => {
    if (!chat?.id) return;
    try {
      const { data } = await callAPI(`/message/${chat.id}/unread`, {}, "POST");
      if (!data?.status) {
        await $crud.notify({
          type: "error",
          message: data?.message || (isGerm ? "Nachricht konnte nicht als ungelesen markiert werden." : "Could not mark message as unread."),
        });
        return;
      }
      const unreadCount = Number(data.unreadCount) || 1;
      const groupId = props.chat?.id || data.group;
      applyUnreadCountToLists(groupId, unreadCount);

      // SideNav reads unSeenAllCount from /badge/count (slow). Bump by 1
      // (this message only); the force fetch below reconciles with the BE.
      const a = { ...(store.getState().unSeenAllCount || {}) };
      props.updateAllBadgeCount({
        ...a,
        unseenChatCount: (Number(a.unseenChatCount) || 0) + 1,
      });
      invalidateBadgeCount();
      getBadgesCount(props?.projectDetails?.id);

      // As on mobile: leaving the chat makes it stick (staying would mark it read again).
      handleHeaderBack();
    } catch (err) {
      console.error("Failed to mark message as unread:", err);
      await $crud.notify({
        type: "error",
        message: isGerm ? "Nachricht konnte nicht als ungelesen markiert werden." : "Could not mark message as unread.",
      });
    }
  };

  const addToForwardSelection = (chat) => {
    if (!chat?.id) return msgIdsRef.current || [];
    let ids = [...(msgIdsRef.current || [])];
    const albumIds = [];
    const pushId = (id) => {
      if (!id) return;
      if (!albumIds.some((x) => String(x) === String(id))) albumIds.push(id);
      if (!ids.some((x) => String(x) === String(id))) ids.push(id);
    };
    pushId(chat.id);
    if (chat?.images && chat.images.length > 1) {
      chat.images.forEach((img) => pushId(img.id));
      const key = albumIds.map(String).sort().join(",");
      if (
        albumIds.length > 1 &&
        !forwardAlbumsRef.current.some((a) => a.map(String).sort().join(",") === key)
      ) {
        forwardAlbumsRef.current = [...forwardAlbumsRef.current, albumIds];
      }
    }
    msgIdsRef.current = ids;
    setMsgIds(ids);
    return ids;
  };

  const openForwardPicker = () => {
    setShowForwardPicker(true);
    setForwardPickerVisible(true);
  };

  const handleForward = (chat) => {
    if (!chat?.id) return;
    if (Date.now() < ignoreChatClicksUntil.current) return;
    addToForwardSelection(chat);
    setForward(true);
    openForwardPicker();
  };
  // The project of this chat: its room, or for a Microsoft Teams chat the
  // project it is filed under. 1:1 chats and groups without one have none:
  // there "Mark as task" first asks which project the task is for.
  const chatProjectId = (() => {
    if (teamsInfo) return teamsProject && teamsProject.id != null ? teamsProject.id : null;
    const roomId =
      props.chat?.buildingList ||
      props.chat?.building?.id ||
      props.chat?.building ||
      props.chat?.room?.id;
    const id = roomId && typeof roomId === "object" ? (roomId.id || roomId._id) : roomId;
    return id != null && id !== "" ? id : null;
  })();

  const handleCreateTodo = async (chat, pickedRoomId = null) => {
    const groupId = props.chat?.id || props.chat?.key;
    const resolvedRoomId = chatProjectId || pickedRoomId;
    const alreadyBookmarked = isChatBookmarked(bookmarkedChatIds, chat);
    if (!alreadyBookmarked && !resolvedRoomId) {
      setTaskProjectFor(chat);
      return;
    }

    const result = await toggleChatBookmarkTodo({
      dispatch,
      chat,
      groupId,
      roomId: resolvedRoomId,
      secretKey,
      decryptMessage,
      strings,
      isBookmarked: alreadyBookmarked,
    });

    if (result?.busy) return;
    if (result?.removed) {
      $crud.notify({
        type: "success",
        message: strings.bookmark_removed || "Vorgemerkte Aufgabe entfernt.",
      });
      return;
    }
    if (result?.kept) {
      $crud.notify({
        type: "info",
        message: strings.bookmark_already_todo || "Diese Aufgabe wurde bereits bearbeitet und bleibt bestehen",
      });
      return;
    }
    if (result?.created) {
      $crud.notify({
        type: "success",
        message: strings.todo_bookmarked || "Aufgabe wurde vorgemerkt",
      });
      return;
    }
    if (result?.error) {
      $crud.notify({
        type: "error",
        message: (typeof result.error === "string" && result.error) || strings.todo_creation_failed || "Failed to create ToDo",
      });
    }
  };

  const handleCopy = (chat) => {
    const plainText = getCopyableOriginalText(chat);
    const htmlContent = marked.parse(plainText);
    const htmlBlob = new Blob([htmlContent], { type: "text/html" });
    const textBlob = new Blob([plainText], { type: "text/plain" });
    const CItem = window["ClipboardItem"];
    navigator.clipboard.write([
      new CItem({ "text/html": htmlBlob, "text/plain": textBlob })
    ]).then(() => {
      $crud.notify({ type: "success", message: strings.chat_copied_one || (isGerm ? "Nachricht kopiert" : "Message copied") });
    });
  };

  useEffect(() => {
    const onCopy = (e) => {
      if (e.target?.closest?.('textarea, input, [contenteditable="true"]')) return;
      const sel = window.getSelection();
      if (!sel || sel.rangeCount === 0 || sel.isCollapsed) return;
      const node = sel.getRangeAt(0).commonAncestorContainer;
      const el = node?.nodeType === 1 ? node : node?.parentElement;
      const bubble = el?.closest?.('[id^="chat-"]');
      if (!bubble) return;
      const id = bubble.id.replace(/^chat-/, '');
      let chat = null;
      for (const entry of tempChatHistoryRef.current || []) {
        for (const section of entry.data || []) {
          chat = (section.items || []).find((item) => String(item.id) === String(id));
          if (chat) break;
        }
        if (chat) break;
      }
      if (!chat) return;
      if (showOriginalMapRef.current?.[chat.id]) return;
      const isTranslated = (chat.originalMessage && chat.originalMessage !== chat.message)
        || (chat.originalTranscribedAudio && chat.originalTranscribedAudio !== chat.transcribedAudio);
      if (!isTranslated) return;
      const plain = getCopyableOriginalTextRef.current?.(chat);
      if (!plain) return;
      e.preventDefault();
      e.clipboardData.setData('text/plain', plain);
    };
    document.addEventListener('copy', onCopy);
    return () => document.removeEventListener('copy', onCopy);
  }, []);
  const handleCopyImage = async (chat) => {
    let imageUrl = buildImageUrl(chat.local, chat?.fileUrl, chat?.attachedFileName)
    try {
      // Fetch the image as a Blob
      const response = await fetch(imageUrl);
      const blob = await response.blob();

      if (blob.type != 'image/png') {
        // Convert the image/jpeg Blob to a PNG Blob
        const img = document.createElement('img');
        img.src = URL.createObjectURL(blob);

        img.onload = async () => {
          // Create a canvas to convert the image to PNG
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          // Set canvas size to image size
          canvas.width = img.width;
          canvas.height = img.height;

          // Draw the image on the canvas
          ctx.drawImage(img, 0, 0);

          // Convert the canvas content to a PNG Blob
          canvas.toBlob(async (pngBlob) => {
            try {
              // Copy the PNG Blob using copyBlobToClipboard
              await copyBlobToClipboard(pngBlob);
              $crud.notify({
                type: "success",
                message: strings.chat_image_copied || (isGerm ? "Bild kopiert" : "Image copied"),
              });
              // alert('Image copied to clipboard as PNG!');
            } catch (err) {
              console.error('Failed to copy image: ', err);
            }
          }, 'image/png');
        };
      } else {
        // If the blob is already a supported format (e.g., PNG), copy it directly
        await copyBlobToClipboard(blob);
        $crud.notify({
          type: "success",
          message: "Copied!",
        });
        // alert('Image copied to clipboard!');
      }
    } catch (err) {
      console.error('Failed to copy image: ', err);
    }
  };
  const currentTime = moment();
  // Select mode (mobile Pro): a click on a row ticks / unticks it; a merged album stands for
  // all its images (forwarding and deleting take every one of them).
  const selectIds = (chat) => {
    if (Date.now() < ignoreChatClicksUntil.current) return;
    if (!isSelectableRow(chat)) return;
    const next = toggleRowSelection(chat, msgIdsRef.current || []);
    msgIdsRef.current = next;
    const albumIds = selectionIdsOf(chat);
    if (albumIds.length > 1) {
      const key = albumIds.map(String).sort().join(",");
      const sameAlbum = (a) => a.map(String).sort().join(",") === key;
      forwardAlbumsRef.current = isRowSelected(chat, next)
        ? (forwardAlbumsRef.current.some(sameAlbum) ? forwardAlbumsRef.current : [...forwardAlbumsRef.current, albumIds])
        : forwardAlbumsRef.current.filter((a) => !sameAlbum(a));
    }
    setMsgIds(next);
  };

  // Menu "Select": select mode with this message ticked; the header offers copy · forward · delete.
  const handleSelectMessage = (chat) => {
    if (!chat) return;
    setDelMessage(false);
    setShowForwardPicker(false);
    msgIdsRef.current = [];
    forwardAlbumsRef.current = [];
    setForward(true);
    const next = toggleRowSelection(chat, []);
    msgIdsRef.current = next;
    if (next.length > 1) forwardAlbumsRef.current = [next];
    setMsgIds(next);
  };

  const copySelection = async () => {
    const list = flattenSections(activeChatSections);
    const { text, count } = selectionCopy(list, msgIdsRef.current || msgIds, { myId: user?.id, secretKey });
    if (text) {
      try {
        await navigator.clipboard.writeText(text);
        $crud.notify({
          type: "success",
          message: count === 1
            ? (strings.chat_copied_one || (isGerm ? "Nachricht kopiert" : "Message copied"))
            : (strings.chat_copied_many || (isGerm ? "{n} Nachrichten kopiert" : "{n} messages copied")).replace("{n}", String(count)),
        });
      } catch (_) { /* clipboard blocked */ }
    }
    cancelForward();
  };

  const deleteSelection = async () => {
    const list = flattenSections(activeChatSections);
    const ids = deleteIdsOf(list, msgIdsRef.current || msgIds);
    if (!ids.length) return;
    try {
      document.body.setAttribute('data-confirm-color', 'orange');
      await $crud.confirm({
        title: "",
        textContent: selectedMessages(list, ids).length > 1
          ? (strings.chat_delete_messages_confirm || (isGerm ? "Möchtest du diese Nachrichten wirklich löschen?" : "Do you really want to delete these messages?"))
          : (strings.delete_message_confirm || (isGerm ? "Möchtest du diese Nachricht wirklich löschen?" : "Do you really want to delete this message?")),
        options: {
          ok: strings.delete_label || (isGerm ? "Löschen" : "Delete"),
          cancel: strings.cancel || (isGerm ? "Abbrechen" : "Cancel"),
        },
      });
      document.body.removeAttribute('data-confirm-color');
    } catch (e) {
      document.body.removeAttribute('data-confirm-color');
      return;
    }
    await deleteSelectedMessages(props.chat?.group?.id || props.chat?.id, ids);
    cancelForward();
  };

  const handleForwardMessage = async () => {
    if ((msgIdsRef.current || []).length > 0 || msgIds.length > 0) {
      openForwardPicker();
    } else {
      $crud.notify({
        type: "error",
        message: strings.chat_select_to_forward || (isGerm ? "Wähle die Nachrichten aus, die du weiterleiten möchtest." : "Select the messages you want to forward."),
      });
    }
  };

  const cancelForward = () => {
    if (forward) {
      setForward(false);
    } else {
      setDelMessage(false);
    }
    setShowForwardPicker(false);
    setForwardPickerVisible(true);
    msgIdsRef.current = [];
    forwardAlbumsRef.current = [];
    setMsgIds([]);
  };

  // Puts the caret at the end of the composer (reply / edit start, mobile: the keyboard opens).
  const focusComposer = () => {
    setTimeout(() => {
      const rich = isComposerToolbarOpenRef.current;
      const el = rich ? richEditorRef.current : textRef.current;
      if (!el || typeof el.focus !== "function") return;
      el.focus();
      if (rich && window.getSelection) {
        const range = document.createRange();
        range.selectNodeContents(el);
        range.collapse(false);
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      }
    }, 0);
  };

  // Back arrow of the header (and "Mark as unread", which leaves the chat like on mobile).
  const handleHeaderBack = () => {
    // Fullscreen (from a profile or a direct message): close every chat element and go to the latest messages
    if (isFullscreenMode) {
      dispatch({ type: SET_DEEPLINK_DATA, payload: null });
      dispatch({ type: SET_CHAT_FULLSCREEN, payload: false });
      dispatch({ type: OPEN_CHATS, openChats: [] });
      dispatch({ type: TOGGLE_CHAT, payload: false });
      dispatch({ type: GROUPS, groups: [] });
      dispatch({ type: SET_OPEN_SIDE_BAR, payload: 'LatestMessages' });
      dispatch({ type: RIGHT_TOP, rightTop: '' });
      dispatch({ type: TOGGLE_LATEST_MSG, payload: true });
      dispatch({ type: TOGGLE_TODO_VIEW, payload: false });
      // Background refresh of the latest messages without clearing the cache (no reload loop)
      dispatch({ type: RESET_LATEST_MESSAGES, status: true });
      history.replace("/messages");
      return;
    }
    // Custom back handler (e.g. from ToDo)
    if (props.onBackToParent) {
      props.onBackToParent(props.chat?.id, { backToLatest: true });
      return;
    }
    // Close all open chats and projects to show the list
    dispatch({ type: OPEN_CHATS, openChats: [] });
    dispatch({ type: OPEN_PROJECTS, openProjects: [] });
    dispatch({ type: TOGGLE_LATEST_MSG, payload: true });
    dispatch({ type: TOGGLE_TODO_VIEW, payload: false });
    dispatch({ type: SET_OPEN_SIDE_BAR, payload: 'LatestMessages' });
    dispatch({ type: RESET_LATEST_MESSAGES, status: true });
    history.replace("/messages");
    if (props.handleClose) {
      props.handleClose(props.chat?.id, { backToLatest: true });
    }
  };

  const handleReply = (chat) => {
    if (!chat) return;
    if (editingChatRef.current) cancelEditMessage();
    setActiveReply(true);
    if (
      secretKey &&
      (chat?.messageType === "simple" || chat?.messageType === "image")
    ) {
      const updateChat = {
        ...chat,
        message: secretKey
          ? decryptMessage(chat?.message, secretKey)
          : chat?.message,
      };
      setReplyMessage(updateChat);
    } else {
      setReplyMessage(chat);
    }
    focusComposer();
  };

  const cancelReply = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setActiveReply(false);
    setReplyMessage(null);
  };

  function handleAnchorRef(id) {
    const parentNode = document.getElementById(id);

    // Check if parentNode exists before proceeding
    if (!parentNode) {
      console.warn(`Element with id "${id}" not found`);
      return;
    }

    const scrollView = document.getElementById(`chat-scroll-view-${props.chat?.id}`);
    if (!scrollView) {
      console.warn(`Scroll view with id "chat-scroll-view-${props.chat?.id}" not found`);
      return;
    }

    scrollView.scrollTo({
      top:
        parentNode.offsetTop -
        scrollView.getBoundingClientRect().top -
        40,
      behavior: "smooth",
    });
    parentNode.className += " highlight";
    const t = setTimeout(() => {
      parentNode.className = parentNode.className
        ?.split(" ")
        .filter((a) => a !== "highlight")
        .join(" ");
      clearTimeout(t);
    }, 2000);
  }

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };
  const start = () => {
    // Microsoft Teams chats: no voice messages.
    if (teamsHides(teamsInfoRef.current, "voiceMessage")) return;
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      if (!navigator.getUserMedia && !navigator.webkitGetUserMedia) {
        $crud.notify({ type: "error", message: strings.chat_mic_unavailable || (isGerm ? "Kein Mikrofon gefunden." : "No microphone found.") });
        return;
      }
    }
    recordingStartRef.current = Date.now();
    setAudioRecording(true);
    setRecordState(RecordState.START);
  };

  const stop = () => {
    setRecordState(RecordState.STOP);
  };

  const stopRecording = async (audioData, chatId) => {
    const elapsed = Date.now() - recordingStartRef.current;
    if (audioData && audioData.blob && audioData.blob.size > 100 && elapsed > 500 && audioRecording) {
      const base64 = await convertBase64(audioData.blob);
      const $fileName = new Date().getTime() + ".mp3";
      const audioObj = new File([audioData.blob], $fileName, {
        lastModified: new Date().getTime(),
        type: "audio/mp3",
      });
      sendAudioFile(audioObj, chatId, base64);
    }
    setAudioRecording(false);
  };
  const updateMessageTranscript = (messageId, messageRequestId, transcript, originalTranscript) => {
    const updatedHistory = [...tempChatHistoryRef.current];
    const chatIdx = updatedHistory.findIndex(item => item.id == props.chat?.id);
    if (chatIdx === -1) return;
    let found = false;
    updatedHistory[chatIdx].data = updatedHistory[chatIdx].data.map(section => ({
      ...section,
      items: section.items.map(item => {
        if ((messageId && item.id === messageId) || (messageRequestId && item.messageRequestId === messageRequestId)) {
          found = true;
          const updated = { ...item, transcribedAudio: transcript, transcriptionPending: false };
          if (originalTranscript) updated.originalTranscribedAudio = originalTranscript;
          return updated;
        }
        return item;
      })
    }));
    if (found) setTempChatHistory([...updatedHistory]);
  };

  const setMessageTranscriptPending = (messageId) => {
    const updatedHistory = [...tempChatHistoryRef.current];
    const chatIdx = updatedHistory.findIndex(item => item.id == props.chat?.id);
    if (chatIdx === -1) return;
    let found = false;
    updatedHistory[chatIdx].data = updatedHistory[chatIdx].data.map(section => ({
      ...section,
      items: section.items.map(item => {
        if (item.id === messageId) {
          found = true;
          return { ...item, transcriptionPending: true };
        }
        return item;
      })
    }));
    if (found) setTempChatHistory([...updatedHistory]);
  };

  const requestTranscriptForMessage = (chatMsg) => {
    if (!chatMsg?.id || !chatMsg?.fileUrl || chatMsg.transcribedAudio || chatMsg.transcriptionPending) return;
    setMessageTranscriptPending(chatMsg.id);
    fetchTranscriptForIncoming({ ...chatMsg, groupId: chatMsg.groupId || props.chat?.id });
  };

  const callTranscriptAPI = async (filePath, chatId) => {
    const response = await callAPI("/message/transcriptAudioFile", {}, "POST", { filePath, chatId: `${chatId}` });
    console.log('Transcript API response:', JSON.stringify(response?.data));
    const respData = response?.data;
    const raw = respData?.transcribedAudio
      || respData?.data?.transcribedAudio
      || respData?.transcript
      || respData?.data?.transcript
      || respData?.text
      || respData?.data?.text
      || (typeof respData === 'string' ? respData : null);
    return cleanTranscript(raw);
  };

  const fetchTranscriptForIncoming = async (messageData) => {
    if (messageData.messageType !== 'audio' || messageData.transcribedAudio) return;
    try {
      await new Promise(resolve => setTimeout(resolve, 5000));
      const filePath = Array.isArray(messageData.fileUrl) ? messageData.fileUrl[0] : messageData.fileUrl;
      if (!filePath) {
        updateMessageTranscript(messageData.id, null, null);
        return;
      }
      // The backend keys the transcript on the chat MESSAGE id (it does
      // Chat.findOne({ id }) / updates the chat row), so we must send the
      // message id here — sending the conversation/group id meant the
      // transcript was never persisted and got re-transcribed on every load.
      const transcript = await callTranscriptAPI(filePath, messageData.id);
      if (transcript) {
        if (isAutoTranslation && messageData.senderId !== user?.id &&
            shouldAutoTranslateFromSender(messageData.detectedMessageLanguage, translationLang, autoTransLangsRef.current, messageData.messageMatchesSenderLanguage)) {
          const translated = await getTranslateText(transcript, translationLang);
          if (translated && translated.trim() !== transcript.trim()) {
            updateMessageTranscript(messageData.id, null, translated, transcript);
          } else {
            updateMessageTranscript(messageData.id, null, transcript);
          }
        } else {
          updateMessageTranscript(messageData.id, null, transcript);
        }
      } else {
        updateMessageTranscript(messageData.id, null, null);
      }
    } catch (e) {
      console.error('Incoming transcript error:', e);
      updateMessageTranscript(messageData.id, null, null);
    }
  };

  const fetchTranscriptAndUpdate = async (serverFileUrl, chatId, messageRequestId) => {
    try {
      await new Promise(resolve => setTimeout(resolve, 3000));
      const filePath = Array.isArray(serverFileUrl) ? serverFileUrl[0] : serverFileUrl;
      if (!filePath) return;
      const transcript = await callTranscriptAPI(filePath, chatId);
      if (transcript) updateMessageTranscript(null, messageRequestId, transcript);
    } catch (e) {
      console.error('Transcript API error:', e);
    }
  };

  const updateMessageImageDescription = (messageId, imageDescription) => {
    const updatedHistory = [...tempChatHistoryRef.current];
    const chatIdx = updatedHistory.findIndex(item => item.id == props.chat?.id);
    if (chatIdx === -1) return;
    let found = false;
    updatedHistory[chatIdx].data = updatedHistory[chatIdx].data.map(section => ({
      ...section,
      items: section.items.map(item => {
        if (item.id === messageId) {
          found = true;
          return { ...item, imageDescription };
        }
        return item;
      })
    }));
    if (found) setTempChatHistory([...updatedHistory]);
  };

  const fetchImageDescriptionForIncoming = async (messageData) => {
    if (messageData.messageType !== 'image' || messageData.imageDescription) return;
    try {
      await new Promise(resolve => setTimeout(resolve, 5000));
      const apiUrl = `/group/${messageData.groupId}/getChat?page=1&limit=1`;
      const { data } = await callAPI(apiUrl, {}, 'GET');
      if (data?.status && data?.chatHistory?.length > 0) {
        const msg = data.chatHistory.find(m => m.id === messageData.id);
        if (msg?.imageDescription) {
          updateMessageImageDescription(messageData.id, msg.imageDescription);
        }
      }
    } catch (e) {
      console.error('Image description fetch error:', e);
    }
  };

  const sendAudioFile = async (audio, chatId, base64) => {
    if (chatDetails.isBlock) {
      await $crud.confirm({
        title: strings.unblock_to_send,
        textContent: "",
        options: {
          ok: strings.unblock,
          cancel: strings.cancel,
        },
      });
    const id = chatId;
    const user = chatDetails.otherUserId;
    const { data } = await callAPI(`/group/${id}/block`, {}, "PUT", {
      id: id,
      user: user,
    });
    getDetails(chatId);
    } else {
      let uniID = makeid(10);
      if (audio) {
        if (!activeReply) {
          let msg = {
            createdAt: new Date(),
            id: uniID,
            isSend: false,
            message: message.trim(),
            messageLng: "en",
            messageType: "audio",
            senderId: user.id,
            senderAvatar: user?.avatar,
            userEmoji: [],
            isReply: false,
            messageRequestId: uniID,
            isSent: true,
            fileUrl: [base64],
            local: true,
            attachedFileName: audio.name,
            isCopied: isCopied,
            transcriptionPending: true,
          };
          if (tempChatHistory.length > 0) {
            let tt = [...tempChatHistory];
            const lastIdx = tt[0].data.length - 1;
            tt[0].data[lastIdx].items.push(msg);
            setTempChatHistory([...tt]);
          } else {
            let data = [{ items: [{ ...msg }] }];
            let tt = [];
            tt.push({ data: data, id: props.chat?.id });
            setTempChatHistory([...tt]);
          }
          scrollToBottom(chatId, 'auto');
          let formData = new FormData();
          formData.append("group", `${chatId}`);
          formData.append("isGroup", "true");
          formData.append("message", `${message}`);
          formData.append("messageRequestId", uniID);
          formData.append("attachedFileName", `${audio.name}`);
          formData.append("messageType", "audio");
          formData.append("sender", `${user?.id}`);
          formData.append("file", audio, audio.name);
          formData.append("isCopied", isCopied);

          const { data } = await callAPI2("/message", {}, "POST", formData);
          const serverFileUrl = data?.data?.fileUrl || data?.fileUrl;
          if (serverFileUrl) fetchTranscriptAndUpdate(serverFileUrl, chatId, uniID);
        } else {
          let ttx = replyMessage;
          // Preserve the original message's fileUrl in inReplyTo (don't overwrite with audio URL)
          // Only set fileUrl in inReplyTo if the original message is an audio message
          const inReplyToFileUrl = ttx.messageType === "audio" ? [audio.url] : ttx.fileUrl;
          let msg = {
            createdAt: new Date(),
            id: uniID,
            isSend: false,
            message: message.trim(),
            messageLng: "en",
            messageType: "audio",
            senderId: user.id,
            senderAvatar: user?.avatar,
            userEmoji: [],
            isReply: true,
            messageRequestId: uniID,
            isSent: true,
            Rid: ttx.id,
            inReplyTo: { ...ttx, fileUrl: inReplyToFileUrl },
            fileUrl: [audio.url],
            local: true,
            attachedFileName: audio.name,
            isCopied: isCopied,
            transcriptionPending: true,
          };
          if (tempChatHistory.length > 0) {
            let tt = [...tempChatHistory];
            const lastIdx = tt[0].data.length - 1;
            tt[0].data[lastIdx].items.push(msg);
            setTempChatHistory([...tt]);
          } else {
            let data = [{ items: [{ ...msg }] }];
            let tt = [];
            tt.push({ data: data, id: props.chat?.id });
            setTempChatHistory([...tt]);
          }
          scrollToBottom(chatId, 'auto');
          setActiveReply(false);
          let formData = new FormData();
          formData.append("id", replyMessage.id);
          formData.append("group", `${chatId}`);
          formData.append("isGroup", "true");
          formData.append("message", `${message}`);
          formData.append("attachedFileName", `${audio.name}`);
          formData.append("messageType", "audio");
          formData.append("messageRequestId", uniID);
          formData.append("sender", `${user?.id}`);
          formData.append("file", audio, audio.name);
          formData.append("isCopied", isCopied);
          const { data } = await callAPI2(
            `/message/${replyMessage.id}/reply`,
            {},
            "POST",
            formData
          );
          const serverFileUrl2 = data?.data?.fileUrl || data?.fileUrl;
          if (serverFileUrl2) fetchTranscriptAndUpdate(serverFileUrl2, chatId, uniID);
          setActiveReply(false);
          setReplyMessage(null);
        }
      }
    }
    setIsCopied(false);
  };

  const setText = (e) => {
    if (!e?.target) return;
    const value = e.target.value;
    if (value == null) return;
    setMessage(value);
  };

  const handleEmojiPicker = () => {
    setEmojiPicker(!openEmojiPicker);
  };

  const fetchMoreData = (chatId, direction = 'bottom') => {
    const pg = paginationRef.current;
    // A window (search jump) pages from the search index's rows first.
    if (threadWindowRef.current) {
      if (direction === 'bottom') {
        loadNewerInWindow();
        return;
      }
      if (direction === 'top' && loadOlderFromIndex()) return;
    }
    if (direction === 'top' && !pg.isLoadingTop && hasMoreTop) {
      const nextPage = topPage + 1;
      if (!loadedPages.has(nextPage) && !pg.isApiCallInProgress) {
        pg.loadingDirection = 'top';
        _getMessages(nextPage, 'top');
      }
    } else if (direction === 'bottom' && !isLoadingBottom && hasMoreBottom) {
      const previousPage = bottomPage > 1 ? bottomPage - 1 : deeplinkData?.page_no - 1;
      if (previousPage >= 1 && !loadedPages.has(previousPage) && !pg.isApiCallInProgress) {
        _getMessages(previousPage, 'bottom');
      } else if (previousPage < 1) {
        setHasMoreBottom(false);
      }
    }
  };

  const _sendContact = async (data) => {
    for (let obj of data.conts) {
      let uniID = makeid(10);
      let dt = { ...data, ...obj, messageRequestId: uniID, contacts: [obj.id] };
      let dt1 = {
        ...data,
        ...obj,
        messageRequestId: uniID,
        contacts: [{ ...obj }],
      };
      if (tempChatHistory.length > 0) {
        let tt = [...tempChatHistory];
        const lastIdx = tt[0].data.length - 1;
        tt[0].data[lastIdx].items.push(dt1);
        setTempChatHistory([...tt]);
      }
      $(`.textInput-${props.chat?.id}`).val("");
      const response = await callAPI("/message", {}, "POST", dt);
      
      // Dispatch to update LatestMessages list immediately
      if (response?.data?.message) {
        const contactName = obj.fullName || "Contact";
        dispatch({ 
          type: SET_NEW_MESSAGE_DATA, 
          payload: { 
            ...response.data.message, 
            groupId: props.chat?.id,
            message: contactName,
            previewMessage: contactName
          } 
        });
      }
    }
  };
  // Compute display width for single image containers
  const computeDisplayWidth = () => {
    return '378px';
  };

  const _renderImages = (chatu) => {
    if (!chatu || chatu.messageType !== "image") {
      return null;
    }
    
    let xChat = { ...chatu };
    
    // Ensure images array exists - if not, create it from fileUrl
    if (!xChat.images && xChat.fileUrl) {
      const fileUrls = Array.isArray(xChat.fileUrl) ? xChat.fileUrl : [xChat.fileUrl];
      // Exclude images from spread to avoid circular reference
      const { images: _, ...messageWithoutImages } = xChat;
      // Ensure local flag is preserved - incoming messages should have local: false
      const isLocal = xChat.local !== undefined ? xChat.local : (xChat.senderId === user?.id);
      
      xChat.images = fileUrls.map((url, index) => ({
        ...messageWithoutImages,
        fileUrl: url,
        attachedFileName: Array.isArray(xChat.attachedFileName) 
          ? xChat.attachedFileName[index] 
          : xChat.attachedFileName,
        local: isLocal, // Preserve local flag
        imageDimension: xChat.imageDimension || {
          width: xChat.width || 0,
          height: xChat.height || 0
        }
      }));
      xChat.count = xChat.images.length;
      xChat.isMultiples = xChat.images.length > 1;
      
    }
    
    // If still no images, try to create from fileUrl one more time
    if (!xChat.images || xChat.images.length === 0) {
      console.warn('_renderImages: No images array found, attempting to create from fileUrl');
      if (xChat.fileUrl) {
        const fileUrls = Array.isArray(xChat.fileUrl) ? xChat.fileUrl : [xChat.fileUrl];
        const isLocal = xChat.local !== undefined ? xChat.local : (xChat.senderId === user?.id);
        xChat.images = fileUrls.map((url, index) => ({
          ...xChat,
          fileUrl: url,
          attachedFileName: Array.isArray(xChat.attachedFileName) 
            ? xChat.attachedFileName[index] 
            : xChat.attachedFileName,
          local: isLocal,
          imageDimension: xChat.imageDimension || {
            width: xChat.width || 0,
            height: xChat.height || 0
          }
        }));
      } else {
        console.error('_renderImages: No images array and no fileUrl, cannot render image');
        return null;
      }
    }
    
    // Final check - if still no images, return null
    if (!xChat.images || xChat.images.length === 0) {
      console.error('_renderImages: Still no images after all attempts, returning null');
      return null;
    }
    
    // Render gallery using ImagesWithVideos component
    if (xChat.images && xChat.images.length > 0) {
      const chatId = props.chat?.id || props.chat?.key;
      const extraKeys = [props.chat?.id, props.chat?.key];
      const galleryData = xChat.images.map((img) => {
        const resolved = resolveGalleryImage(
          { ...img, local: img?.local !== undefined ? img.local : !!xChat.local },
          chatId,
          extraKeys
        );
        return { ...img, local: true, url: resolved.url, fallbackUrl: resolved.fallbackUrl, serverUrl: resolved.serverUrl };
      });

      return (
        <div className="chat-image-gallery" style={{ marginTop: 4, maxWidth: "100%", overflow: "hidden" }}>
          <ImagesWithVideos data={galleryData} isC={true} isInternal={!!chatDetails?.isInternal} />
        </div>
      );
    }

    return null;
  };

  const renderUserSuggestion = (
    mention,
    search,
    highlightedDisplay,
    index,
    focus
  ) => {
    return (
      <div
        key={mention.id}
        style={{
          display: "flex",
          flexDirection: "row",
          borderBottom: "1px solid #dfdfdf",
          paddingBottom: 10,
          paddingTop: 10,
        }}
      >
        <div>
          {mention.type != "All" ? (
            <img
              src={
                mention.avatar
                  ? BASE_URL + mention.avatar
                  : process.env.PUBLIC_URL + "/assets/img/contact-us.svg"
              }
              style={{ height: 35, width: 35, borderRadius: 5, objectFit: 'cover' }}
              alt=""
            />
          ) : (
            <span
              className="material-symbols-outlined"
              style={{
                fontSize: 24,
                fontVariationSettings: "'FILL' 0, 'wght' 300, 'GRAD' 0, 'opsz' 24",
                color: '#737373',
              }}
            >
              groups
            </span>
          )}
        </div>
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            paddingLeft: 10,
          }}
        >
          {mention.name}
        </div>
      </div>
    );
  };

  const _getSl = () => {
    return strings.selected;
  };

  // --- Reactions and the message menu (mobile Pro) ---
  // A reaction I already gave is taken back; any other is added.
  const myReactionOf = (chat, hex) => {
    const key = String(hex || "").toLowerCase();
    if (!key || !Array.isArray(chat?.userEmoji)) return null;
    return chat.userEmoji.find((r) => r && String(r.sender) === String(user?.id) && String(r.emoji).toLowerCase() === key) || null;
  };

  const toggleReaction = (chat, glyph) => {
    if (!chat?.id || !glyph) return;
    let hex = "";
    try {
      hex = emojiUnicode(glyph);
    } catch (_) {
      return;
    }
    const mine = myReactionOf(chat, hex);
    if (mine) handleRemoveReaction({ ...mine }, chat.id);
    else handleEmojiReaction(glyph, chat.id);
  };

  // A reaction chip under a bubble: mine → take it back, someone else's → add the same one.
  const toggleReactionChip = (chat, hex, isMine) => {
    if (!chat?.id || !hex) return;
    const mine = isMine ? myReactionOf(chat, hex) : null;
    if (mine) {
      handleRemoveReaction({ ...mine }, chat.id);
      return;
    }
    let glyph = "";
    try {
      glyph = emojiDecode(hex);
    } catch (_) {
      glyph = "";
    }
    if (glyph) handleEmojiReaction(glyph, chat.id);
  };

  const openMessageMenu = (chat, anchor) => {
    if (!chat || chat.isDeleted || forward) return;
    setMessageMenu({ chat, anchor });
  };

  const closeMessageMenu = () => setMessageMenu(null);

  const saveMediaOf = async (chat) => {
    const ok = await saveMessageMedia(chat);
    if (!ok) {
      $crud.notify({
        type: "error",
        message: strings.chat_save_failed || (isGerm ? "Die Datei konnte nicht gespeichert werden." : "The file could not be saved."),
      });
    }
  };

  const menuLabels = {
    reply: strings.reply || (isGerm ? "Antworten" : "Reply"),
    forward: strings.forward || (isGerm ? "Weiterleiten" : "Forward"),
    copy: strings.copy || (isGerm ? "Kopieren" : "Copy"),
    save: strings.chat_menu_save || (isGerm ? "Speichern" : "Save"),
    todo: strings.mark_as_task || (isGerm ? "Als Aufgabe markieren" : "Mark as task"),
    todoRemove: strings.unmark_task || (isGerm ? "Aus Aufgaben entfernen" : "Remove from tasks"),
    translate: strings.translate || (isGerm ? "Übersetzen" : "Translate"),
    markUnread: strings.mark_unread || (isGerm ? "Als ungelesen markieren" : "Mark as unread"),
    select: strings.chat_menu_select || (isGerm ? "Auswählen" : "Select"),
    info: strings.info || "Info",
    edit: strings.chat_menu_edit || (isGerm ? "Bearbeiten" : "Edit"),
    delete: strings.delete_label || (isGerm ? "Löschen" : "Delete"),
  };

  const menuRowsFor = (chat) => {
    if (!chat) return [];
    const readOnly = !!props.chat?.onlyView;
    const canWrite = !readOnly && !chatDetails?.isLeave;
    if (teamsInfo) {
      // Microsoft Teams: no forward / unread / info; edit and delete from the row's
      // teams.canEdit / teams.canDelete (no 10-minute window); "Open in Teams".
      return buildTeamsActionRows({
        chat,
        canWrite: canWrite && teamsInfo.canWrite !== false,
        isBookmarked: isChatBookmarked(bookmarkedChatIds, chat),
        canBookmark: !readOnly && canBookmarkChatMessage(chat),
        canCopy: canCopyChatMessage(chat),
        canTranslate: String(chat.senderId ?? "") !== String(user?.id ?? "") && chat.messageType !== "poll",
        webUrl: teamsInfo.webUrl,
        labels: { ...menuLabels, openInTeams: strings.teams_open_in_teams || (isGerm ? "In Teams öffnen" : "Open in Teams") },
        handlers: {
          reply: () => handleReply(chat),
          copy: () => handleCopy(chat),
          todo: () => handleCreateTodo(chat),
          translate: () => handleTranslate(chat),
          select: () => handleSelectMessage(chat),
          openInTeams: () => openInTeams(teamsInfo.webUrl),
          edit: () => startEditMessage(chat),
          delete: readOnly ? undefined : () => handleDeleteSingleMessage(chat),
        },
      });
    }
    return buildChatActionRows({
      chat,
      myId: user?.id,
      isSelfChat: isSelfChatConversation,
      canWrite,
      isBookmarked: isChatBookmarked(bookmarkedChatIds, chat),
      canBookmark: !readOnly && canBookmarkChatMessage(chat),
      canCopy: canCopyChatMessage(chat),
      labels: menuLabels,
      handlers: {
        reply: () => handleReply(chat),
        forward: () => handleForward(chat),
        copy: () => handleCopy(chat),
        save: () => saveMediaOf(chat),
        todo: () => handleCreateTodo(chat),
        translate: () => handleTranslate(chat),
        markUnread: readOnly ? undefined : () => handleMarkUnread(chat),
        select: () => handleSelectMessage(chat),
        info: () => handleMessageInfo(chat),
        edit: canWrite ? () => startEditMessage(chat) : undefined,
        delete: readOnly ? undefined : () => handleDeleteSingleMessage(chat),
      },
    });
  };

  const handleEmojiReaction = async (emojiData, chatId) => {
    try {
      // Close the picker immediately
      closePreloadedEmojiPicker();
      
      if (!emojiData || !chatId) {
        console.error('Invalid emoji reaction data:', { emojiData, chatId });
        return;
      }

      // Preserve scroll position before updating
      const scrollView = document.getElementById(`chat-sc-${props.chat?.id}`);
      const savedScrollTop = scrollView?.scrollTop || 0;
      
      // Set flag to prevent auto-scroll in useEffect
      emojiUpdateRef.current = { isUpdating: true, scrollTop: savedScrollTop };

      // Get emoji string - emoji-mart uses 'emoji' (our formatted), native uses 'native'
      const emojiString = emojiData?.emoji || emojiData?.native || (typeof emojiData === 'string' ? emojiData : null);
      if (!emojiString) {
        console.error('Invalid emoji string:', emojiString, emojiData);
        return;
      }

      let emojiUnicodeValue;
      try {
        emojiUnicodeValue = emojiUnicode(emojiString);
      } catch (unicodeError) {
        console.error('Error converting emoji to unicode:', unicodeError);
        return;
      }

      const emojiInfo = { sender: user?.id, emoji: emojiUnicodeValue };
      let newEmojiList = [];
      
      // Safely update chat history
      if (tempChatHistory && tempChatHistory[0] && tempChatHistory[0].data) {
        const newChat = tempChatHistory[0].data.map((chatGroup) => {
          return {
            ...chatGroup,
            items: chatGroup?.items?.map((chat) => {
              if (chat?.id !== chatId) return chat;
              newEmojiList = chat?.userEmoji?.length
                ? [...chat.userEmoji, emojiInfo]
                : [emojiInfo];
              return { ...chat, userEmoji: newEmojiList };
            }),
          };
        });
        const newTempChat = [{ id: tempChatHistory[0].id, data: newChat }];
        
        if (newEmojiList?.length && emojiReactionUser?.[0]?.chatId === chatId) {
          getUserListForEmoji({
            emojiList: newEmojiList,
            chatId,
            groupId: props.chat?.id,
            modalIs: false,
          });
        }
        setTempChatHistory(newTempChat);
        
        // Restore scroll position after state update
        requestAnimationFrame(() => {
          if (scrollView && savedScrollTop !== undefined) {
            scrollView.scrollTop = savedScrollTop;
          }
        });
      }
      
      // Make API call
      try {
        await callAPI(`/message/${chatId}/emoji`, {}, "POST", {
          id: chatId,
          emoji: emojiUnicodeValue,
        });
      } catch (apiError) {
        console.error('Error calling emoji API:', apiError);
      }
      
      setEmojiModal({});
    } catch (error) {
      console.error('Error in handleEmojiReaction:', error);
      closePreloadedEmojiPicker();
    }
  };

  const handleRemoveReaction = async (emojiInfo, chatId) => {
    if (user?.id === emojiInfo?.sender) {
      // Preserve scroll position before updating
      const scrollView = document.getElementById(`chat-sc-${props.chat?.id}`);
      const savedScrollTop = scrollView?.scrollTop || 0;
      
      // Set flag to prevent auto-scroll in useEffect
      emojiUpdateRef.current = { isUpdating: true, scrollTop: savedScrollTop };
      
      let newEmojiList = [];
      const newChat = tempChatHistory?.[0]?.data?.map((chatGroup, index) => {
        return {
          ...chatGroup,
          items: chatGroup?.items?.map((chat) => {
            if (chat?.id === chatId) {
              newEmojiList = [...chat?.userEmoji];
              const emojiInd = (newEmojiList || [])?.findIndex(
                (emoji) =>
                  emoji?.sender === emojiInfo?.sender &&
                  emojiInfo?.emoji === emoji?.emoji
              );
              if (emojiInd !== -1) {
                newEmojiList?.splice(emojiInd, 1);
              }
              return {
                ...chat,
                userEmoji: newEmojiList,
              };
            } else {
              return chat;
            }
          }),
        };
      });

      const newTempChat = [{ id: tempChatHistory?.[0]?.id, data: newChat }];

      if (newEmojiList?.length && emojiReactionUser?.[0]?.chatId === chatId) {
        getUserListForEmoji({
          emojiList: newEmojiList,
          chatId,
          groupId: props.chat?.id,
          modalIs: true,
        });
      }
      setTempChatHistory(newTempChat);
      
      // Restore scroll position after state update
      requestAnimationFrame(() => {
        if (scrollView && savedScrollTop !== undefined) {
          scrollView.scrollTop = savedScrollTop;
        }
      });
      
      const { data } = await callAPI(`/message/${chatId}/emoji`, {}, "POST", {
        id: chatId,
        emoji: emojiInfo?.emoji,
      });
      if (newEmojiList?.length === 0) {
        setViewEmojiModal(false);
        setEmojiReactionUser([]);
      }
    }
    return;
  };

  const managerDuplicateEmoji = (messages) => {
    const uniqueMessages = [];
    const seenEmojis = new Set();

    for (const message of messages) {
      if (!seenEmojis.has(message?.emoji)) {
        seenEmojis.add(message?.emoji);
        uniqueMessages.push(message);
      }
    }
    return uniqueMessages;
  };

  const getUserListForEmoji = async ({
    emojiList,
    groupId,
    chatId,
    modalIs,
  }) => {
    // Preserve scroll position before any state changes
    const scrollView = document.getElementById(`chat-sc-${props.chat?.id}`);
    const savedScrollTop = scrollView?.scrollTop || 0;
    
    // Set flag to prevent auto-scroll
    emojiUpdateRef.current = { isUpdating: true, scrollTop: savedScrollTop };
    
    const { data } = await callAPI(`/group/${groupId}/info`, {}, "GET");
    if (data?.status) {
      const findUserById = (userId) =>
        data?.groupInfo?.users?.find((user) => user?.id === userId);

      const newList = emojiList?.map((message) => {
        const user = findUserById(message?.sender);
        return {
          ...message,
          avatar: user?.avatar,
          // A Microsoft Teams person ('teams:<aad>') is no Kjuup user: the reaction carries the name.
          fullName: user?.fullName || message?.senderName || (String(message?.sender || "").startsWith("teams:")
            ? (strings.teams_user_fallback || (isGerm ? "Teams-Benutzer" : "Teams user"))
            : undefined),
          chatId,
        };
      });

      setEmojiReactionUser(newList);

      if (modalIs) {
        setViewEmojiModal(true);
      }
      
      // Restore scroll position after state update
      requestAnimationFrame(() => {
        if (scrollView) {
          scrollView.scrollTop = savedScrollTop;
        }
      });
    }
  };

  const handlePaste = (event) => {
    try {
      const data = event.clipboardData;
      const files = collectPastedImageFiles(data);
      const items = data?.items;
      let hasText = false;
      if (items) {
        for (let i = 0; i < items.length; i++) {
          if (items[i].type && items[i].type.indexOf("text") !== -1) hasText = true;
        }
      }

      if (files.length > 0) {
        event.preventDefault();
        flushComposerRef.current();
        setDropFiles((prevFiles) => [...(prevFiles || []), ...files]);
        setFloatingAction(true);
        return;
      }

      pasteAsPlainText(event);

      if (hasText) {
        const copiedAt = sessionStorage.getItem("copiedFromKjuupPilot");
        const isFromKjuupPilot = copiedAt && Date.now() - parseInt(copiedAt, 10) < 60000;
        if (isFromKjuupPilot) {
          sessionStorage.removeItem("copiedFromKjuupPilot");
          setIsCopied(true);
        } else {
          setIsCopied(false);
        }
      }
    } catch (e) {
      // Never let a paste crash the conversation view
    }
  };

  const _startJitsiCall = async (withVideo = false) => {
    const chatId = props.chat?.id || props.chat?.key;
    if (!chatId) return;
    // Open the call in its OWN browser tab so Kjuup stays usable during the
    // call. window.open MUST run synchronously inside this click handler
    // (before any await) or the popup blocker rejects it. Marking the call
    // active also lets App.js suppress the "Anruf gestartet" ongoing-calls
    // popup for us, the caller (the BE broadcasts videoCallStarted to everyone
    // in the group, including us). `withVideo` decides whether the camera
    // starts on (video call) or off (audio call).
    markCallActive(chatId)
    openCallTab({ roomId: chatId, roomName: props.chat?.name, isGroupChat: false, withVideo })
    try {
      await callAPI(`/videochat/join`, {}, "POST", { room: chatId });
    } catch (err) {
      unmarkCallActive(chatId)
    }
  }

  // Microsoft Teams chat: the call buttons create a Teams meeting (POST /teams/chats/:id/call), send
  // its join link into the chat as a normal message and open it for the caller. Everyone in the chat
  // joins from the "Join now" card (utils/teams/teamsCall), in the Teams app or the browser.
  const sendTeamsCallText = async (chatId, text) => {
    const uniID = makeid(10);
    const msg = {
      createdAt: new Date(),
      id: uniID,
      isSend: false,
      message: secretKey ? encryptMessage(text, secretKey) : text,
      messageLng: "en",
      messageType: "simple",
      senderId: user.id,
      userEmoji: [],
      isReply: false,
      messageRequestId: uniID,
      isSent: true,
      sending: true,
    };
    playSendSound();
    setTempChatHistory((prev) => {
      const idx = prev.findIndex((item) => item.id === chatId);
      if (idx < 0) return [...prev, { id: chatId, data: [{ createdAt: formatDateWithLocale(msg.createdAt), items: [msg] }] }];
      const data = [...(prev[idx].data || [])];
      if (data.length) {
        const last = data.length - 1;
        data[last] = { ...data[last], items: [...(data[last].items || []), msg] };
      } else {
        data.push({ createdAt: formatDateWithLocale(msg.createdAt), items: [msg] });
      }
      const next = [...prev];
      next[idx] = { ...prev[idx], data };
      return next;
    });
    scrollToBottom(chatDetails.id, "auto");
    dispatch({
      type: SET_NEW_MESSAGE_DATA,
      payload: {
        id: uniID,
        groupId: chatId,
        message: text,
        previewMessage: text,
        messageType: "simple",
        senderId: user?.id,
        createdAt: new Date().toISOString(),
        decrypted: true,
        optimistic: true,
      },
    });
    return postOutgoing(uniID, "/message", {
      group: chatId,
      isGroup: true,
      message: secretKey ? encryptMessage(text, secretKey) : text,
      messageType: "simple",
      sender: user?.id,
      messageRequestId: uniID,
      isCopied: false,
    });
  };

  const teamsCallBusyRef = useRef(false);

  const sendTeamsCallLink = async (chatId, video, tab) => {
    if (teamsCallBusyRef.current) return;
    teamsCallBusyRef.current = true;
    try {
      if (tab) {
        try {
          tab.document.title = "Microsoft Teams";
          tab.document.body.textContent = tr("teams_call_opening", "Teams wird geöffnet…", "Opening Teams…");
        } catch (_) {
          /* not ours to write */
        }
      }
      const r = await createTeamsCallLink(chatId, { video });
      if (!r.ok) {
        if (tab && !tab.closed) tab.close();
        if (r.code === "call_consent_required") {
          askTeamsCallConsent(chatId, video, r.accountId);
          return;
        }
        $crud.notify({ type: "error", message: r.message || tr("teams_call_failed", "Der Teams-Anruf konnte nicht gestartet werden.", "The Teams call could not be started.") });
        return;
      }
      await sendTeamsCallText(chatId, teamsCallMessage({ url: r.joinUrl, video }, strings, isGerm));
      if (tab && !tab.closed) {
        try {
          tab.opener = null;
          tab.location.href = r.joinUrl;
        } catch (_) {
          if (!tab.closed) tab.close();
        }
      }
    } finally {
      teamsCallBusyRef.current = false;
    }
  };

  const startTeamsCall = (video) => {
    const chatId = props.chat?.id || props.chat?.key;
    if (!chatId || teamsCallBusyRef.current) return;
    $crud
      .confirm({
        title: video
          ? tr("teams_call_confirm_video", "Teams-Videoanruf starten?", "Start a Teams video call?")
          : tr("teams_call_confirm_audio", "Teams-Anruf starten?", "Start a Teams call?"),
        textContent: tr(
          "teams_call_confirm_body",
          "Kjuup sendet einen Link zum Beitreten in diesen Chat. Alle im Chat können über die Teams-App oder den Browser beitreten.",
          "Kjuup sends a join link into this chat. Everyone in the chat can join in the Teams app or the browser."
        ),
        options: {
          ok: tr("teams_call_confirm_ok", "Link senden & beitreten", "Send link & join"),
          cancel: strings.cancel || (isGerm ? "Abbrechen" : "Cancel"),
        },
      })
      .then(() => {
        // Opened inside the click so the browser does not block it; the meeting is loaded into it.
        let tab = null;
        try {
          tab = window.open("", "_blank");
        } catch (_) {
          tab = null;
        }
        return sendTeamsCallLink(chatId, video, tab);
      })
      .catch(() => {});
  };

  // The account has not allowed Teams meetings yet: the Microsoft sign-in once more, now also asking
  // for the meeting permission (auth-url calls=1). After it the link is created and sent.
  const askTeamsCallConsent = (chatId, video, accountId) => {
    $crud
      .confirm({
        title: tr("teams_call_consent_title", "Teams-Anrufe erlauben", "Allow Teams calls"),
        textContent: tr(
          "teams_call_consent_body",
          "Für Anrufe braucht Kjuup einmalig deine Erlaubnis bei Microsoft, Besprechungen zu erstellen.",
          "For calls, Kjuup needs your one-time permission in Microsoft to create meetings."
        ),
        options: {
          ok: tr("teams_call_consent_ok", "Erlauben", "Allow"),
          cancel: strings.cancel || (isGerm ? "Abbrechen" : "Cancel"),
        },
      })
      .then(async () => {
        let popup = null;
        try {
          popup = window.open("", "kjuup-teams-oauth", "width=600,height=720,scrollbars=yes");
        } catch (_) {
          popup = null;
        }
        const r = await getTeamsAuthUrl({ accountId, calls: true });
        if (!r.ok) {
          if (popup && !popup.closed) popup.close();
          $crud.notify({ type: "error", message: r.message || tr("teams_call_failed", "Der Teams-Anruf konnte nicht gestartet werden.", "The Teams call could not be started.") });
          return;
        }
        if (!popup || popup.closed) {
          // Popups blocked: the sign-in runs in this tab and comes back to the Teams settings.
          window.location.assign(r.url);
          return;
        }
        popup.location.href = r.url;
        popup.focus();
        const onMessage = (event) => {
          if (event.source !== popup) return;
          const link = teamsReturnFromMessage(event && event.data);
          if (!link) return;
          window.removeEventListener("message", onMessage);
          handleTeamsReturn(link, { strings })
            .then((result) => {
              if (result && result.ok) {
                $crud.notify({ type: "success", message: tr("teams_call_consent_done", "Teams-Anrufe sind erlaubt.", "Teams calls are allowed.") });
                sendTeamsCallLink(chatId, video, null);
              } else if (result) {
                $crud.notify({ type: "error", message: result.message });
              }
            })
            .catch(() => {});
        };
        window.addEventListener("message", onMessage);
        // Stop listening once the popup is gone (closed without finishing).
        const watch = setInterval(() => {
          if (!popup || popup.closed) {
            clearInterval(watch);
            setTimeout(() => window.removeEventListener("message", onMessage), 2000);
          }
        }, 1000);
      })
      .catch(() => {});
  };

  // NOTE: The per-room /videochat/get call was removed because it added a
  // ~1.9s round-trip to every chat open while providing no information that
  // isn't already available on the client:
  //   - Active call status comes from the global `runningCalls` selector,
  //     which is populated by /videochat/getRunningCalls and kept fresh by
  //     socket events (videoCallStarted / videoCallEnded).
  //   - dmCallFeatureEnabled is sourced from the user profile in Redux.
  // The backend still validates on /videochat/join.

  const JoinCall = async () => {
    const chatId = props.chat?.id || props.chat?.key;
    if (!chatId) return;
    markCallActive(chatId)
    openCallTab({ roomId: chatId, roomName: props.chat?.name, isGroupChat: false })
    setIsCallRunning(false)
    try {
      await callAPI(`/videochat/join`, {}, "POST", { room: chatId, joinOnly: true });
    } catch (err) {
      unmarkCallActive(chatId)
    }
  }

  const JoinCallButton = () => {
    return (
      <div onClick={() => { JoinCall() }} style={{ cursor: "pointer", position: "absolute", top: 70, left: "calc(50% + 10px)", transform: "translateX(-50%)", zIndex: 1000, backgroundColor: "#fff", borderRadius: 10 }}>
        <AcceptCallButton />
      </div>
    );
  };

  const checkForMarkdownContailsOrNot = (message) => {
    let mess = secretKey ? decryptMessage(message, secretKey) : message;
    mess = cleanMarkdownWhitespace(mess);
    if (containsMarkdown(mess)) {
      return mess?.trim();
    }
    return getUsernameFromText(mess?.trim());
  };

  const _renderCommonMarkDownCmp = (message, messageId = null) => {
    const processedMessage = checkForMarkdownContailsOrNot(message);
    const isExpanded = messageId ? expandedMessages[messageId] : true;
    return (
      <ChatMessageMarkdown
        message={processedMessage}
        messageId={messageId}
        isExpanded={isExpanded}
        toggleMessageExpansion={toggleMessageExpansion}
        isDesktop={isDesktop}
        screenWidth={screenWidth}
        moreLabel={strings.see_more || (isGerm ? "...mehr" : "...more")}
        highlight={searchHighlightFor(messageId)}
      />
    );
  };

  const renderSimpleMessageBody = (chat) => {
    if (chat.isDeleted) {
      return <span className="kjc-deleted">{strings.message_delete}</span>;
    }
    return _renderCommonMarkDownCmp(getDisplayMessage(chat), chat.id);
  };

  const openPostedDocPreview = (item) => {
    if (shouldOpenInlineDocViewer(item)) {
      dispatch({ type: SET_VIEWER_IINITAL_INDEX, index: 0 });
      dispatch({ type: SET_VIEWER_IMAGES, ViewerImages: buildDocViewerItems([item]) });
      dispatch({ type: SET_VIEWER_IS_INTERNAL, isInternal: !!chatDetails?.isInternal });
      return;
    }
    setDoc(item);
    setViewDoc(true);
  };

  // ---------------------------------------------------------------------------
  // Mobile Pro chat: header values, labels and the thread rows
  // ---------------------------------------------------------------------------
  const tr = (key, de, en) => (strings && strings[key]) || (isGerm ? de : en);
  const absMediaUrl = (p) =>
    typeof p === "string" && p.trim() ? (/^(https?:|blob:|data:)/i.test(p) ? p : BASE_URL + p) : null;
  const hasChatDetails = !!(chatDetails && typeof chatDetails === "object" && !Array.isArray(chatDetails) && Object.keys(chatDetails).length > 0);
  const headerTitle = isSelfChatConversation
    ? (strings.my_notes || "My Space")
    : teamsInfo
      ? stripMarkdown(teamsHeaderTitle || (typeof props.chat?.name === "string" && props.chat.name) || (typeof chatDetails.name === "string" ? chatDetails.name : "") || "Microsoft Teams")
    : props.chat?.defaultChatGroup
      ? (isGerm ? "Alle" : "All")
      : stripMarkdown(
          (typeof translatedChatName === "string" && translatedChatName) ||
          (typeof props.chat?.name === "string" && props.chat.name) ||
          (typeof chatDetails.name === "string" ? chatDetails.name : "")
        ).replace(/All members of the (room|project)/, strings.all_member_of_project);
  const headerAvatar = isSelfChatConversation
    ? { kind: "self", name: headerTitle }
    : teamsInfo
      // Teams people have no Kjuup photo or presence: initials (1:1) or the group tile.
      ? { kind: teamsInfo.chatType === "oneOnOne" ? "person" : "group", name: headerTitle, src: null, online: false }
    : {
        kind: "person",
        name: chatDetails?.otherUserName || headerTitle,
        src: absMediaUrl(chatDetails?.otherUserAvatar || (typeof props.chat?.avatar === "string" ? props.chat.avatar : null)),
        online: !!chatDetails?.isOnline,
      };
  let headerSubline = null;
  let headerSublineAccent = false;
  if (peerTyping) {
    headerSubline = `${tr("chat_typing", "schreibt", "typing")}…`;
    headerSublineAccent = true;
  } else if (isCallRunning) {
    headerSubline = strings.call_is_started || (isGerm ? "Anruf gestartet" : "Call is started");
    headerSublineAccent = true;
  } else if (teamsInfo) {
    // Microsoft Teams: "Microsoft Teams" for a 1:1, the Teams members for a group, then the
    // project room the chat is filed under.
    headerSubline = teamsInfo.chatType === "oneOnOne"
      ? "Microsoft Teams"
      : (teamsMembersLine(chatDetails?.users, user?.id) || "Microsoft Teams");
    if (teamsProject && teamsProject.name) headerSubline = `${headerSubline} · ${stripMarkdown(teamsProject.name)}`;
  } else if (!isSelfChatConversation && chatDetails?.isOnline) {
    headerSubline = tr("chat_online", "online", "online");
  } else if (!isSelfChatConversation && chatDetails?.lastOnlineAt) {
    headerSubline = lastOnlineText(chatDetails.lastOnlineAt, strings, language);
  }
  const headerLabels = {
    back: strings.back || (isGerm ? "Zurück" : "Back"),
    openInfo: tr("chat_open_info", "Chat-Info öffnen", "Open chat info"),
    videoCall: strings.video_call || (isGerm ? "Videoanruf" : "Video call"),
    audioCall: strings.audio_call || (isGerm ? "Audioanruf" : "Audio call"),
    searchInChat: tr("chat_search_in_chat", "Im Chat suchen", "Search in chat"),
    closeSearch: tr("chat_search_close", "Suche schließen", "Close search"),
    searchPlaceholder: tr("chat_search_placeholder", "In diesem Chat suchen", "Search in this chat"),
    clear: tr("chat_search_clear", "Leeren", "Clear"),
    // ▲ goes on to the next ranked result, ▼ back to the previous one
    prevMatch: tr("chat_search_next", "Nächster Treffer", "Next match"),
    nextMatch: tr("chat_search_prev", "Vorheriger Treffer", "Previous match"),
    searching: tr("chat_search_running", "Suche läuft …", "Searching…"),
    pressEnter: tr("chat_search_press_enter", "Enter ↵ zum Suchen", "Press Enter ↵ to search"),
    loadingResult: tr("chat_search_loading_hit", "Lade Treffer {n} …", "Loading result {n}…"),
    noResults: tr("chat_search_no_results", "Keine Treffer", "No results"),
    cancel: strings.cancel || (isGerm ? "Abbrechen" : "Cancel"),
    selected: tr("chat_selected", "ausgewählt", "selected"),
    copy: strings.copy || (isGerm ? "Kopieren" : "Copy"),
    forward: strings.forward || (isGerm ? "Weiterleiten" : "Forward"),
    delete: strings.delete_label || (isGerm ? "Löschen" : "Delete"),
  };
  const metaLabels = {
    edited: strings.message_edited || (isGerm ? "bearbeitet" : "edited"),
    retry: tr("chat_retry_send", "Erneut senden", "Send again"),
    read: tr("chat_info_read", "Gelesen", "Read"),
    delivered: tr("chat_info_delivered", "Zugestellt", "Delivered"),
    sent: tr("chat_status_sent", "Gesendet", "Sent"),
    pending: tr("chat_status_pending", "Wird gesendet …", "Sending…"),
  };
  // Microsoft Teams has no delivered / read receipts: only the delivery into Teams shows.
  const teamsMetaRow = (chat) => {
    const d = teamsDeliveryOf({ ...chat, isTeams: true });
    return {
      ...chat,
      messageReadByAll: false,
      messageReachedToAll: false,
      failedToSend: !!chat.failedToSend || d === "failed",
      sending: !!chat.sending || !!chat.uploading || (!!chat.local && chat.isSent === false) || d === "pending",
    };
  };
  const teamsMetaLabels = {
    ...metaLabels,
    retry: tr("chat_retry_send", "Erneut senden", "Send again"),
    pending: strings.teams_sending || (isGerm ? "Wird an Teams gesendet…" : "Sending to Teams…"),
  };
  const transLabels = {
    translating: tr("chat_translating", "Wird übersetzt …", "Translating…"),
    original: tr("chat_original", "Original", "Original"),
    translatedFrom: tr("chat_translated_from", "Übersetzt aus", "Translated from"),
    translated: tr("chat_translated", "Übersetzt", "Translated"),
    showTranslation: tr("chat_show_translation", "Übersetzung anzeigen", "Show translation"),
    showOriginal: tr("chat_show_original", "Original anzeigen", "Show original"),
  };
  const hoverLabels = {
    add_reaction: strings.add_reaction || (isGerm ? "Reaktion hinzufügen" : "Add reaction"),
    reply: strings.reply || (isGerm ? "Antworten" : "Reply"),
    more_options: strings.more_options || (isGerm ? "Mehr Optionen" : "More options"),
  };
  const threadList = flattenSections(activeChatSections);
  const selectedCount = forward ? selectedMessages(threadList, msgIds).length : 0;
  const selectionDeletable = forward && !props.chat?.onlyView && allSelectedDeletable(threadList, msgIds, user?.id);
  const openChatInfo = () => {
    setMessageMenu(null);
    setViewInfo(true);
  };
  const unreadBandLabel = (n) =>
    n === 1
      ? `1 ${tr("chat_unread_one", "ungelesene Nachricht", "unread message")}`
      : `${n} ${tr("chat_unread_many", "ungelesene Nachrichten", "unread messages")}`;

  const isOwnMessage = (chat) => chat != null && user?.id != null && String(chat.senderId) === String(user.id);

  // null = not a system row; false = a system row that stays hidden (1:1 unblock notes, #36).
  const systemNoteOf = (chat) => {
    if (!chat) return null;
    const own = isOwnMessage(chat);
    const oneToOne = !!(chatDetails?.isOneToOne || props.chat?.isOneToOne);
    if (chat.pendingGroup) return <>{chat.pendingGroup} {strings.PENDING_GROUP_USER}</>;
    if (chat.joinedGroup) {
      if (oneToOne) return false;
      if (own) return chat.chat_from_start ? strings.chat_from_start_have : strings.you_joined_group_chat;
      return <>{chat.senderName} {chat.chat_from_start ? strings.chat_from_start_has : strings.joined_group_chat}</>;
    }
    if (chat.userDeleted) return <>{chat.senderName} {oneToOne ? strings.deleted_direct : strings.delteed}</>;
    if (chat.userReactivate) return own ? strings.reactive_itself : <>{chat.senderName} {strings.reactive}</>;
    if (chat.userDeactivated) return own ? strings.has_deactivated_itself : <>{chat.senderName} {strings.has_deactivated}</>;
    if (chat.rejectedGroup) return <>{chat.senderName}{strings.denied_group_chat}</>;
    if (chat.leftGroup) {
      if (own) return oneToOne ? strings.you_have_blocked : <>{strings.you} {strings.YOU_LEFT_GROUP}</>;
      if (oneToOne) return false;
      return <>{chat.senderName} {strings.LEFT_GROUP}</>;
    }
    return null;
  };

  // Right-click on a bubble opens the message menu at the pointer (mobile: long press); with
  // text selected inside the bubble the browser's own menu stays (copying a part of a message).
  const handleBubbleContextMenu = (e, chat) => {
    if (props.chat?.onlyView || forward || !chat || chat.isDeleted) return;
    const sel = window.getSelection ? window.getSelection() : null;
    if (sel && !sel.isCollapsed && e.currentTarget.contains(sel.anchorNode)) return;
    if (e.target && e.target.closest && e.target.closest("a, video, audio, input, textarea")) return;
    e.preventDefault();
    openMessageMenu(chat, { x: e.clientX, y: e.clientY });
  };

  const linkPreviewsOf = (chat) => {
    if (chat.all) return chat.all;
    if (!chat.message || typeof chat.message !== "string") return [];
    let found = extractUrls(secretKey ? decryptMessage(chat.message, secretKey) : chat.message);
    found = Array.isArray(found) ? found.map((u) => u.replace("&quot", "")) : [];
    return [...new Set(found)].reduce((acc, lnk) => {
      if (lnk.match("vimeo")) acc.push({ href: lnk, videoType: "vimeo" });
      else if (lnk.match("youtube") || lnk.match("youtu")) acc.push({ href: lnk, videoType: "youtube" });
      return acc;
    }, []);
  };

  // Microsoft Teams group chat: the other people's names over their messages (like a room group).
  const teamsGroupChat = !!(teamsInfo && teamsInfo.chatType !== "oneOnOne");
  const teamsSenderOf = (chat) =>
    teamsSenderName(chat, chatDetails?.users, strings.teams_user_fallback || (isGerm ? "Teams-Benutzer" : "Teams user"));

  const renderBubbleContent = (chat, own, index, first = false) => {
    const type = chat.messageType;
    const text = getDisplayMessage(chat);
    const hasText = typeof text === "string" && text.trim().length > 0;
    const links = type === "simple" ? linkPreviewsOf(chat) : [];
    // A Teams meeting link (call buttons of a Teams chat, or pasted): "Join now" card.
    const teamsCall = type === "simple" && hasText && !chat.isDeleted
      ? teamsCallOf(secretKey ? decryptMessage(text, secretKey) : text)
      : null;
    return (
      <>
        {teamsGroupChat && !own && first ? (
          <span className="kjc-sender" style={{ color: getSenderColor(chat.senderId) }}>
            {teamsSenderOf(chat)}
          </span>
        ) : null}
        {chat.isForward ? <ForwardedBadge label={strings.forwarded} /> : null}
        {chat.isReply && !chat.isForward ? (
          <ReplyPreview
            chat={chat}
            side={own ? "right" : "left"}
            onAnchorClick={handleAnchorRef}
            userId={user?.id}
            strings={strings}
            secretKey={secretKey}
            chatId={props.chat?.id}
          />
        ) : null}
        {links.length > 0 ? (
          <div className="kjc-bubble__player">
            <PlayerFeed Links={links} article={{}} />
          </div>
        ) : null}
        {type === "simple" && chat.taskNotice ? (
          <TaskNoticeMessage
            notice={chat.taskNotice}
            userId={user?.id}
            busy={taskNoticeBusy != null && String(taskNoticeBusy) === String(chat.taskNotice.todoId)}
            onConfirm={confirmTaskNotice}
            onOpenTask={openTaskNoticeTask}
          />
        ) : null}
        {type === "simple" && !chat.taskNotice && teamsCall ? (
          <TeamsCallMessage
            call={teamsCall}
            body={teamsCall.rest ? <div className={`kjc-bubble__text simple-msg-${props.chat?.id}`}>{renderSimpleMessageBody(chat)}</div> : null}
          />
        ) : null}
        {type === "simple" && !chat.taskNotice && !teamsCall ? (
          <div className={`kjc-bubble__text simple-msg-${props.chat?.id}`}>{renderSimpleMessageBody(chat)}</div>
        ) : null}
        {type === "image" ? (
          <div className="image-message-wrapper" style={{ width: computeDisplayWidth() }}>
            <div className="group-ct-image">
              <LazyMedia type="image" eager={true}>{_renderImages(chat)}</LazyMedia>
            </div>
            {hasText ? (
              <div className={`kjc-bubble__caption simple-msg-${props.chat?.id}`}>
                {_renderCommonMarkDownCmp(text, chat.id)}
              </div>
            ) : null}
          </div>
        ) : null}
        {type === "doc" ? (
          <LazyMedia type="doc" eager={!chat._page || chat._page === 1}>
            {chat.documents && chat.documents.length > 1 ? (
              <DocumentGalleryView
                documents={chat.documents}
                isInternal={!!chatDetails?.isInternal}
                onPreviewDoc={openPostedDocPreview}
                caption={hasText ? _renderCommonMarkDownCmp(text, chat.id) : null}
              />
            ) : (
              <div className="pointer">
                <DownloadFileWithIcon info={chat} group={true} isMe={!own} onPreview={openPostedDocPreview} />
                {hasText ? <div className="kjc-bubble__caption">{_renderCommonMarkDownCmp(text, chat.id)}</div> : null}
              </div>
            )}
          </LazyMedia>
        ) : null}
        {type === "audio" ? (
          <div className="pointer">
            <LazyMedia type="audio" eager={!chat._page || chat._page === 1}>
              <VoiceMessageWithTranscript
                src={buildImageUrl(chat.local, chat?.fileUrl)}
                audioType={chat?.fileUrl && String(chat.fileUrl).includes(".mp3") ? "audio/mp3" : "audio/wav"}
                senderAvatar={chat?.senderAvatar}
                transcribedAudio={chat?.transcribedAudio}
                transcriptionPending={chat?.transcriptionPending}
                translationPending={chat?.translationPending}
                originalTranscribedAudio={chat?.originalTranscribedAudio}
                highlight={searchHighlightFor(chat.id)}
                onCreateTodo={own ? (t) => handleCreateTodo({ ...chat, message: t }) : undefined}
                onRequestTranscript={() => requestTranscriptForMessage(chat)}
              />
            </LazyMedia>
          </div>
        ) : null}
        {type === "video" ? (
          <div className="video-message">
            <ChatVideoBubble
              fileUrl={chat.fileUrl}
              thumbnailUrl={chat.thumbnailUrl}
              local={chat.local}
              attachedFileName={chat.attachedFileName}
              uploading={!!chat.uploading || chat.messageRequestId === pendingVideoId}
              progress={chat.messageRequestId === pendingVideoId ? videoUploadProgress : null}
              processing={chat.messageRequestId === pendingVideoId && videoCompressing}
              serverFileUrl={chat.serverFileUrl}
            />
            {hasText ? <div className="kjc-bubble__caption">{_renderCommonMarkDownCmp(text, chat.id)}</div> : null}
          </div>
        ) : null}
        {type === "map" ? (
          <div className="map" id={`map-${index}`}>
            <LocationMapPreview url={decryptMessage(chat.message, secretKey)} />
          </div>
        ) : null}
        {type === "contact" ? (
          <div className="kjc-contacts">
            {(chat.contacts || []).map((c, i) => (
              <Link
                key={c?.id || i}
                to={`/user-profile/${c?.id}`}
                className="kjc-contact"
                onClick={(e) => e.stopPropagation()}
              >
                <ChatAvatar size={36} name={c?.fullName} src={absMediaUrl(c?.avatar)} />
                <span className="kjc-contact__name">{c?.fullName}</span>
              </Link>
            ))}
          </div>
        ) : null}
      </>
    );
  };

  const renderMessageRow = (chat, index, items, sindex) => {
    if (!chat) return null;
    const messageKey = chat?.messageRequestId || chat?.id || `msg-${sindex}-${index}`;
    const unread = unreadAtOpenRef.current;
    const band =
      unread > 0 && unreadAnchorId != null && String(chat.id) === unreadAnchorId ? (
        <UnreadBand key={`unread-${messageKey}`} label={unreadBandLabel(unread)} />
      ) : null;
    const noAnim = chat?.skipAnimation || chat?.animated;
    const flash = flashMessageId != null && String(chat.id) === flashMessageId;
    const note = systemNoteOf(chat);
    if (note !== null) {
      if (note === false) return band;
      return (
        <React.Fragment key={messageKey}>
          {band}
          <div className={`chat-message-item kjc-row kjc-row--note${noAnim ? " no-animation" : ""}`} id={`chat-${chat.id}`}>
            <SystemNote focused={flash}>{note}</SystemNote>
          </div>
        </React.Fragment>
      );
    }
    if (!chat.isDeleted && (chat.message === null || (chat.messageType === "simple" && !String(chat.message || "").trim()))) {
      return band;
    }
    const own = isOwnMessage(chat);
    const older = index > 0 ? items[index - 1] : null;
    const first = !older || isSystemRow(older) || String(older.senderId) !== String(chat.senderId);
    const selectable = isSelectableRow(chat);
    const selected = forward && isRowSelected(chat, msgIds);
    const readOnly = !!props.chat?.onlyView;
    const reactions = !chat.isDeleted && Array.isArray(chat.userEmoji) && chat.userEmoji.length > 0;
    const translated = !!(chat.originalMessage && chat.originalMessage !== chat.message);
    const showTrans = !own && !chat.isDeleted && chat.messageType !== "audio" && (chat.translationPending || translated);
    const canAct = !readOnly && !forward && !chat.isDeleted;
    // Microsoft Teams row: reply and react only once the message reached Teams.
    const teamsCaps = teamsInfo ? teamsRowCaps({ ...chat, isTeams: true }) : null;
    const canReactHere = !teamsCaps || teamsCaps.canReact;
    const teamsDelivery = teamsInfo && own ? teamsDeliveryOf(chat) : null;
    return (
      <React.Fragment key={messageKey}>
        {band}
        <div
          className={`chat-message-item kjc-row${first ? " is-run-start" : ""}${forward && selectable ? " is-selectable" : ""}${selected ? " is-selected" : ""}${flash ? " is-flash" : ""}${reactions ? " has-reactions" : ""}${noAnim ? " no-animation" : ""}`}
          onClick={forward && selectable ? () => selectIds(chat) : undefined}
        >
          {forward ? (
            <div className="kjc-check-col">
              <SelectCheck
                on={selected}
                disabled={!selectable}
                onToggle={() => selectIds(chat)}
                label={tr("chat_select_message", "Nachricht auswählen", "Select message")}
              />
            </div>
          ) : null}
          {teamsGroupChat && !own ? (
            <div className="kjc-avatar-col">
              {first ? <ChatAvatar size={30} name={teamsSenderOf(chat)} src={null} /> : null}
            </div>
          ) : null}
          <div className={own ? "forword-conver" : "forword-conver del-other"}>
            <div className={own ? "user_chat_content right_users" : "user_chat_content"}>
              <div className="kjc-bubble-col">
                <div
                  className={`user_info_chat left_users kjc-bubble${first ? " is-first" : ""}${chat.messageType === "image" && !chat.isDeleted ? " has-image-message" : ""}${chat.isDeleted ? " is-deleted" : ""}`}
                  id={`chat-${chat.id}`}
                  onContextMenu={(e) => handleBubbleContextMenu(e, chat)}
                >
                  {canAct ? (
                    <MessageContextMenu
                      side={own ? "right" : "left"}
                      strings={strings}
                      labels={hoverLabels}
                      onReaction={canReactHere ? (e) => openEmojiPickerForChat(chat.id, e) : undefined}
                      onReply={chatDetails?.isLeave || (teamsCaps && (!teamsCaps.canReply || teamsInfo.canWrite === false)) ? undefined : () => handleReply(chat)}
                      onMore={(e) => {
                        const rect = e.currentTarget.getBoundingClientRect();
                        openMessageMenu(chat, { rect, alignEnd: own });
                      }}
                    />
                  ) : null}
                  {chat.isDeleted ? (
                    <span className="kjc-deleted">{strings.message_delete}</span>
                  ) : (
                    renderBubbleContent(chat, own, index, first)
                  )}
                  {showTrans ? (
                    <TranslationLine
                      translating={!!chat.translationPending}
                      showingOriginal={!!showOriginalMap[chat.id]}
                      langCode={chat.detectedMessageLanguage}
                      uiLanguage={translationLang}
                      onToggle={translated ? () => toggleShowOriginal(chat.id) : undefined}
                      labels={transLabels}
                    />
                  ) : null}
                  <MessageMeta
                    chat={teamsInfo ? teamsMetaRow(chat) : receiptsRef.current.apply(chat)}
                    showStatus={own && !isSelfChatConversation && (!teamsInfo || !!teamsMetaRow(chat).failedToSend || !!teamsMetaRow(chat).sending)}
                    onRetry={retryOutgoingMessage}
                    labels={teamsInfo ? teamsMetaLabels : metaLabels}
                  />
                  {teamsDelivery === "failed" && !chat.failedToSend ? (
                    <span className="kjc-teams-delivery is-failed">
                      {chat.teamsDeliveryMessage || strings.teams_send_failed || (isGerm ? "Nicht an Teams gesendet" : "Not sent to Teams")}
                    </span>
                  ) : null}
                </div>
                {reactions ? (
                  <EmojiReactionsDisplay
                    userEmoji={chat.userEmoji}
                    isOwn={own}
                    myId={user?.id}
                    groupId={props.chat?.id}
                    chatId={chat.id}
                    onToggle={readOnly || !canReactHere ? undefined : (hex, isMine) => toggleReactionChip(chat, hex, isMine)}
                    onShowReactions={getUserListForEmoji}
                    disabled={readOnly}
                    showReactionsLabel={tr("chat_reactions_who", "Rechtsklick: wer hat reagiert", "Right-click: who reacted")}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };

  // Quick reactions of the hover bar's picker: the same toggle as the menu.
  const reactToMessageId = (chatId, emojiData) => {
    const glyph = emojiData?.emoji || emojiData?.native || (typeof emojiData === "string" ? emojiData : null);
    const chat = threadList.find((m) => m && String(m.id) === String(chatId));
    if (chat && glyph) toggleReaction(chat, glyph);
    else handleEmojiReaction(emojiData, chatId);
  };

  const replyBarTitle = replyMessage
    ? isOwnMessage(replyMessage)
      ? `${tr("chat_reply_to", "Antwort an", "Reply to")} ${tr("chat_yourself", "dich selbst", "yourself")}`
      : `${tr("chat_reply_to", "Antwort an", "Reply to")} ${replyMessage.senderName || headerTitle}`
    : "";
  const replyLineLabels = {
    photo: tr("chat_photo", "Foto", "Photo"),
    video: strings.video || "Video",
    voice: strings.voice_message || (isGerm ? "Sprachnachricht" : "Voice message"),
    document: strings.document || (isGerm ? "Dokument" : "Document"),
    location: strings.location || (isGerm ? "Standort" : "Location"),
    contact: strings.contact || (isGerm ? "Kontakt" : "Contact"),
    poll: tr("chat_poll", "Umfrage", "Poll"),
  };
  const plainOf = (chat) => {
    const raw = chat?.message;
    if (typeof raw !== "string") return "";
    if (raw.startsWith("U2FsdGVkX1") && secretKey) {
      try {
        return decryptMessage(raw, secretKey) || "";
      } catch (_) {
        return "";
      }
    }
    return raw;
  };
  const composerHasText = !!(message && String(message).trim());

  // Removed viewByOwner - not applicable for one-on-one chats
  const viewByOwner = props.chat?.onlyView || false;
  return (
    <React.Suspense fallback={null}>
    <React.Fragment>
      {!viewInfo &&
        !mediaDoc &&
        !showContactSection &&
        !viewDoc && (
          <div
            className={`w-300 chat_text chat_box_main_div kjc-chat${isInternalAccent ? " kjc-internal" : ""}`}
            style={{
              position: "relative",
              height: isFullscreenMode ? "100%" : "calc(var(--app-height) - 55px)",
              maxHeight: "100%",
              width: '100%',
              maxWidth: '100%',
              minWidth: 0,
              minHeight: 0,
              display: "flex",
              flex: 1,
              flexDirection: "column",
              borderRadius: 0,
              marginLeft: 0,
              border: 'none',
              borderLeft: isFullscreenMode ? '1px solid #e0e0e0' : 'none',
              borderTop: isFullscreenMode ? '1px solid #e0e0e0' : 'none',
              overflow: 'hidden',
              boxSizing: 'border-box',
              flexShrink: 1
            }}
          >
            {/* Chat Loading Overlay - Hidden when coming from ToDo */}
            {false && showChatLoadingPopup && !props.isFromTodo && !deeplinkData?.fromTodo && (
              <div className="chat-loading-overlay">
                <div className="suggestion-loading-spinner">
                  <div className="spinner-ring"></div>
                  <div className="spinner-ring"></div>
                  <div className="spinner-ring"></div>
                </div>
                <p className="suggestion-loading-text" style={{ marginTop: "24px", marginBottom: 0 }}>
                  {strings?.loading_chat_message || (isGerm ? 'Lade Chat...' : 'Loading chat...')}
                </p>
              </div>
            )}

            <div className="kjc-header-slot">
              <ChatHeaderPro
                internal={isInternalAccent}
                showBack={shouldShowBackArrow}
                onBack={handleHeaderBack}
                avatar={headerAvatar}
                title={headerTitle}
                subline={headerSubline}
                sublineAccent={headerSublineAccent}
                bridgeLabel={teamsBridgeLabel(strings, chatDetails, props.chat)}
                loading={!hasChatDetails}
                onOpenInfo={hasChatDetails ? openChatInfo : undefined}
                calls={
                  teamsInfo
                    ? {
                        // Microsoft Teams chats: a Teams meeting link sent into the chat (startTeamsCall).
                        visible: hasChatDetails && !props.chat?.onlyView && teamsInfo.canWrite !== false,
                        onVideo: () => startTeamsCall(true),
                        onAudio: () => startTeamsCall(false),
                      }
                    : {
                        visible: hasChatDetails && !chatDetails.isLeave && !isSelfChatConversation && isVideoCallAllowed && !props.chat?.onlyView,
                        onVideo: () => _startJitsiCall(true),
                        onAudio: () => _startJitsiCall(false),
                      }
                }
                callSlot={
                  hasChatDetails && !chatDetails.isLeave && !isSelfChatConversation && isVideoCallAllowed && isCallRunning && !teamsInfo ? (
                    <div className="video-call-incoming">
                      <div className="video-call-action" onClick={() => JoinCall()}>
                        <MaterialIcon icon="check_circle" size={28} color="#4CAF50" />
                        <span className="video-call-action-label" style={{ color: "#4CAF50" }}>{strings.join_call}</span>
                      </div>
                      <div className="video-call-action" onClick={() => setIsCallRunning(false)}>
                        <MaterialIcon icon="cancel" size={28} color="#e53935" />
                        <span className="video-call-action-label" style={{ color: "#e53935" }}>{strings.reject}</span>
                      </div>
                    </div>
                  ) : null
                }
                onSearch={hasChatDetails ? openChatSearch : undefined}
                search={
                  searchView
                    ? {
                        value: searchDraft,
                        query: search,
                        onChange: (v) => setSearchDraft(v),
                        onSubmit: (v) => setSearch(String(v || "").trim()),
                        onClear: () => {
                          setSearchDraft("");
                          setSearch("");
                        },
                        onClose: closeChatSearch,
                        total: searchHits.length,
                        index: searchPos,
                        onOlder: () => stepSearch(1),
                        onNewer: () => stepSearch(-1),
                        olderDisabled: searchPos >= searchHits.length - 1,
                        newerDisabled: searchPos <= 0,
                        busy: historySearch.indexing || searchJumping,
                        jumping: searchJumping,
                      }
                    : null
                }
                selection={
                  forward && !props.chat?.onlyView
                    ? {
                        count: selectedCount,
                        onCancel: cancelForward,
                        onCopy: copySelection,
                        onForward: teamsHides(teamsInfo, "forwardOut") ? undefined : handleForwardMessage,
                        onDelete: deleteSelection,
                        canDelete: teamsInfo ? !props.chat?.onlyView && teamsSelectionDeletable(threadList, msgIds) : selectionDeletable,
                      }
                    : null
                }
                labels={headerLabels}
              />
              {stickyDay && !searchView ? <DayChip label={stickyDay} sticky /> : null}
            </div>
            {null}
            <div style={{ flex: "1 1 0", overflow: floatingAction ? "visible" : "hidden", display: "flex", flexDirection: "column", position: "relative", width: '100%', maxWidth: '100%', minHeight: 0, boxSizing: 'border-box', paddingTop: 60, paddingBottom: 60 }}>
              <Dropzone
                onDrop={onDrop}
                children={
                  <div
                    style={{ paddingBottom: 0, boxSizing: "content-box", flex: "1 1 0", display: "flex", flexDirection: "column", minHeight: 0 }}
                    className={`kjc-thread ${
                      forward
                        ? `bottom-bar chat-scroll forward-msg${hasSuggestionsVisible && shouldShowAutoSuggestions() ? ' has-suggestions' : ''}`
                        : delMessage
                          ? `bottom-bar chat-scroll delete_msg${hasSuggestionsVisible && shouldShowAutoSuggestions() ? ' has-suggestions' : ''}`
                          : sumTotalChatHistory(tempChatHistory) < 4
                            ? `bottom-bar chat-scroll-first${hasSuggestionsVisible && shouldShowAutoSuggestions() ? ' has-suggestions' : ''}`
                            : `bottom-bar chat-scroll${hasSuggestionsVisible && shouldShowAutoSuggestions() ? ' has-suggestions' : ''}`
                    }`}
                    id={`chat-scroll-view-${props.chat?.id}`}
                  >

                    {/* Bottom loader for newer messages - removed spinner, using smooth fade */}
                    {isLoadingBottom && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#fff",
                          zIndex: 1000,
                          position: "absolute",
                          bottom: -10,
                          width: "100%",
                          alignSelf: "center",
                          opacity: isLoadingBottom ? 1 : 0,
                          transition: 'opacity 0.3s ease',
                          pointerEvents: 'none' /* Allow scroll to pass through - scrolling should never stop */,
                        }}
                      >
                        <span style={{ fontSize: "14px", color: "#666" }}>
                          {tr("chat_loading_newer", "Neuere Nachrichten werden geladen …", "Loading newer messages…")}
                        </span>
                      </div>
                    )}
                    <div
                      className={isDesktop ? "chat-scroll-container" : "chat-scroll-container-mobile"}
                      ref={messagesEndRef}
                      id={`chat-sc-${props.chat?.id}`}
                      onScroll={debouncedScrollHandler}
                    >

                      {/* Skeleton loading placeholder - matches chat layout to prevent height shifts */}
                      {/* Hidden when coming from ToDo - ToDo has its own transition screen */}
                      {(isLoading || showSkeleton) && !isContentReady && !props.isFromTodo && !deeplinkData?.fromTodo && (
                        <div 
                          style={{ 
                            position: 'absolute',
                            inset: 0,
                            backgroundColor: 'var(--kjc-thread, #fff)',
                            zIndex: 10,
                            overflow: 'hidden',
                            display: 'flex',
                            flexDirection: 'column',
                            padding: '20px',
                            pointerEvents: 'none' /* Allow scroll to pass through - scrolling should never stop */
                          }}
                        >
                          <style>{`
                            @keyframes skeletonPulse {
                              0%, 100% { opacity: 0.4; }
                              50% { opacity: 0.7; }
                            }
                            .skeleton-item {
                              animation: skeletonPulse 1.5s ease-in-out infinite;
                            }
                          `}</style>
                          {/* Skeleton date separators and message bubbles */}
                          {[0, 1, 2].map((groupIndex) => (
                            <div key={groupIndex} style={{ marginBottom: 20 }}>
                              {/* Date separator skeleton */}
                              <div style={{ textAlign: 'center', marginBottom: 15 }}>
                                <div 
                                  className="skeleton-item"
                                  style={{ 
                                    display: 'inline-block',
                                    width: 80,
                                    height: 22,
                                    backgroundColor: 'var(--kjuup-bg)',
                                    borderRadius: 30,
                                    animationDelay: `${groupIndex * 0.1}s`
                                  }} 
                                />
                              </div>
                              {/* Message bubbles skeleton - alternating left/right */}
                              {[0, 1, 2, 3].map((msgIndex) => (
                                <div 
                                  key={msgIndex}
                                  style={{ 
                                    display: 'flex',
                                    justifyContent: msgIndex % 2 === 0 ? 'flex-start' : 'flex-end',
                                    marginBottom: 12
                                  }}
                                >
                                  <div 
                                    className="skeleton-item"
                                    style={{ 
                                      width: msgIndex % 3 === 0 ? 200 : msgIndex % 3 === 1 ? 150 : 180,
                                      height: msgIndex % 2 === 0 ? 45 : 35,
                                      backgroundColor: msgIndex % 2 === 0 ? '#f5f5f5' : '#fdf5ef',
                                      borderRadius: 12,
                                      animationDelay: `${(groupIndex * 0.1) + (msgIndex * 0.05)}s`
                                    }} 
                                  />
                                </div>
                              ))}
                            </div>
                          ))}
                        </div>
                      )}
                      {/* Content always rendered - prevents unmount/remount flicker */}
                      {/* Add no-animation class after initial load to prevent re-animation on page loads */}
                      <div 
                        className={`chat-messages-loaded ${isContentReady ? 'chat-content-smooth-appear' : ''} ${topPage > 1 || currentPage > 1 ? 'chat-no-animation' : ''}${threadSwapping ? ' is-swapping' : ''}`}
                      >
                      {/* Removed green turning wheel spinner - content loads smoothly via skeleton */}

                      {/* Top loading indicator — zero-height sticky wrapper, so showing/hiding it never
                          shifts the messages (a sticky box still takes its height in the flow). Stays up
                          for a whole search jump instead of blinking once per page. */}
                      {isLoadingTop && (
                        <div style={{
                          position: 'sticky',
                          top: 0,
                          zIndex: 5,
                          height: 0,
                          overflow: 'visible',
                          overflowAnchor: 'none',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'flex-start',
                          pointerEvents: 'none'
                        }}>
                          <span style={{
                            marginTop: 8,
                            flexShrink: 0,
                            fontSize: '12px',
                            color: '#999',
                            backgroundColor: 'rgba(255,255,255,0.9)',
                            borderRadius: 16,
                            padding: '4px 14px',
                            boxShadow: '0 1px 4px rgba(0,0,0,0.08)'
                          }}>{searchJumping
                            ? tr("chat_search_loading_to_hit", "Nachrichten bis zum Treffer werden geladen …", "Loading messages up to the result…")
                            : tr("chat_loading_older", "Ältere Nachrichten werden geladen …", "Loading older messages…")}</span>
                        </div>
                      )}

                      {/* Message list (mobile Pro rows) */}
                      {activeChatSections.map((section, sindex) => {
                        if (!section) return null;
                        // Stable key based on the date so new data does not re-render old sections
                        const sectionKey = section?.createdAt || `section-${sindex}`;
                        const items = section?.items || [];
                        return (
                          <div
                            key={sectionKey}
                            className={`chat-date-section ${section?.skipAnimation ? 'no-animation' : ''}`}
                          >
                            <DayChip label={section?.createdAt} />
                            {items.map((item, index) => renderMessageRow(item, index, items, sindex))}
                          </div>
                        );
                      })}
                      {peerTyping ? (
                        <TypingRow label={`${headerTitle} ${tr("chat_typing", "schreibt", "typing")}…`} />
                      ) : null}
                        {/* Scroll anchor - helps browser maintain scroll position when loading older messages */}
                        <div className="chat-scroll-anchor" />
                        </div>
                    </div>
                  </div>
                }
                err={strings.only_in_mobileL}
              />
            </div>
            {!chatDetails.isLeave && !props.chat?.onlyView && (
              <div
                className={'chat_input p-0'}
                style={{ position: 'absolute', bottom: 0, left: 0, right: 0, zIndex: 100, backgroundColor: '#fff' }}
              >
                {chatsHiddenMembers.map((member) => (
                  <div key={member.userId} className="chat-hidden-notice">
                    <span className="chat-hidden-notice-text">
                      {(strings.chats_hidden_member_notice ||
                        "{name} has hidden chats and can no longer be reached via chat in Kjuup.")
                        .replace(/\{name\}/g, member.userName || "")}
                    </span>
                  </div>
                ))}
                {/* Unavailability Notice - auto-hides after 5s */}
                {showUnavailBanner && (() => {
                  const otherUnavailable = unavailableMembers.filter(u => u.userId !== user?.id);
                  if (otherUnavailable.length === 0) return null;
                  return otherUnavailable.map((member) => {
                    const endDateStr = member.endDate ? new Date(member.endDate).toLocaleDateString() : '';
                    const displayMsg = member.message
                      ? member.message.replace(/\{endDate\}/g, endDateStr)
                      : '';
                    return (
                      <div key={member.userId} className="chat-unavailability-notice chat-unavailability-notice--fade">
                        <div className="chat-unavailability-notice-content">
                          <span className="chat-unavailability-notice-text">{displayMsg}</span>
                          {member.replacementUserId && member.replacementUserName && (
                            <span
                              className="chat-unavailability-replacement-link"
                              onClick={async (e) => {
                                e.stopPropagation();
                                try {
                                  const { data } = await callAPI('/group', {}, 'POST', {
                                    groupType: 'user', isOneToOne: true, users: [user?.id, member.replacementUserId],
                                  });
                                  if (data?.chat?.id) {
                                    const chat = data.chat;
                                    const replaceName = member.replacementUserName || chat.name || '';
                                    const targetUserId = member.replacementUserId;

                                    const currentMessages = store.getState().activityMessages || [];
                                    const existingEntry = currentMessages.find(m => {
                                      if (!m?.group?.isOneToOne) return false;
                                      if (m?.group?.users) {
                                        return m.group.users.some(u => (u.id || u) === targetUserId);
                                      }
                                      if (m?.senderId === targetUserId) return true;
                                      const nameMatch = m?.group?.name || m?.name || '';
                                      if (nameMatch && nameMatch === replaceName) return true;
                                      return false;
                                    });

                                    const resolvedId = existingEntry?.group?.id || chat.id;
                                    console.warn('[UrgentContact] chat.id:', chat.id, 'existingEntry group.id:', existingEntry?.group?.id, 'resolvedId:', resolvedId);

                                    const chatPayload = {
                                      ...chat, id: resolvedId, key: resolvedId,
                                      name: replaceName, isOpened: true, isOneToOne: true,
                                      avatar: chat.avatar || null,
                                    };

                                    const updatedMessages = currentMessages.map(m => ({
                                      ...m,
                                      isOpened: m === existingEntry,
                                    }));
                                    dispatch({ type: OPEN_PROJECTS, openProjects: [] });
                                    dispatch({ type: SET_ACTIVITY_MESSAGES, messages: updatedMessages });
                                    dispatch({ type: OPEN_CHATS, openChats: [chatPayload] });
                                    history.push('/messages');
                                  }
                                } catch (err) { console.error('Failed to open replacement DM:', err); }
                              }}
                            >
                              {strings.unavailability_contact_urgent} – <strong>{member.replacementUserName}</strong>
                            </span>
                          )}
                        </div>
                      </div>
                    );
                  });
                })()}
                {/* Scroll-to-latest (mobile Pro): floats above the composer, counts what came in meanwhile */}
                <ScrollToLatestButton
                  visible={showScrollFab}
                  count={awayNewCount}
                  label={tr("chat_scroll_latest", "Zur neuesten Nachricht", "Scroll to latest")}
                  onClick={() => {
                    setAwayNewCount(0);
                    scrollToBottom(props.chat?.id, "smooth");
                  }}
                />
                {/* Auto-suggestion chips - positioned above reply-left and input */}
                {!audioRecording && !forward && !props.chat?.onlyView && 
                 shouldShowAutoSuggestions() && isReplyInputFocused &&
                 (autoSuggestions.length > 0 || autoSuggestionsLoading) && !autoSuggestionsError && (
                  <div className="suggestions-container suggestions-fade-in"
                    onMouseDown={(e) => e.preventDefault()}
                  >
                    <div className="suggestions-wrapper">
                      <div className="suggestions-header">
                        <MaterialIcon icon="stars_2" size={14} color="#e066ed" />
                        <span>{strings.suggested_replies || 'Suggested Replies'}</span>
                      </div>
                      <div className="suggestions-chips">
                        <button
                          className="suggestion-chip"
                          onMouseDown={(e) => e.preventDefault()}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSuggestionPlaceholderClick(0);
                          }}
                          disabled={autoSuggestionsLoading && pendingSuggestionIndex !== null}
                        >
                          <span className="suggestion-text">{strings.positive_suggestion_placeholder || 'Positive'}</span>
                          <MaterialIcon icon="north_west" size={12} color="#e066ed" className="suggestion-arrow" />
                        </button>
                        <button
                          className="suggestion-chip"
                          onMouseDown={(e) => e.preventDefault()}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSuggestionPlaceholderClick(1);
                          }}
                          disabled={autoSuggestionsLoading && pendingSuggestionIndex !== null}
                        >
                          <span className="suggestion-text">{strings.neutral_suggestion_placeholder || 'Neutral'}</span>
                          <MaterialIcon icon="north_west" size={12} color="#e066ed" className="suggestion-arrow" />
                        </button>
                        <button
                          className="suggestion-chip"
                          onMouseDown={(e) => e.preventDefault()}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSuggestionPlaceholderClick(2);
                          }}
                          disabled={autoSuggestionsLoading && pendingSuggestionIndex !== null}
                        >
                          <span className="suggestion-text">{strings.negative_suggestion_placeholder || 'Negative'}</span>
                          <MaterialIcon icon="north_west" size={12} color="#e066ed" className="suggestion-arrow" />
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                {/* Mentions (rich editor; the plain input has its own list) */}
                {showSuggestions && (() => {
                  const filtered = mentionSuggestions.filter((mention) =>
                    mention.name?.toLowerCase().includes(mentionInput?.toLowerCase())
                  );
                  if (filtered.length === 0) return null;
                  return (
                    <div className="kjc-mentions">
                      {filtered.map((mention, i) => (
                        <div
                          key={mention.id}
                          className={`kjc-mentions__row${i === 0 ? " is-active" : ""}`}
                          onMouseDown={(e) => e.preventDefault()}
                          onClick={() => onMentionSelect(mention)}
                        >
                          <ChatAvatar
                            size={32}
                            kind={mention.type === "All" ? "group" : "person"}
                            name={mention.name}
                            src={mention.type !== "All" ? absMediaUrl(mention.avatar) : null}
                          />
                          <span className="kjc-mentions__text">
                            <span className="kjc-mentions__name">{mention.name}</span>
                          </span>
                        </div>
                      ))}
                    </div>
                  );
                })()}

                {/* "You blocked this contact · tap to unblock" (only for one-on-one chats) */}
                {chatDetails?.isBlock && chatDetails?.isOneToOne && !props.chat?.onlyView && (
                  <div
                    className="chat-blocked-notice kjc-blocked"
                    role="button"
                    tabIndex={0}
                    onClick={async () => {
                      try {
                        await $crud.confirm({
                          title: strings.unblock,
                          textContent: strings.unblocks || (isGerm ? "Möchtest du diesen Kontakt wirklich entblocken?" : "Are you sure you want to unblock this user?"),
                          options: {
                            ok: strings.unblock,
                            cancel: strings.cancel
                          }
                        });

                        const id = props.chat?.id;
                        const userId = chatDetails.otherUserId;
                        await callAPI(`/group/${id}/block`, {}, 'PUT', {
                          id: id,
                          user: userId
                        });

                        // Refresh chat details and messages
                        getDetails(props.chat?.id);
                        _getMessages(1, 'initial');

                        // Update Redux groups state to reflect unblock
                        const updatedGroups = groups.map(group => {
                          if (group.id === id) {
                            const updatedUsers = group.users.map(u => {
                              if (u.id === userId) {
                                return { ...u, isBlock: false };
                              }
                              return u;
                            });
                            return { ...group, users: updatedUsers };
                          }
                          return group;
                        });
                        dispatch({ type: GROUPS, groups: updatedGroups });

                        // No "you have unblocked" note in the thread (mobile); a toast confirms it.
                        $crud.notify({
                          type: "success",
                          message: strings.you_have_unblocked || strings.unblock
                        });
                      } catch (error) {
                        // cancelled
                      }
                    }}
                  >
                    <MaterialIcon icon="block" size={20} weight={400} />
                    <span className="kjc-blocked__text">{strings.bolcked_click_un_block}</span>
                  </div>
                )}

                {/* Loading popup when suggestion is clicked while still loading - rendered via portal to document.body */}
                {showSuggestionLoadingPopup && createPortal(
                  <div className="suggestion-loading-popup-overlay">
                    <div className="suggestion-loading-popup">
                      <div className="suggestion-loading-spinner">
                        <div className="spinner-ring"></div>
                        <div className="spinner-ring"></div>
                        <div className="spinner-ring"></div>
                      </div>
                      <p className="suggestion-loading-text">
                        {strings.suggestion_loading_message || 'Nur noch ein kurzer Moment. Dein Text wird individuell für dich vorbereitet.'}
                      </p>
                    </div>
                  </div>,
                  document.body
                )}

                {/* Edit / reply bar on top of the composer (mobile Pro) */}
                {editingChat && !audioRecording ? (
                  <ComposerContextBar
                    kind="edit"
                    title={tr("chat_edit_message", "Nachricht bearbeiten", "Edit message")}
                    text={replyPreviewLine(editingChat, getPlainMessageText(editingChat), replyLineLabels)}
                    onClose={cancelEditMessage}
                    closeLabel={strings.close || (isGerm ? "Schließen" : "Close")}
                  />
                ) : activeReply && replyMessage && !audioRecording && !forward ? (
                  <ComposerContextBar
                    kind="reply"
                    title={replyBarTitle}
                    text={replyPreviewLine(replyMessage, plainOf(replyMessage), replyLineLabels)}
                    onClose={cancelReply}
                    closeLabel={strings.close || (isGerm ? "Schließen" : "Close")}
                  />
                ) : null}

                {/* Microsoft Teams chat that cannot be written to: the reason (and Reconnect) instead of the composer */}
                {teamsInfo && teamsInfo.canWrite === false && !forward && !props.chat?.onlyView ? (
                  <div className="kjc-teams-readonly" role="status">
                    <span className="kjc-teams-readonly__text">{teamsReadOnlyText(teamsReadOnlyReason(teamsInfo), strings)}</span>
                    {teamsReadOnlyReason(teamsInfo) === "reconnect" ? (
                      <button
                        type="button"
                        className="kj-btn kj-btn--ghost kj-btn--sm"
                        onClick={() => history.push(TEAMS_SETTINGS_PATH)}
                      >
                        {strings.teams_reconnect_action || (isGerm ? "Erneut verbinden" : "Reconnect")}
                      </button>
                    ) : null}
                  </div>
                ) : null}
                {/* Composer: attach · pill (formatting toolbar, text, emoji) · send / voice */}
                {!audioRecording && !forward && !props.chat?.onlyView && !(teamsInfo && teamsInfo.canWrite === false) && (
                  <div className={`kjc-composer${editingChat || (activeReply && replyMessage) ? "" : " has-divider"} ${isInternalAccent ? 'chat-input-container-internal' : 'chat-input-container-external'}`}>
                    {!editingChat ? (
                      <button
                        type="button"
                        className="kj-btn kj-btn--icon kj-btn--lg kj-btn--neutral kjc-composer__attach"
                        onClick={() => {
                          flushComposerRef.current();
                          setFloatingAction(true);
                        }}
                        aria-label={tr("chat_attach", "Anhängen", "Attach")}
                        title={tr("chat_attach", "Anhängen", "Attach")}
                      >
                        <MaterialIcon icon="add" size={26} weight={300} />
                      </button>
                    ) : null}
                    <div
                      className={`kjc-composer__pill input_text_msg customInputBoxNew ${isInternalAccent ? 'internal-chat-input' : 'external-chat-input'}`}
                      onClick={(e) => {
                        if (!isComposerToolbarOpen) {
                          if (e.target === e.currentTarget || !e.target.closest('textarea')) {
                            const textarea = textRef.current;
                            if (textarea) {
                              textarea.focus();
                            }
                          }
                        } else {
                          const editor = richEditorRef.current;
                          if (editor && (e.target === e.currentTarget)) {
                            editor.focus();
                          }
                        }
                      }}
                    >
                      {isComposerToolbarOpen && (
                        <div className="chat-wysiwyg-toolbar">
                          <button type="button" className={`chat-wysiwyg-btn${activeFormats.bold ? ' active' : ''}`} title={tr("chat_format_bold", "Fett", "Bold")} onMouseDown={(e) => { e.preventDefault(); applyComposerFormat("bold"); setTimeout(updateActiveFormats, 0); }}><MaterialIcon icon="format_bold" size={18} /></button>
                          <button type="button" className={`chat-wysiwyg-btn${activeFormats.italic ? ' active' : ''}`} title={tr("chat_format_italic", "Kursiv", "Italic")} onMouseDown={(e) => { e.preventDefault(); applyComposerFormat("italic"); setTimeout(updateActiveFormats, 0); }}><MaterialIcon icon="format_italic" size={18} /></button>
                          <button type="button" className={`chat-wysiwyg-btn${activeFormats.underline ? ' active' : ''}`} title={tr("chat_format_underline", "Unterstrichen", "Underline")} onMouseDown={(e) => { e.preventDefault(); applyComposerFormat("underline"); setTimeout(updateActiveFormats, 0); }}><MaterialIcon icon="format_underlined" size={18} /></button>
                          <span className="chat-wysiwyg-separator" />
                          <button type="button" className={`chat-wysiwyg-btn${activeFormats.unordered ? ' active' : ''}`} title={tr("chat_format_bullets", "Aufzählung", "Bullet list")} onMouseDown={(e) => { e.preventDefault(); applyComposerFormat("unordered"); setTimeout(updateActiveFormats, 0); }}><MaterialIcon icon="format_list_bulleted" size={18} /></button>
                          <button type="button" className={`chat-wysiwyg-btn${activeFormats.ordered ? ' active' : ''}`} title={tr("chat_format_numbers", "Nummerierte Liste", "Numbered list")} onMouseDown={(e) => { e.preventDefault(); applyComposerFormat("ordered"); setTimeout(updateActiveFormats, 0); }}><MaterialIcon icon="format_list_numbered" size={18} /></button>
                        </div>
                      )}
                      <div className="kjc-composer__field">
                        {isComposerToolbarOpen ? (
                          <div
                            ref={richEditorRef}
                            className="chat-rich-editor kjc-composer__editor"
                            contentEditable
                            suppressContentEditableWarning
                            data-placeholder={tr("chat_message_placeholder", "Nachricht", "Message")}
                            onPaste={handlePaste}
                            onDrop={handleComposerDrop}
                            onFocus={() => { setIsReplyInputFocused(true); typingSenderRef.current.focus(); }}
                            onBlur={() => { typingSenderRef.current.blur(); setTimeout(() => setIsReplyInputFocused(false), 150); }}
                            onKeyDown={(e) => {
                              if (e.key === "Escape") {
                                if (editingChatRef.current) {
                                  e.preventDefault();
                                  cancelEditMessage();
                                  return;
                                }
                                if (activeReply) {
                                  e.preventDefault();
                                  cancelReply();
                                  return;
                                }
                              }
                              const outcome = handleComposerEnterKey(e, {
                                editor: richEditorRef.current,
                              });
                              if (outcome === "send") {
                                if (showSuggestions) {
                                  const filtered = mentionSuggestions.filter((mention) =>
                                    mention.name?.toLowerCase().includes(mentionInput?.toLowerCase())
                                  );
                                  if (filtered.length > 0) {
                                    onMentionSelect(filtered[0]);
                                    return;
                                  }
                                }
                                const chatId = props.chat?.id || props.chat?.key;
                                const md = getRichEditorContent();
                                if (md && md.trim()) sendMessage(chatId);
                              }
                            }}
                            onInput={() => {
                              const editor = richEditorRef.current;
                              syncComposerEmptiness(setMessage, editor?.innerText);
                              if (!editingChatRef.current && !isSelfChatConversation) {
                                typingSenderRef.current.typed(props.chat?.id || props.chat?.key, editor?.innerText);
                              }
                              const sel = window.getSelection();
                              if (sel && sel.rangeCount > 0 && editor) {
                                const range = sel.getRangeAt(0);
                                if (editor.contains(range.startContainer) && range.startContainer.nodeType === Node.TEXT_NODE) {
                                  const text = range.startContainer.textContent;
                                  const cursorPos = range.startOffset;
                                  const textBeforeCursor = text.substring(0, cursorPos);
                                  const atIdx = textBeforeCursor.lastIndexOf("@");
                                  if (atIdx >= 0) {
                                    const chBefore = atIdx > 0 ? textBeforeCursor[atIdx - 1] : null;
                                    if (atIdx === 0 || chBefore === " " || chBefore === "\n" || chBefore === "\xa0") {
                                      const query = textBeforeCursor.substring(atIdx + 1);
                                      if (query.length <= 50) {
                                        setMentionInput(query);
                                        setShowSuggestions(true);
                                        mentionCursorRef.current = { node: range.startContainer, offset: cursorPos, atIndex: atIdx };
                                        return;
                                      }
                                    }
                                  }
                                }
                              }
                              setShowSuggestions(false);
                            }}
                          />
                        ) : (
                          <Form.Group controlId="exampleForm.ControlInput1">
                            <MentionsInput
                              onPaste={handlePaste}
                              onDrop={handleComposerDrop}
                              className="mentions scrollable-mentions"
                              value={message}
                              placeholder={tr("chat_message_placeholder", "Nachricht", "Message")}
                              onFocus={() => { setIsReplyInputFocused(true); typingSenderRef.current.focus(); }}
                              onBlur={() => { typingSenderRef.current.blur(); setTimeout(() => setIsReplyInputFocused(false), 150); }}
                              onKeyDown={(e) => {
                                if (e.key === "Escape") {
                                  if (editingChatRef.current) {
                                    e.preventDefault();
                                    cancelEditMessage();
                                    return;
                                  }
                                  if (activeReply) {
                                    e.preventDefault();
                                    cancelReply();
                                    return;
                                  }
                                }
                                const textarea = textRef.current || e.target;
                                const outcome = handleComposerEnterKey(e, {
                                  textValue: textarea.value ?? message,
                                  selectionStart: textarea.selectionStart,
                                  onListReplace: (nextValue, nextCursor) => {
                                    saveComposerHistory(textarea.value ?? message);
                                    applyComposerState(nextValue, nextCursor, nextCursor);
                                  },
                                });
                                if (outcome === "send" && (textarea.value || message)) {
                                  const chatId = props.chat?.id || props.chat?.key;
                                  sendMessage(chatId);
                                }
                              }}
                              onChange={(e) => {
                                handleComposerChange(e);
                                if (!editingChatRef.current && !isSelfChatConversation) {
                                  typingSenderRef.current.typed(props.chat?.id || props.chat?.key, e?.target?.value);
                                }
                              }}
                              inputRef={textRef}
                              allowSuggestionsAboveCursor
                              forceSuggestionsAboveCursor
                              id={`text-area-${props.chat?.id}`}
                              suggestionsPortalHost={document.body}
                              style={{
                                control: {
                                  backgroundColor: 'transparent',
                                  fontSize: 14,
                                  fontWeight: 'normal',
                                  minHeight: 20,
                                },
                                highlighter: {
                                  padding: 0,
                                  border: 'none',
                                },
                                input: {
                                  padding: 0,
                                  border: 'none',
                                  outline: 'none',
                                },
                                suggestions: {
                                  zIndex: 99999,
                                  backgroundColor: '#fff',
                                  borderRadius: 14,
                                  boxShadow: '0 8px 24px rgba(23, 34, 46, 0.16)',
                                  list: {
                                    backgroundColor: '#fff',
                                    border: '1px solid #dce3ea',
                                    borderRadius: 14,
                                    maxHeight: 300,
                                    overflowY: 'auto',
                                  },
                                  item: {
                                    padding: '8px 12px',
                                    borderBottom: '1px solid #e6ebf0',
                                    cursor: 'pointer',
                                    '&focused': {
                                      backgroundColor: 'var(--kjuup-bg)',
                                    },
                                  },
                                },
                              }}
                            >
                              <Mention
                                markup={"@[__display__](__id__)"}
                                trigger="@"
                                data={mentionSuggestions}
                                displayTransform={(id, display) =>
                                  `@${display}`
                                }
                                renderSuggestion={renderUserSuggestion}
                              />
                            </MentionsInput>
                          </Form.Group>
                        )}
                      </div>
                      {!props?.project?.viewByOwner && (
                        <>
                          <button
                            type="button"
                            ref={ttop}
                            id={`my-anchor-element-${props.chat?.id}`}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              toggleEmojiPicker();
                            }}
                            className={`kj-btn kj-btn--icon kj-btn--neutral kjc-composer__emoji emoji-picker-trigger ${message ? 'has-message' : ''}${isInputEmojiOpen && !isInputEmojiClosing ? ' is-active' : ''}`}
                            aria-expanded={isInputEmojiOpen && !isInputEmojiClosing}
                            aria-label={tr("chat_emoji", "Emoji einfügen", "Insert emoji")}
                            title={tr("chat_emoji", "Emoji einfügen", "Insert emoji")}
                          >
                            <MaterialIcon icon="sentiment_satisfied" size={22} weight={300} />
                          </button>
                          <ComposerEmojiPicker
                            open={isInputEmojiOpen}
                            closing={isInputEmojiClosing}
                            anchorRef={ttop}
                            onSelect={(glyph) => userTyping(null, props.chat?.id, glyph)}
                            onClose={closeEmojiPicker}
                            isGerm={isGerm}
                            internal={isInternalAccent}
                          />
                        </>
                      )}
                    </div>
                    {composerHasText || editingChat || teamsHides(teamsInfo, "voiceMessage") ? (
                      <button
                        type="button"
                        className="kjc-round"
                        disabled={editSaving || (!composerHasText && !editingChat)}
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={(e) => {
                          e.preventDefault();
                          const chatId = props.chat?.id || props.chat?.key;
                          if (isComposerToolbarOpenRef.current && richEditorRef.current) {
                            const md = getRichEditorContent();
                            if (md && md.trim()) sendMessage(chatId, md);
                          } else {
                            sendMessage(chatId);
                          }
                        }}
                        aria-label={editingChat ? tr("chat_save_edit", "Speichern", "Save") : tr("chat_send", "Senden", "Send")}
                        title={editingChat ? tr("chat_save_edit", "Speichern", "Save") : tr("chat_send", "Senden", "Send")}
                      >
                        <MaterialIcon icon={editingChat ? "check" : "send"} size={22} weight={400} fill={1} />
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="kjc-round"
                        onClick={(e) => {
                          e.preventDefault();
                          start();
                        }}
                        aria-label={tr("chat_record_voice", "Sprachnachricht aufnehmen", "Record voice message")}
                        title={tr("chat_record_voice", "Sprachnachricht aufnehmen", "Record voice message")}
                      >
                        <MaterialIcon icon="mic" size={22} weight={400} fill={1} />
                      </button>
                    )}
                  </div>
                )}
                {!props.chat?.onlyView && (
                  <AudioReactRecorder
                    ref={el => { if (el) el.tested = true; }}
                    style={{ height: 0 }}
                    canvasHeight={0}
                    canvasWidth={0}
                    state={recordState}
                    onStop={(audioData) =>
                      stopRecording(audioData, props.chat?.id)
                    }
                  />
                )}
                {audioRecording && !props.chat?.onlyView && (
                  <RecordingBar
                    seconds={recordingCounter}
                    onCancel={() => { setRecordState(RecordState.STOP); setAudioRecording(false); }}
                    onSend={stop}
                    cancelLabel={tr("chat_recording_delete", "Aufnahme löschen", "Delete recording")}
                    sendLabel={tr("chat_send_voice", "Sprachnachricht senden", "Send voice message")}
                  />
                )}
              </div>
            )}
            <div>
              {viewEmojiModal ? (
                <div className="emoji-reaction-overlay">
                  <EmojiReaction
                    userList={emojiReactionUser}
                    handleRemoveReaction={handleRemoveReaction}
                    handleClose={() => {
                      setEmojiReactionUser([]);
                      setViewEmojiModal(false);
                    }}
                    isInternal={isInternalAccent}
                  />
                </div>
              ) : <></>}

              {openEmojiPicker && (
                <EmojiPickerDialog
                  handleClose={() => setEmojiPicker(false)}
                  setMessage={setMessage}
                  sendMessage={sendMessage}
                />
              )}
              {showTranslateDialog && (
                <TranslateDialog
                  handleTranslateMessage={(chatMessage) =>
                    handleTranslateMessage(chatMessage, props.chat?.id)
                  }
                  handleClose={() => {
                    setTranslateDialog(false);
                  }}
                  chat={chatMessage}
                  secretKey={secretKey}
                />
              )}
              {viewLoader && (
                <div className="website_loader">
                  <div className="loader" />
                </div>
              )}
            </div>
            {floatingAction && (
              <FloatingAction
                sendDocFile={sendDocFile}
                sendDocFiles={sendDocFiles}
                sendVideoMessage={sendVideoMessage}
                showContactPage={() => {
                  setShowContactSection(true);
                  setFloatingAction(false);
                }}
                showLocationDialog={teamsHides(teamsInfo, "location") ? undefined : showLocationDialog}
                sendImageMessage={sendImageMessage}
                handleClose={() => {
                  setFloatingAction(false);
                  setDropFiles(null);
                }}
                chat={props.chat}
                chatDetails={chatDetails}
                setParam={() => { }}
                dropfiles={dropfiles}
                isInternal={isInternalAccent}
                messagePaar={message}
                userTyping={(e) => userTyping(e, props.chat?.id)}
                onBlur={(e) => setText(e)}
                mentionSuggestions={mentionSuggestions}
              />
            )}
            {props.ViewerImages && props.ViewerImages.length > 0 && (
              <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, zIndex: 1000 }}>
                <FullScreenImageViewer reduxImages={props.ViewerImages} />
              </div>
            )}
          </div>
        )}
      {/* Message info: a sheet over the chat (mobile ProMsgInfoSheet) */}
      {showMessageInfo && chatMessage ? (
        <MessageInfoSheet
          chatMessage={chatMessage}
          isGroup={false}
          isInternal={isInternalAccent}
          peer={{ name: chatDetails?.otherUserName || headerTitle, src: headerAvatar.src || null }}
          handleClose={() => {
            setMessageInfo(false);
            setChatMessage("");
          }}
        />
      ) : null}
      {/* "Mark as task" in a chat without a project: pick the project first */}
      <BookmarkProjectSheet
        open={!!taskProjectFor}
        onPick={(room) => {
          const chat = taskProjectFor;
          setTaskProjectFor(null);
          if (chat) handleCreateTodo(chat, room.id);
        }}
        onClose={() => setTaskProjectFor(null)}
      />
      {/* Message menu (right-click / "more" of the hover bar) */}
      <MessageMenuPro
        open={!!messageMenu}
        anchor={messageMenu?.anchor}
        rows={messageMenu ? menuRowsFor(messageMenu.chat) : []}
        reactions={
          messageMenu && !props.chat?.onlyView && !messageMenu.chat?.isDeleted && (!teamsInfo || canReactToRow({ ...messageMenu.chat, isTeams: true }))
            ? { onReact: (glyph) => toggleReaction(messageMenu.chat, glyph) }
            : null
        }
        myReactions={(messageMenu?.chat?.userEmoji || [])
          .filter((r) => r && String(r.sender) === String(user?.id))
          .map((r) => String(r.emoji))}
        onClose={closeMessageMenu}
        internal={isInternalAccent}
        isGerm={isGerm}
        labels={{ moreReactions: tr("chat_more_reactions", "Weitere Reaktionen", "More reactions") }}
      />
      {/* Removed AddProjectUser and AddProjectChatUser - not needed for one-on-one chats */}
      {viewInfo && !mediaDoc && teamsInfo && (
        <div style={{
          height: isFullscreenMode ? "calc(var(--app-height) - 15px)" : "calc(var(--app-height) - 55px)",
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          borderLeft: isFullscreenMode ? '1px solid #e0e0e0' : 'none'
        }}>
          <TeamsChatInfo
            chat={props.chat}
            teams={teamsInfo}
            title={headerTitle}
            members={chatDetails?.users || []}
            isInternal={isInternalAccent}
            project={teamsProject}
            onProjectChange={props.chat?.onlyView ? undefined : (p) => setTeamsProjectOverride(p || null)}
            onClose={() => setViewInfo(false)}
            onSearch={() => {
              setViewInfo(false);
              openChatSearch();
            }}
            onMedia={() => setMediaDoc(true)}
          />
        </div>
      )}
      {viewInfo && !mediaDoc && !teamsInfo && (
        <div style={{
          height: isFullscreenMode ? "calc(var(--app-height) - 15px)" : "calc(var(--app-height) - 55px)",
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          borderLeft: isFullscreenMode ? '1px solid #e0e0e0' : 'none'
        }}>
          <UserInfo
            isEmailAllowed={isEmailAllowed}
            setSearch={() => {
              setViewInfo(false);
              openChatSearch();
            }}
            viewSearch={() => {
              setViewInfo(false);
              openChatSearch();
            }}
            viewMediaDoc={() => setMediaDoc(true)}
            handleClose={() => {
              setViewInfo(false);
              // Reload chat details to update block status
              getDetails(props.chat?.id);
              // Refresh chat messages to update block/unblock notes
              _getMessages(1, 'initial');
              setTimeout(() => {
                scrollToBottom(props.chat?.id, 'auto');
              }, 100);
            }}
            chatDetails={chatDetails}
            chat={props.chat}
            isInternal={isInternalAccent}
            isGp={false}
            users={users}
            viewByOwner={props.chat?.onlyView || false}
            fromActivity={props.fromActivity}
            hideGroup={() => { hideProject(props.chat?.id || props.chat?.key) }}
            isFullscreenMode={isFullscreenMode}
            unavailableMembers={unavailableMembers}
          />
        </div>
      )}

      {mediaDoc && (
        <div style={{
          height: isFullscreenMode ? "calc(var(--app-height) - 15px)" : "calc(var(--app-height) - 55px)",
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          borderLeft: isFullscreenMode ? '1px solid #e0e0e0' : 'none'
        }}>
          <MediaLinksDocs
            closeMediaDoc={() => setMediaDoc(false)}
            chatHistory={chatHistory}
            chat={props.chat}
            isInternal={isInternalAccent}
            viewByOwner={viewByOwner}
            viewByCompanyOwner={viewByOwner}
          />
        </div>
      )}

      {viewDoc && (
        <div style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0, width: "100%" }}>
          <DocViewer
            isInternal={isInternalAccent}
            chat={doc}
            handleClose={() => setViewDoc(false)}
          />
        </div>
      )}
      {show && (
        <ChatShareMap
          sendMapMessage={(message) => sendMapMessage(message, props.chat?.id)}
          chat={props.chat}
          show={show}
          handleClose={hideLocationDialog}
        />
      )}
      {showContactSection && (
        <ShareContact
          sendCont={(dadad) => {
            _sendContact(dadad);
          }}
          chat={props.chat}
          handleClose={() => setShowContactSection(false)}
        />
      )}
      <Modal
        className="profile_image"
        show={showImage}
        onHide={() => {
          setImage("");
          setShowImage(false);
        }}
        centered
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <div className="profile_pic_profile">
            <img
              className="chat-image-preview"
              src={image}
              alt="Generic placeholder"
            />
          </div>
        </Modal.Body>
      </Modal>
      {/* Pre-loaded emoji picker for instant display */}
      <PreloadedEmojiPicker
        isOpen={activeEmojiChatId !== null}
        onClose={closePreloadedEmojiPicker}
        onEmojiClick={(e) => reactToMessageId(activeEmojiChatId, e)}
        onReactionClick={(e) => reactToMessageId(activeEmojiChatId, e)}
        triggerElement={emojiTriggerElement}
        isGerm={isGerm}
        internal={isInternalAccent}
        myReactions={(threadList.find((m) => m && String(m.id) === String(activeEmojiChatId))?.userEmoji || [])
          .filter((r) => r && String(r.sender) === String(user?.id))
          .map((r) => String(r.emoji))}
        labels={{
          addReaction: tr("add_reaction", "Reaktion hinzufügen", "Add reaction"),
          moreReactions: tr("chat_more_reactions", "Weitere Reaktionen", "More reactions"),
        }}
      />

      {/* ToDo Creating Loader */}
      {showTodoCreatingLoader && (
        <div className="todo-creating-overlay">
          <div className="todo-creating-popup" style={{ minWidth: 320 }}>
            {/* Step indicators */}
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center', 
              gap: 6, 
              marginBottom: 24 
            }}>
              {/* Step 1 indicator */}
              <div style={{
                width: 28,
                height: 28,
                borderRadius: '50%',
                backgroundColor: todoCreatingStep >= 1 ? 'var(--kjuup-accent)' : '#e0e0e0',
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 12,
                fontWeight: 600,
                transition: 'background-color 0.3s ease'
              }}>
                {todoCreatingStep > 1 ? '✓' : '1'}
              </div>
              {/* Connector line 1-2 */}
              <div style={{
                width: 32,
                height: 3,
                backgroundColor: todoCreatingStep >= 2 ? 'var(--kjuup-accent)' : '#e0e0e0',
                borderRadius: 2,
                transition: 'background-color 0.3s ease'
              }} />
              {/* Step 2 indicator */}
              <div style={{
                width: 28,
                height: 28,
                borderRadius: '50%',
                backgroundColor: todoCreatingStep >= 2 ? 'var(--kjuup-accent)' : '#e0e0e0',
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 12,
                fontWeight: 600,
                transition: 'background-color 0.3s ease'
              }}>
                {todoCreatingStep > 2 ? '✓' : '2'}
              </div>
              {/* Connector line 2-3 */}
              <div style={{
                width: 32,
                height: 3,
                backgroundColor: todoCreatingStep >= 3 ? 'var(--kjuup-accent)' : '#e0e0e0',
                borderRadius: 2,
                transition: 'background-color 0.3s ease'
              }} />
              {/* Step 3 indicator */}
              <div style={{
                width: 28,
                height: 28,
                borderRadius: '50%',
                backgroundColor: todoCreatingStep >= 3 ? 'var(--kjuup-accent)' : '#e0e0e0',
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 12,
                fontWeight: 600,
                transition: 'background-color 0.3s ease'
              }}>
                3
              </div>
            </div>
            {/* Step labels */}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: 20,
              gap: 4,
            }}>
              <span style={{ fontSize: "var(--kjuup-type-caption)", color: todoCreatingStep >= 1 ? 'var(--kjuup-accent)' : '#aaa', fontWeight: todoCreatingStep === 1 ? 600 : 400, textAlign: 'center', flex: 1, transition: 'color 0.3s ease' }}>
                {strings.extracting_message || (isGerm ? 'Nachricht extrahieren' : 'Extracting message')}
              </span>
              <span style={{ fontSize: "var(--kjuup-type-caption)", color: todoCreatingStep >= 2 ? 'var(--kjuup-accent)' : '#aaa', fontWeight: todoCreatingStep === 2 ? 600 : 400, textAlign: 'center', flex: 1, transition: 'color 0.3s ease' }}>
                {strings.creating_todo || (isGerm ? 'Aufgabe erstellen' : 'Creating ToDo')}
              </span>
              <span style={{ fontSize: "var(--kjuup-type-caption)", color: todoCreatingStep >= 3 ? 'var(--kjuup-accent)' : '#aaa', fontWeight: todoCreatingStep === 3 ? 600 : 400, textAlign: 'center', flex: 1, transition: 'color 0.3s ease' }}>
                {strings.navigating_to_todo || (isGerm ? 'Zu Aufgaben navigieren' : 'Navigating to ToDo')}
              </span>
            </div>
            
            <div className="todo-creating-spinner-container">
              <div className="spinner-ring"></div>
              <div className="spinner-ring"></div>
              <div className="spinner-ring"></div>
            </div>
            <p className="todo-creating-text">
              {todoCreatingStep === 1 
                ? (strings.extracting_message || (isGerm ? 'Nachricht wird extrahiert...' : 'Extracting message...'))
                : todoCreatingStep === 2
                  ? (strings.creating_todo || (isGerm ? 'Aufgabe wird erstellt...' : 'Creating ToDo...'))
                  : (strings.navigating_to_todo || (isGerm ? 'Weiterleitung zu Aufgaben...' : 'Navigating to ToDo...'))
              }
            </p>
          </div>
        </div>
      )}
      {showForwardPicker && createPortal(
        <ForwardChatPicker
          msgIds={msgIds}
          albums={forwardAlbumsRef.current}
          hidden={!forwardPickerVisible}
          originGroupId={props.chat?.id || props.chat?.key}
          onClose={() => {
            setShowForwardPicker(false);
            setForwardPickerVisible(true);
            setForward(false);
            msgIdsRef.current = [];
            forwardAlbumsRef.current = [];
            setMsgIds([]);
          }}
          onSelectMore={() => {
            ignoreChatClicksUntil.current = Date.now() + 400;
            setForwardPickerVisible(false);
            setForward(true);
          }}
          onForwarded={() => {
            setShowForwardPicker(false);
            setForwardPickerVisible(true);
            setForward(false);
            msgIdsRef.current = [];
            forwardAlbumsRef.current = [];
            setMsgIds([]);
          }}
        />,
        document.body
      )}
    </React.Fragment>
    </React.Suspense>
  );
}

const mapStateToProps = (state) => {
  const {
    openChats,
    groups,
    updateGroupMessage,
    language,
    groupChats,
    forwardGroupMessages,
    draftMessages,
    updateProjectActionFire,
    ViewerImages,
  } = state;
  return {
    groups: groups,
    language: language,
    openChats: openChats,
    updateGroupMessage: updateGroupMessage,
    groupChats: groupChats,
    forwardGroupMessages: forwardGroupMessages,
    draftMessages: draftMessages,
    updateProjectActionFire: updateProjectActionFire,
    ViewerImages: ViewerImages,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    updateGroups: (groups) => dispatch({ type: GROUPS, groups: groups }),
    updateProjects: (projects) =>
      dispatch({ type: PROJECTS, projects: projects }),
    updateOpenChats: (chats) =>
      dispatch({ type: OPEN_CHATS, openChats: chats }),
    updateOpenChatsList: (chats) =>
      dispatch({ type: OPEN_CHATS, openChats: chats }),
    updateLastMessage: (msg) =>
      dispatch({ type: UPDATE_GROUP_MESSAGE, updateGroupMessage: msg }),
    updateGroupChats: (chats) =>
      dispatch({ type: GROUP_CHATS, groupChats: chats }),
    updateForwardGroupMessage: (groupMessages) =>
      dispatch({
        type: FORWARD_GROUP_MESSAGES,
        forwardGroupMessages: groupMessages,
      }),
    updateDraftMessages: (msg) =>
      dispatch({ type: DRAFT_MESSAGES, draftMessages: msg }),
    updateAllBadgeCount: (count) =>
      dispatch({ type: ALL_BADGE_COUNT, unSeenAllCount: count }),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(memo(Conversation)));

